/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/naming-convention */
import { ResourceLanguage } from 'i18next';
import { MRT_Localization_DE } from 'material-react-table/locales/de';
import { ATLunchDayListElementDTOPlaceEnum, ATLunchLineErrorDTOLineErrorsEnum } from 'probonio-shared-ui/api';

const translation: ResourceLanguage = {
  authModule: {
    errorMessage: 'Es ist ein Fehler aufgetreten. Bitte neu anmelden.',
    processingLogin: {
      title: 'Anmeldung läuft',
      text: 'Die Anmeldung wird verarbeitet, bitte warten...',
    },
    registrationExpired: {
      title: 'Registrierungslink abgelaufen',
      text: 'Dein Registrierungslink ist leider abgelaufen. Dein Arbeitgeber kann in der Nutzerverwaltung eine neue Einladungsmail generieren und versenden.',
    },
    socialLoginError: {
      title: 'Anmeldemethode nicht verknüpft',
      text: 'Die gewählte Anmeldemethode ist keinem Probonio-Konto zugeordnet. Bitte verwenden Sie die Anmeldemethode, mit der Ihr Konto erstellt wurde, oder wenden Sie sich an den Probonio-Support.',
    },
  },
  departmentModule: {
    all: 'Alle',
  },
  errorModule: {
    defaultMessage: 'Es ist ein Fehler aufgetreten.',
    forbiddenMessage: 'Fehlende Berechtigung',
    wafBlockedMessage: 'Ihre Anfrage wurde blockiert. Bitte versuchen Sie es erneut.',
    wafCountryBlockedMessage: 'Der Zugriff aus Ihrem Land ist nicht verfügbar.',
    causeId: 'Cause-ID:',
    form: {
      min: 'Wert muss größer oder gleich {{value}} sein',
      max: 'Wert muss kleiner oder gleich {{value}} sein',
      pattern: 'Bitte richtigen Datentyp eingeben',
      positive: 'Wert muss größer null sein',
      required: 'Wert wird benötigt',
    },
    goHome: 'Zurück zum Dashboard',
    unhandled: {
      headlineLarge: 'Oh nein...',
      headlineSmall: 'Technischer Fehler',
      message: 'Es ist ein technischer Fehler aufgetreten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.',
    },
    notFound: {
      headlineLarge: '404',
      headlineSmall: 'Es ist ein Fehler aufgetreten.',
      message: 'Bitte überprüfen Sie die eingegebene URL, oder folgen Sie uns zurück zur Startseite.',
    },
    unauthorized: {
      headlineLarge: '403',
      headlineSmall: 'Sie haben keinen Zugriff auf diese Ressource',
      message: 'Bitte überprüfen Sie ihre Zugangsdaten.',
    },
    pageSizeToTiny: {
      header: 'Mobile Ansicht nicht unterstützt',
      text: 'Das Arbeitgeber-Portal unterstützt aktuell keine mobile Ansicht. Bitte verwenden Sie einen Laptop/Desktop um das Portal zu verwenden',
      button: 'Zur Mitarbeiter-App',
    },
    incompleteProfile: {
      header: 'Profil vervollständigen',
      text: 'Um Probonio nutzen zu können, müssen Sie zunächst Ihr Profil vervollständigen. Bitte ergänzen Sie die fehlenden Angaben, um fortzufahren.',
      button: 'Profil vervollständigen',
    },
    accountMerged: {
      header: 'Ihr Login hat sich geändert',
      text: 'Bikeleasing und Probonio sind jetzt vereint. Ihr Probonio-Konto wurde mit Ihrem Bikeleasing-Account zusammengeführt.<br/><br/>Sie können nun alle Benefits mit diesem Konto verwalten. Bitte melden Sie sich ab und loggen Sie sich mit Ihrer Bikeleasing-E-Mail erneut ein.',
      button: 'Zum Login',
    },
    wrongPreferredPortal: {
      header: 'Dieses Portal ist für Ihr Unternehmen nicht aktiviert',
      text: 'Dieses Portal ist für Ihr Unternehmen nicht aktiviert. Ihr Unternehmen nutzt derzeit das Bikeleasing Portal zur Benefitverwaltung. Wenn Sie das ändern möchten, kontaktieren Sie bitte das Bikeleasing Support Team.',
      button: 'Zum Bikeleasing Portal',
    },
  },
  maintenanceModeModule: {
    maintenancePage: {
      headlineLarge: 'Wartungsmodus aktiv',
      headlineSmall: 'Das Arbeitgeber-Portal wird aktuell gewartet. Bitte versuchen Sie es später erneut.',
      message: '',
    },
  },
  navigationModule: {
    brand: 'Probonio',
    title: 'Arbeitgeber-Portal',
    titleFull: 'Probonio Arbeitgeber-Portal',
    login: 'Login',
    logout: 'Logout',
    linkToApp: 'Zur Mitarbeiter-App',
    manual: 'Helpcenter anzeigen',
    home: 'Dashboard',
    toHome: 'Zum Dashboard',
    openDrawerMenu: 'Menü anzeigen',
    closeDrawerMenu: 'Menü schließen',
    referralCode: {
      dialogTitle: 'Probonio weiterempfehlen',
      dialogDescription: 'Empfehlen Sie Probonio jetzt an Freunde oder Verwandte weiter und erhalten Sie:',
      code: 'Empfehlungscode',
      howItWorks: 'Wie es funktioniert',
      bonusOneTitle: '50€ Gutschein',
      bonusOneDesc: 'Für Sie',
      bonusTwoTitle: '30% Rabatt',
      bonusTwoDesc: 'Für das neue Unternehmen in den ersten 3 Monaten',
      dialogHowTo: 'Geben Sie dazu einfach diesen Code weiter:',
      dialogFooter: '* Gilt nur für Unternehmen mit mindestens 10 Mitarbeitern',
    },
    unsupportedBrowserModal: {
      buttonTitle: 'Bitte aktualisiere deinen Browser',
      buttonSubTitle: 'Wir bitten dich, diesen zu aktualisieren da ansonsten unerwartete Fehler auftreten können',
      dialogTitle: 'Browser nicht unterstützt',
      description_one: 'Leider wird deine Browserversion nicht mehr unterstützt wodurch unerwartete Fehler auftreten können.',
      description_two: 'Wir bitten dich, deine Browserversion zu aktualisieren.',
      actions: {
        noReopen: 'Nicht mehr anzeigen',
        close: 'Schließen',
      },
    },
    userEdit: {
      dialogTitle: 'Einstellungen',
      title: 'Titel',
      salutation: { title: 'Anrede', MR: 'Herr', MS: 'Frau', DIVERS: 'Divers', COMPANY: 'Firma', notSet: 'Keine Angabe' },
      success: 'Änderungen gespeichert!',
      error: 'Speichern der Änderungen fehlgeschlagen!',
      firstName: 'Vorname',
      lastName: 'Nachname',
      mail: 'E-Mail',
      locale: 'Sprache',
      localeSwitch: {
        en: 'Englisch',
        de: 'Deutsch',
      },
    },
    missingEmployeeInformation: {
      title: 'Fast geschafft!',
      description: 'Trage noch kurz deine persönlichen Daten ein.',
    },
    changeTenantDialog: {
      title: 'Unternehmen wechseln',
      text: 'Wählen Sie das gewünschte Unternehmen aus, um das Arbeitgeber-Portal für dieses Unternehmen zu öffnen.',
      select: 'Unternehmen',
      submit: 'Wechseln',
      myCompanies: 'Meine Unternehmen',
      otherCompanies: 'Andere',
      searchPlaceholder: 'Tenant suchen...',
      searchResultCount: '{{from}}–{{to}} von {{total}} Treffern',
      previousPage: 'Vorherige Seite',
      nextPage: 'Nächste Seite',
      linkedTenantNotAccessible: 'Das verlinkte Unternehmen konnte nicht geöffnet werden.',
    },
    menuHeader: {
      overview: 'Übersicht',
      employees: 'Mitarbeiter',
      benefits: 'Benefits',
      customBenefits: 'Eigene Benefits',
      lunch: 'Essenszuschuss',
      application: 'Portal',
      discountCode: 'Mitarbeiterrabatte',
    },
    menuItem: {
      manageEmployees: 'Mitarbeiterstammdaten',
      manageBenefits: 'Benefits verwalten',
      exploreBenefits: 'Neue Benefits finden',
      reviewReceipts: 'Auswertung',
      siteNotice: 'Impressum',
      dataPrivacy: 'Datenschutz',
      gdprInformation: 'Informationspflichten nach DSGVO',
      tenantSettings: 'Einstellungen',
      manual: 'Helpcenter anzeigen',
      account: 'Kontoeinstellungen',
      referral: 'Probonio weiterempfehlen',
      userProfile: 'Mein Profil',
      contactSupport: 'Support anfragen',
    },
    appearance: {
      label: 'Darstellung',
      light: 'Hell',
      dark: 'Dunkel',
      system: 'System',
    },
    badgeLabel: {
      new: 'Neu',
    },
  },
  firstLoginModule: {
    title: 'Willkommen im Arbeitgeber-Portal von Probonio',
    textIntroduction:
      'Unser Arbeitgeber-Portal vereint alle wichtigen Funktionen in nur einem Tool und sorgt dafür, dass Sie Ihre Benefits einfach und effektiv verwalten und jederzeit anpassen können.',
    textHandbook:
      'Damit Sie Ihr Arbeitgeber-Portal vollumfänglich nutzen und direkt starten können, haben wir für Sie ein Probonio-Nutzer HelpCenter erstellt. In diesem finden Sie Informationen und Tipps dazu, wie Sie:',
    listSettings: 'Einstellungen verwalten',
    createEmployees: 'Mitarbeitende anlegen',
    modifyBenefits: 'Benefits individuell an Ihre Wünsche anpassen',
    handBookButton: 'HelpCenter öffnen',
    support: 'Sollten Sie weitere Fragen haben, kontaktieren Sie uns – Wir unterstützen Sie gerne!',
    team: 'Ihr Probonio-Team',
    doNotShowAgain: 'Nicht erneut anzeigen',
    close: 'Zum Arbeitgeber-Portal',
  },
  filterModule: {
    department: 'Abteilung',
    costCenter: 'Kostenstelle',
    workLocations: 'Arbeitsstätte',
    all: 'Alle',
  },
  usersModule: {
    title: 'Stammdaten',
    createNewUser: 'Neue Mitarbeiter anlegen',
    createNewUserFields: {
      lead: 'Sie können Ihre Mitarbeiter auch über einen Registrierungslink einladen. Mitarbeiter, welche sich über diesen Link registrieren erscheinen im Arbeitgeber-Portal.',
      putEmail: 'Bitte geben Sie eine oder mehrere E-Mail-Adressen ein.',
      helperEmail:
        'Sie können aus beliebigen Quellen (z.B. Word, Excel, PDF) E-Mail-Adressen direkt hochladen. Markieren Sie hierfür Ihr gesamtes Dokument (STRG + A), kopieren Sie die Auswahl (STRG + C) und fügen Sie die Auswahl in dem unteren Feld ein (STRG + V).',
      emailAddress: 'E-Mail-Adressen',
      duplicatedMails: 'Eine oder mehrere E-Mail-Adressen existieren bereits im System:',
      notValidMail: 'Bitte ungültige E-Mails entfernen!',
      notMoreThanThree: 'Bitte nicht mehr als drei E-Mail-Adressen eingeben!',
      inviteButton: 'Einladen',
      createButton: 'Anlegen',
      sendMail: 'Mitarbeiter sofort einladen',
      sendMailTooltip:
        'Wir empfehlen, die Einladung erst zu versenden, wenn alle Benefits eingerichtet sind. Sonst sind in der Mitarbeiter-App zunächst keine Benefits sichtbar. <0>Details</0>',
      inviteByCode: 'Mitarbeiter über Registrierungscode einladen',
      registrationCode: 'Registrierungscode',
      codeHelper: 'Alternativ können Ihre Mitarbeiter bei der Registrierung diesen Code eingeben',
      registrationLink: 'Registrierungslink',
      linkHelper: 'Kopieren Sie einfach diesen Link und senden Sie ihn an Ihre Mitarbeiter',
      orDivider: 'oder',
      codeChange: 'Registrierungscode ändern',
      codeWarning: 'Achtung! Der bisherige Registrierungscode wird dadurch ungültig und kann nicht mehr verwendet werden!',
      codeChangeConfirm: 'Ich möchte den Registrierungscode trotzdem ändern',
      template: 'Vorlage für Benefit-Konfiguration',
      templateHelper:
        'Optional können Sie allen neuen Mitarbeitern eine vordefinierte Benefit-Konfiguration zuweisen. Wählen Sie dafür hier eine Vorlage aus.',
      accountServiceErrors: {
        emailAlreadyExists: 'Diese E-Mail-Adresse wird bereits von einem anderen Mitarbeiter verwendet.',
        parentCompanyNotFound: 'Ihr Unternehmen konnte nicht zugeordnet werden. Bitte wenden Sie sich an den Support.',
        parentCompanyDeleted: 'Ihr Unternehmen konnte nicht zugeordnet werden. Bitte wenden Sie sich an den Support.',
      },
    },
    profile: 'PROFIL',
    success: 'Erfolgreich eingeladen',
    userDetails: 'Mitarbeiter: {{name}}',
    userMenu: {
      settings: 'Profil Einstellungen',
      editSettings: 'Profil bearbeiten',
      profile: 'Profil',
    },
    duplicates: {
      alert: {
        message_one:
          '{{count}} Mitarbeitende:r hat eine doppelte E-Mail-Adresse oder Personalnummer. Das kann in den Lohndatenexporten zu Problemen führen. Bitte prüfen Sie den Eintrag.',
        message_other:
          '{{count}} Mitarbeitende haben doppelte E-Mail-Adressen oder Personalnummern. Das kann in den Lohndatenexporten zu Problemen führen. Bitte prüfen Sie die Einträge.',
        action: 'Nur betroffene anzeigen ({{count}})',
      },
      tooltip: {
        CLAIMABLE: {
          mail: 'Für diesen Mitarbeitenden ist {{value}} vorgesehen, die Adresse ist aber noch keinem Account zugeordnet. Im Profil lässt sich festlegen, wer sie bekommt.',
          employeeNumber:
            'Für diesen Mitarbeitenden ist {{value}} vorgesehen, die Nummer ist aber noch keinem Account zugeordnet. Im Profil lässt sich festlegen, wer sie bekommt.',
        },
        MISMATCH: {
          mail: 'Bei der Migration würde diese Adresse durch {{value}} ersetzt. Im Profil lässt sich festlegen, welche gelten soll.',
          employeeNumber:
            'Bei der Migration würde diese Nummer durch {{value}} ersetzt. Im Profil lässt sich festlegen, welche gelten soll.',
        },
        CONFLICT: {
          mail: '{{value}} ist bereits einem anderen Mitarbeitenden zugeordnet. Im Profil muss eine abweichende Kontakt-E-Mail hinterlegt werden.',
          employeeNumber:
            '{{value}} ist bereits einem anderen Mitarbeitenden zugeordnet. Im Profil muss eine abweichende Personalnummer hinterlegt werden.',
        },
      },
      mismatchLabel: {
        mail: 'Wird bei Migration ersetzt',
        employeeNumber: 'Wird bei Migration ersetzt',
      },
      differsLabel: {
        mail: 'Duplikat',
        employeeNumber: 'Duplikat',
      },
      conflictLabel: {
        mail: 'E-Mail bereits vergeben',
        employeeNumber: 'Personalnummer bereits vergeben',
      },
    },
    userForm: {
      lead: `<p>Bitte geben Sie alle erforderlichen Daten ein, um einen neuen Mitarbeiter zu Ihrem Firmenkonto hinzuzufügen.</p>
      <p>Nach dem Klick auf "Speichern" wird eine Einladung per Email an den Mitarbeiter verschickt, über die er seinen Zugang einrichten kann.</p>`,
      section: {
        employeeInfo: 'Stammdaten',
        role: 'Rolle',
        benefits: 'Benefits',
      },
      row: {
        personal: {
          title: 'Persönliche Informationen',
          info: 'Die Kontakt-E-Mail-Adresse ist die E-Mail-Adresse, die für die Kommunikation mit dem Mitarbeiter verwendet wird. Gesondert davon kann der Mitarbeiter eine Login-E-Mail-Adresse bei der Registrierung frei wählen. Diese E-Mail kann nur vom Mitarbeiter selbst oder durch unseren Support geändert werden.<br/><br/>Familienstand und Kinder sind für die Berechnung der Erholungsbeihilfe erforderlich.<br/><br/>Die private Anschrift wird bei der Bestellung von Sachbezugskarten zur Einrichtung des zugehörigen Guthabenkontos benötigt.',
        },
        professional: {
          title: 'Berufliche Informationen',
          info: 'Die persönliche Mitarbeiternummer wird erfasst, um die Durchführung von Lohnsteuerexporten zu ermöglichen. Ähnlich wie die E-Mail-Adresse dient sie ebenfalls zur eindeutigen Identifikation. Die Angabe der Abteilung und des Einstellungsdatums erleichtert die Filterung von Mitarbeitern, um gezielt Informationen und Daten für bestimmte Gruppen von Mitarbeitern anzuzeigen.',
        },
      },
      field: {
        status: {
          label: 'Status',
        },
        salutation: {
          label: 'Anrede',
          MR: 'Herr',
          MS: 'Frau',
          DIVERS: 'Divers',
          COMPANY: 'Firma',
          notSet: 'Keine Angabe',
        },
        title: 'Titel',
        firstName: 'Vorname',
        lastName: 'Nachname',
        mail: 'Kontakt E-Mail',
        loginMail: 'Login E-Mail',
        mailDisabledTooltip:
          'Die Login E-Mail-Adresse kann vom Mitarbeiter selbst oder durch unseren Support editiert werden. Bitte wenden Sie sich mit der neuen und alten E-Mail-Adresse an: support@probonio.de',
        phone: 'Telefonnummer',
        phoneMobile: 'Mobilnummer',
        department: 'Abteilung',
        costCenter: 'Kostenstelle',
        workLocations: 'Arbeitsstätte',
        workLocationsPlaceholder: 'Ort eingeben',
        employeeNumber: 'Personalnummer',
        employeeNumberInvalid: 'Die Personalnummer darf nicht 0 sein.',
        employeeNumberTooLong: 'Die Personalnummer darf maximal {{value}} Zeichen lang sein.',
        employeeTypeLabel: 'Art der Anstellung',
        hireDate: 'Einstellungsdatum',
        birthDate: 'Geburtsdatum',
        role: 'Benutzerrollen',
        activeBenefits: 'Verfügbare Benefits',
        statusLabel: 'Status',
        terminationDate: {
          label: 'Letzter Arbeitsmonat',
          value: '{{date,monthAndYear}}',
        },
        isSyncedFromHRSystem: '(importiert aus HR System)',
        homeAddressStreet: 'Straße und Hausnummer',
        homeAddressStreetLine2: 'Adresszusatz',
        homeAddressRegion: 'Bundesland',
        homeAddressPostalCode: 'Postleitzahl',
        homeAddressCity: 'Ort',
        homeAddressCountry: 'Land',
        isAddressEnabled: 'Mitarbeiteradresse',
      },
      validation: {
        invalidCountry: 'Bitte wählen Sie ein gültiges Land aus der Dropdown-Liste aus.',
      },
      registrationCodeMask: 'Registrierungscode anzeigen',
      copyRegistrationLink: 'Registrierungslink kopieren',
      mailDeliveryErrorInfo:
        '<p>Leider konnten wir die Mail nicht erfolgreich zustellen.</p>In den meisten Fällen liegt dies an einem Tippfehler in der Mail-Adresse, bitte überprüfen Sie diese. Sollte die Mail-Adresse falsch sein, löschen Sie den Mitarbeiter und legen Sie ihn mit der korrekten Mail-Adresse nochmals an.',
      duplicate: {
        chip: {
          mail: { CLAIMABLE: 'E-Mail Duplikat', MISMATCH: 'E-Mail wird ersetzt', CONFLICT: 'E-Mail bereits vergeben' },
          employeeNumber: {
            CLAIMABLE: 'Personalnummer Duplikat',
            MISMATCH: 'Personalnummer wird ersetzt',
            CONFLICT: 'Personalnummer bereits vergeben',
          },
        },
        claim: {
          title: {
            mail: 'Doppelte E-Mail – Bestätigung erforderlich',
            employeeNumber: 'Doppelte Personalnummer – Bestätigung erforderlich',
            both: 'Doppelte E-Mail und Personalnummer – Bestätigung erforderlich',
          },
          body: {
            mail: 'Die E-Mail <strong>{{mail}}</strong> ist für mehrere Mitarbeitende vorgesehen, darf aber nur einem zugeordnet werden. Bestätigen Sie unten, wenn sie zu diesem Mitarbeitenden gehört – die anderen benötigen dann eine neue Adresse. Eine Änderung kann anschließend nur über den Support vorgenommen werden.',
            employeeNumber:
              'Die Personalnummer <strong>{{employeeNumber}}</strong> ist für mehrere Mitarbeitende vorgesehen, darf aber nur einem zugeordnet werden. Bestätigen Sie unten, wenn sie zu diesem Mitarbeitenden gehört – die anderen benötigen dann eine neue Nummer. Eine Änderung kann anschließend nur über den Support vorgenommen werden.',
            both: 'Die E-Mail <strong>{{mail}}</strong> und die Personalnummer <strong>{{employeeNumber}}</strong> sind für mehrere Mitarbeitende vorgesehen, dürfen aber nur einem zugeordnet werden. Bestätigen Sie unten, was zu diesem Mitarbeitenden gehört – die anderen benötigen dann neue Werte.',
          },
          checkbox: {
            mail: 'Ich bestätige, dass <strong>{{mail}}</strong> für diesen Account verwendet werden soll',
            employeeNumber:
              'Ich bestätige, dass die Personalnummer <strong>{{employeeNumber}}</strong> für diesen Account verwendet werden soll',
          },
          checkboxDisabledHint: {
            mail: 'Nur verfügbar, solange keine abweichende Kontakt-E-Mail eingetragen ist.',
            employeeNumber: 'Nur verfügbar, solange keine abweichende Personalnummer eingetragen ist.',
          },
        },
        mismatch: {
          title: {
            mail: 'Kontakt-E-Mail wird bei der Migration ersetzt',
            employeeNumber: 'Personalnummer wird bei der Migration ersetzt',
            both: 'Kontakt-E-Mail und Personalnummer werden bei der Migration ersetzt',
          },
          body: {
            mail: 'Bei der Migration würde die hinterlegte Kontakt-E-Mail durch <strong>{{mail}}</strong> ersetzt. Bestätigen Sie unten, wenn stattdessen die aktuell eingetragene Adresse gelten soll – sie wird dann dauerhaft übernommen.',
            employeeNumber:
              'Bei der Migration würde die hinterlegte Personalnummer durch <strong>{{employeeNumber}}</strong> ersetzt. Bestätigen Sie unten, wenn stattdessen die aktuell eingetragene Nummer gelten soll – sie wird dann dauerhaft übernommen.',
            both: 'Bei der Migration würden die hinterlegte Kontakt-E-Mail durch <strong>{{mail}}</strong> und die Personalnummer durch <strong>{{employeeNumber}}</strong> ersetzt. Bestätigen Sie unten, wenn stattdessen die aktuell eingetragenen Werte gelten sollen – sie werden dann dauerhaft übernommen.',
          },
          checkbox: {
            mail: 'Ich bestätige, dass die eingetragene Kontakt-E-Mail gilt und nicht durch <strong>{{mail}}</strong> ersetzt wird',
            employeeNumber:
              'Ich bestätige, dass die eingetragene Personalnummer gilt und nicht durch <strong>{{employeeNumber}}</strong> ersetzt wird',
          },
        },
        fieldHint: {
          MISMATCH: {
            mail: 'Wird bei der Migration durch <strong>{{value}}</strong> ersetzt – bestätigen Sie oben, wenn diese Adresse gelten soll.',
            employeeNumber:
              'Wird bei der Migration durch <strong>{{value}}</strong> ersetzt – bestätigen Sie oben, wenn diese Nummer gelten soll.',
          },
          CLAIMABLE: {
            mail: 'Bei der Migration wird die Kontakt-E-Mail durch <strong>{{value}}</strong> ersetzt. Bestätigen Sie oben die Übernahme, oder tragen Sie hier eine abweichende Adresse ein.',
            employeeNumber:
              'Bei der Migration wird die Personalnummer durch <strong>{{value}}</strong> ersetzt. Bestätigen Sie oben die Übernahme, oder tragen Sie hier eine abweichende Nummer ein.',
          },
          CONFLICT: {
            mail: 'Bei der Migration soll die Kontakt-E-Mail durch <strong>{{value}}</strong> ersetzt werden – diese Adresse ist jedoch bereits einem anderen Mitarbeitenden zugeordnet. Bitte tragen Sie hier eine abweichende Adresse ein.',
            employeeNumber:
              'Bei der Migration soll die Personalnummer durch <strong>{{value}}</strong> ersetzt werden – diese Nummer ist jedoch bereits einem anderen Mitarbeitenden zugeordnet. Bitte tragen Sie hier eine abweichende Nummer ein.',
          },
        },
        peers: {
          mail: 'Diese E-Mail-Adresse ist außerdem vorgesehen für:',
          employeeNumber: 'Diese Personalnummer ist außerdem vorgesehen für:',
        },
        syncBlocked: {
          title: 'Stammdaten vorübergehend gesperrt',
          body: 'Für einen anderen Mitarbeitenden ist aktuell dieselbe E-Mail-Adresse oder Personalnummer vorgesehen. Solange das so ist, lassen sich die Stammdaten dieses Mitarbeitenden nicht speichern. Bitte lösen Sie den Eintrag beim anderen Mitarbeitenden auf.',
          peers: 'Betroffene Mitarbeitende:',
        },
        conflict: {
          title: {
            mail: 'E-Mail nicht mehr verfügbar',
            employeeNumber: 'Personalnummer nicht mehr verfügbar',
            both: 'E-Mail und Personalnummer nicht mehr verfügbar',
          },
          body: {
            mail: 'Die E-Mail <strong>{{mail}}</strong> ist bereits einem anderen Mitarbeitenden zugeordnet. Bitte geben Sie eine neue Kontakt-E-Mail ein, um fortzufahren.',
            employeeNumber:
              'Die Personalnummer <strong>{{employeeNumber}}</strong> ist bereits einem anderen Mitarbeitenden zugeordnet. Bitte geben Sie eine neue Personalnummer ein, um fortzufahren.',
            both: 'Die E-Mail <strong>{{mail}}</strong> und die Personalnummer <strong>{{employeeNumber}}</strong> sind bereits anderen Mitarbeitenden zugeordnet. Bitte geben Sie neue Werte ein, um fortzufahren.',
          },
        },
        deleteAlternative:
          'Sollten Sie diesen Account nicht mehr benötigen, können Sie alternativ das Konto löschen. Beenden Sie hierfür zunächst das Arbeitsverhältnis am Ende dieser Seite und löschen Sie anschließend das Konto.',
        saveDisabledTooltip:
          'Bitte lösen Sie zuerst den Eintrag oben im Formular auf. Solange er offen ist, können die übrigen Stammdaten nicht gespeichert werden.',
      },
      terminateEmployment: {
        button: 'Arbeitsverhältnis beenden',
        terminateNow: 'Arbeitsverhältnis sofort beenden',
        planTerminate: 'Austritt planen',
        activate: 'Mitarbeiter wieder aktivieren',
        toBeTerminated: 'Scheidet zum {{date,date}} aus',
        reset: 'Geplanter Austritt zurücknehmen',
        dialogTitle: 'Arbeitsverhältnis beenden',
        infoText:
          'Wenn Sie das Arbeitsverhältnis Ihres Mitarbeiters beenden, kann sich dieser weiterhin in die Mitarbeiter-App einloggen, um bereits erhaltene Gutscheine einzulösen. Allerdings werden alle aktiven Benefits zum gewählten Termin deaktiviert.',
        planInfo:
          'Falls der Austritt erst für die Zukunft geplant ist, geben Sie optional den gewünschten Monat an, zu dessen Ende das Arbeitsverhältnis enden soll.',
        reactivateTitle: 'Mitarbeiter wieder aktivieren',
        reactivateText: 'Wollen Sie den Mitarbeiter wirklich wieder aktivieren? Konfigurieren Sie danach erneut die gewünschten Benefits.',
        reactivateSuccess: 'Mitarbeiter wurde aktiviert',
        deactivateSuccess: 'Austritt gespeichert',
        terminationNotPossibleBenefit:
          'Das Arbeitsverhältnis kann nicht zum gewählten Termin beendet werden, da bereits eine Gutscheinrechnung für den Mitarbeiter erstellt wurde. Bitte wählen Sie einen anderen Termin.',
      },
      sourceFilter: {
        hide: 'Aus Mitarbeiterliste ausblenden',
        show: 'In Mitarbeiterliste anzeigen',
      },
      button: {
        save: 'Speichern',
        cancel: 'Verwerfen',
        changeAvatar: 'Profilbild ändern',
      },
      slider: {
        toggleInfo: 'Benutzer aktivieren und deaktivieren. Es können nur inaktive Benutzer gelöscht werden!',
      },
      deleteUser: {
        button: 'Mitarbeiter entfernen',
        title: 'Mitarbeiter löschen',
        message: 'Dies löscht alle Daten des Mitarbeiters {{userName}} unwiderruflich.',
        securityQuestion: 'Bitte geben Sie das Wort "{{securityQuestionValue}}" zur Bestätigung ein.',
        securityQuestionValue: 'Löschen',
        warningAlert: 'Der Mitarbeiter hat keinen Zugriff mehr auf seine App, nicht eingelöste oder gespeicherte Gutscheine verfallen.',
      },
      resendInvitation: {
        button: 'Erneut einladen',
      },
      applyTemplate: {
        button: 'Vorlage anwenden',
        dialogTitle: 'Benefits aus Vorlage konfigurieren',
        info: 'Wählen Sie die Vorlage, die Sie für die Benefit-Konfiguration des Mitarbeiters anwenden möchten. Alle in der Vorlage konfigurierten Benefits starten ab dem unten gewählten Datum.',
        infoManage: 'Verwalten Sie die verfügbaren Vorlagen in den <0>Unternehmenseinstellungen</0>.',
        noTemplates: 'Es sind keine Benefit-Vorlagen definiert.',
        emptySelection: 'Keine Vorlage',
        infoManyChanges: 'Diese Änderungen betreffen {{count}} Mitarbeiter.',
        activeWarning: 'Bereits aktive oder geplante Benefits des Mitarbeiters bleiben von der Änderung unberührt.',
        field: {
          template: 'Vorlage',
        },
      },
      confirmMailDialog: {
        title: 'Änderung der Kontakt E-Mail bestätigen',
        text: 'Sind Sie sicher, dass Sie die Kontakt-E-Mail-Adresse des Mitarbeiters auf <strong>{{mail}}</strong> ändern möchten?',
        pendingInfo: 'Der Mitarbeiter erhält automatisch eine neue Registrierungsmail. Die vorherige Mail verliert ihre Gültigkeit.',
      },
      benefit: {
        active: 'Seit {{val, date}}',
        inactive: 'Inaktiv',
        LUNCH: {
          name: 'Essenszuschuss',
          description: '',
        },
        MOBILITY: {
          name: 'Mobilität',
        },
        INTERNET: {
          name: 'Internetpauschale',
        },
        KITA: {
          name: 'Kita-Zuschuss',
        },
        BAV: {
          name: 'Altersvorsorge',
        },
        COUPONS: {
          name: 'Gutscheine',
        },
        COUPONS_V2: {
          name: 'Sachbezug Flex',
          giftsName: 'Zuwendungen',
        },
        AT_LUNCH: {
          name: 'Essenszuschuss',
        },
        AT_MOBILITY: {
          name: 'Öffi-Ticket',
        },
        GIFTS: {
          name: 'Aufmerksamkeiten',
          active: 'Nächste am {{val, date}}',
        },
        CUSTOM: {
          name: 'Weitere Benefits',
        },
        BIKE: {
          name: 'Firmenrad',
        },
        BIKELEASING_V2: {
          name: 'Bikeleasing',
        },
        BIKELEASING: {
          name: 'Bikeleasing',
        },
        NEWS: {
          name: 'Mitarbeiterkommunikation',
        },
        FLEX: {
          name: 'Flex Budget',
        },
        RECREATION: {
          name: 'Erholungsbeihilfe',
        },
        FITNESS: {
          name: 'Firmenfitness',
        },
        WELLPASS: {
          name: 'Firmenfitness',
        },
        CREDIT_CARD: {
          name: 'Sachbezugskarte',
        },
        DISCOUNT_CODE: {
          name: 'Mitarbeiterrabatte',
        },
        CAR: {
          name: 'JobAuto',
        },
        IT_LEASING: {
          name: 'IT-Leasing',
        },
      },
    },
    usersList: {
      header: {
        name: 'Mitarbeiter',
        employeeNumber: 'Personalnummer',
        hireDate: 'Einstellungsdatum',
        roles: 'Rolle',
        activeBenefits: 'Aktive Benefits',
        status: 'Status',
        department: 'Abteilung',
        recipients: 'Empfänger',
        salutation: 'Anrede',
        birthDate: 'Geburtstag',
        date: 'Datum',
        homeAddress: 'Adresse',
      },
      noResults: 'Für Ihre Suche wurden keine Mitarbeiter gefunden',
      statusFilterLabel: 'Mitarbeiter-Status',
      includeHidden: 'Ausgeblendete Mitarbeiter einblenden',
      excludeHidden: 'Ausgeblendete Mitarbeiter ausblenden',
      hiddenMarker: {
        tooltip: 'Dieser Mitarbeiter ist in der Liste ausgeblendet',
        confirmTitle: 'Mitarbeiter wieder einblenden',
        confirmText: 'Möchten Sie diesen Mitarbeiter wieder in der Mitarbeiterliste anzeigen?',
      },
      isSyncedFromHRSystem: 'Mitarbeiter wurde aus verbundenem HR System importiert',
      importedFromBikeleasing: 'Mitarbeiter wurde aus Bikeleasing importiert',
      hrSystemTemplateApplied: "Vorlage: '{{name}}' über HR-Schnittstelle angewendet",
      exportDialog: {
        title: 'Datenexport',
        message:
          'Hinweis: Aktivierungen für den kommenden Monat können bis zum 25. des aktuellen Monats noch geändert werden — der Export zeigt den aktuellen Stand.',
        startMonth: 'Von',
        endMonth: 'Bis',
        cancel: 'Abbrechen',
        download: 'Herunterladen',
        benefits: 'Benefits',
        benefitsAll: 'Alle Benefits',
        noUsedBenefits: 'Im gewählten Zeitraum wurden keine Benefits genutzt. Es gibt nichts zu exportieren.',
      },
    },
    profileActivationList: {
      title: 'Benefits',
      currentBenefits: 'Aktuell',
      upcomingBenefits: 'Geplant',
      addBenefit: 'Benefit hinzufügen',
      startDate: 'Start',
      endDate: 'Ende',
      active: 'Aktiv',
      giftsSelectionGroup: 'Sachzuwendungen',
      managedByTemplate: 'Über Vorlage verwaltet',
      hrSystemTemplateApplied: "Vorlage: '{{name}}' über HR-Schnittstelle angewendet",
      noBenefitsActive:
        'Derzeit sind keine Mitarbeiter-Benefits aktiv oder geplant. Mit den obigen Buttons, können Sie Benefits einzeln aktivieren oder Ihre vordefinierten Benefit-Templates anwenden.',
      noBenefitsActiveTerminated:
        'Es ist nicht möglich, diesem Mitarbeiter Benefits zuzuteilen, da er aus dem Unternehmen ausgetreten ist. Sie können den Mitarbeiter in den Profileinstellungen wieder aktivieren.',
    },
    profileActivationHistory: {
      title: 'Benefit-Verlauf',
      buttonTooltip: 'Verlauf der Benefit-Aktivierungen anzeigen',
      buttonTooltipHide: 'Verlauf der Benefit-Aktivierungen verbergen',
      tableHeader: 'Benefit-Aktivierungen',
      tableHeaderGifts: 'Aufmerksamkeiten',
      tableHeaderGiftsV2: 'Aufmerksamkeiten (Sachbezug Flex)',
    },
    notChanged: 'Es wurden keine Änderungen vorgenommen!',
    saveChanges: 'Änderungen gespeichert',
    saveConflictEmployeeNumber: 'Die Personalnummer ist bereits vergeben',
    saveConflictMail: 'Die E-Mail ist bereits vergeben',
    deactivationError: 'Deaktivieren nicht möglich, da Gutscheinrechnung schon erstellt',
    deletionError: 'Löschen nicht möglich, da Gutscheinrechnung schon erstellt',
    mailSent: 'Die Einladungsmail wurde erfolgreich versandt',
    unlockUser: 'Der Mitarbeiter wurde erfolgreich freigegeben',
    statusTerminated: 'ausgetreten',
    employeeNotFound: 'Mitarbeiter nicht gefunden',
    employeeNotFoundInfo: 'Der Mitarbeiter wurde möglicherweise gelöscht, oder die eingegebe URL ist nicht mehr gültig.',
  },
  benefitsModule: {
    bulkActivation: {
      noNewActivationsDone: 'Es wurden keine Mitarbeiter gefunden, für die der Benefit aktiviert werden kann.',
      newActivationsSomeErrors: '{{successCount}} Mitarbeiter aktiviert, {{errorCount}} übersprungen',
      newActivationsError: 'Benefit konnte für gewählte Mitarbeiter nicht aktiviert werden',
      newActivationsSuccess: 'Benefit wurde für {{count}} Mitarbeiter aktiviert',
      activatedCount: '{{count}} aktiviert',
    },
    bulkResult: {
      processed: '{{count}} Mitarbeiter verarbeitet:',
      skipped: '{{count}} übersprungen',
      skippedReason: '{{count}} übersprungen: {{reason}}',
      adjusted: '{{count}} übernommen, Enddatum angepasst',
      blocked: '{{count}} blockiert',
      cappedSuffix: 'davon für {{count}} die Aktivierung auf das Kündigungsdatum begrenzt',
      missingCreditCard: 'Die Aktivierung ist nur mit einer gültigen Sachbezugskarte möglich',
    },
    conflictError: 'Die ausgewählten Benefits sind bereits aktiv.',
    nonCashBenefits: {
      available: 'Verfügbar',
      unavailable: 'Nicht Verfügbar',
      infoTitle: 'Mögliche Auszahlungsarten des Sachbezuges',
      activationDialog: { error: 'Bitte mindestens eine Option wählen!' },
      COUPONS: {
        name: 'Gutscheine',
        requirement: 'Verfügbar für 5€-Schritte',
        infoText: `Um Ihren Mitarbeitern die Gutscheine anzubieten, lässt sich das Gutschein-Budget mit nur wenigen Klicks aufladen und jederzeit flexibel anpassen. Durch die standardgemäße Einstellung zur automatischen Aufladung, erhalten Sie jeden Monat automatisch eine Rechnung für die Kosten, die im nächsten Monat anfallen.
      <br><br>
      Aus steuerrechtlichen Gründen müssen Gutscheine den Mitarbeitern immer im entsprechenden Monat zufließen. Ansonsten würde das Guthaben für Ihre Mitarbeiter verfallen. Um zu vermeiden, dass Guthaben für Ihre Mitarbeiter verfällt, ist standardmäßig ein automatischer Gutscheinzufluss für Ihre Mitarbeiter eingestellt. Sollte ein aktiver Mitarbeiter daher bis zum Ende des Monats noch keinen Gutschein gewählt haben und ebenso keine automatische Auswahl getroffen sein, erhält er automatisch einen von Ihnen festgelegten Gutschein.
      <br><br>
        <strong>Um die steuerlichen Vorteile der Sachbezugsgutscheine zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Ihre Mitarbeiter müssen ihren Gutschein im entsprechenden Monat in der Probonio-App auswählen. Den Zeitpunkt, bis wann Ihre Mitarbeiter einen Gutschein auswählen dürfen, können Sie jederzeit unter den Einstellungen konfigurieren. Den Steuerreport erhalten Sie am darauffolgenden Tag oder spätestens am 01. des Folgemonats.</li>
        <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
        </ul>
       `,
      },
      FITNESS: {
        name: 'Firmenfitness - Urban Sports Club',
        requirement: 'Verfügbare Beträge: 25€, 40€ und 50€',
        infoText: `Mit dem Firmenfitness-Benefit ermöglichen Sie Ihren Mitarbeitern den flexiblen Zugang zu einem breiten Spektrum an Sport-, Wellness- und Gesundheitsangeboten in deutschlandweit teilnehmenden Studios. Je nach individuellen Bedürfnissen können Ihre Mitarbeiter die Angebote flexibel nutzen, was nicht nur die körperliche Gesundheit, sondern auch die geistige Ausgeglichenheit und Zufriedenheit fördert. Für Ihr Unternehmen ergeben sich langfristige Vorteile: Gesündere Mitarbeiter sind weniger krank, produktiver und stärker an das Unternehmen gebunden. 
          <br><br>
          <strong>Um die steuerlichen Vorteile der Firmenfitness als Sachbezug zu nutzen, gelten folgende Regelungen</strong>
          <ul>
          <li>Es darf kein Geld an Mitarbeitern ausgezahlt werden, (Zuschüsse zu) Mitgliedschaften müssen direkt zur Verfügung gestellt werden.</li>
          <li>Das Angebot muss allen Mitarbeitern gleichwertig zugänglich sein, nicht nur bestimmten Gruppen.</li>
          <li>Die Mitgliedschaft oder der Beitrag darf nicht in Bargeld oder als Geldäquivalent (z. B. Gutscheine) ausgezahlt werden.</li>
          <li>Die Teilnahme an den Fitnessangeboten muss auf freiwilliger Basis erfolgen.</li>
          </ul>`,
      },
      WELLPASS: {
        name: 'Firmenfitness - EGYM Wellpass',
        requirement: 'Verfügbarer Beitrag: {{amount}}€',
        infoText: `Mit dem Firmenfitness-Benefit ermöglichen Sie Ihren Mitarbeitern den flexiblen Zugang zu einem breiten Spektrum an Sport-, Wellness- und Gesundheitsangeboten in deutschlandweit teilnehmenden Studios. Je nach individuellen Bedürfnissen können Ihre Mitarbeiter die Angebote flexibel nutzen, was nicht nur die körperliche Gesundheit, sondern auch die geistige Ausgeglichenheit und Zufriedenheit fördert. Für Ihr Unternehmen ergeben sich langfristige Vorteile: Gesündere Mitarbeiter sind weniger krank, produktiver und stärker an das Unternehmen gebunden. 
          <br><br>
          <strong>Um die steuerlichen Vorteile der Firmenfitness als Sachbezug zu nutzen, gelten folgende Regelungen</strong>
          <ul>
          <li>Es darf kein Geld an Mitarbeitern ausgezahlt werden, (Zuschüsse zu) Mitgliedschaften müssen direkt zur Verfügung gestellt werden.</li>
          <li>Das Angebot muss allen Mitarbeitern gleichwertig zugänglich sein, nicht nur bestimmten Gruppen.</li>
          <li>Die Mitgliedschaft oder der Beitrag darf nicht in Bargeld oder als Geldäquivalent (z. B. Gutscheine) ausgezahlt werden.</li>
          <li>Die Teilnahme an den Fitnessangeboten muss auf freiwilliger Basis erfolgen.</li>
          </ul>`,
      },
      CREDIT_CARD: {
        name: 'Sachbezugskarte',
        requirement: 'Verfügbar für Mitarbeiter mit gültiger Sachbezugskarte',
        infoText: '$t(benefitsModule:CREDIT_CARD.infoTextFull)',
      },
    },
    bulkApplyTemplate: {
      noNewActivationsDone: 'Es wurden keine Mitarbeiter gefunden, für die die Vorlage angewendet werden kann.',
      newActivationsSomeErrors: '{{successCount}} Mitarbeiter angewendet, {{errorCount}} übersprungen',
      newActivationsError: 'Vorlage konnte für gewählte Mitarbeiter nicht angewendet werden',
      newActivationsSuccess: 'Vorlage wurde für {{count}} Mitarbeiter angewendet',
      appliedCount: 'Vorlage für {{count}} Mitarbeiter angewendet',
    },
    fields: {
      date: 'Datum',
      dateFrom: 'Von',
      dateTill: 'Bis',
      benefit: 'Benefit',
      options: 'Optionen',
      buttons: {
        cancel: 'Abbrechen',
        save: 'Speichern',
      },
    },
    labelStartDate: 'Von',
    labelEndDate: 'Bis',
    pause: 'Pausierung',
    pauseBenefitLabel: 'Benefit für folgenden Zeitraum pausieren:',
    planPause: 'Pausierung planen',
    receipts: {
      from: 'Eingereicht von',
      date: 'Datum',
      amount: 'Betrag',
      refund: 'Erstattungsbetrag',
      completedDate: 'Eingereicht am',
      expirationDate: 'Nächste Bestätigung bis',
      status: 'Status',
      pending: 'Beleg in Prüfung',
      approved: 'Beleg freigegeben',
      rejected: 'Beleg abgelehnt',
      timeCardSplit: 'Diese Jahres-/Zeitkarte wird über die Gültigkeit von {{validityMonths}} Monaten anteilsweise ausgezahlt.',
      validityStart: 'Start',
      duration: 'Dauer',
      durationMonthsSingle: '≤ 1 Monat',
      durationMonths_one: '{{count}} Monat',
      durationMonths_other: '{{count}} Monate',
      refundType: 'Rückerstattungsart',
      refundType_MONTHLY: 'Aliquot',
      refundType_YEARLY: 'Einmalig',
    },
    helperText: {
      dateFrom: 'Ab aktuellem Monat',
      dateTill: 'Optional, nach Startdatum',
      dateNextMonth: 'Ab nächstem Monat',
    },
    hrSystemTemplateOverrideWarning:
      'Das Bearbeiten dieser Aktivierung wird bei der nächsten Synchronisation über die HR-Schnittstelle wieder überschrieben.',
    benefitSplitAlert: {
      default: 'Ihre Änderung gilt nur für den aktuellen und die Folgemonate. Vergangene Monate bleiben von der Änderung unberührt',
      COUPONS_V2:
        'Ihre Änderung gilt nur für den aktuellen Monat falls der Mitarbeiter noch keinen Gutschein erhalten hat. Ihre Änderung gilt ansonsten für die Folgemonate.',
    },
    noValidActivationPeriod:
      'Für diesen Mitarbeiter ist keine Aktivierung möglich: Der früheste Startzeitpunkt liegt nach dem Austrittsdatum.',
    showMoreButton: 'Mehr anzeigen',
    showLessButton: 'Weniger anzeigen',
    dialogCreateTitle: 'Neue Aktivierung hinzufügen',
    dialogEditTitle: 'Aktivierung bearbeiten',
    deleteConfirmation: 'Sind Sie sicher, dass Sie die geplante Aktivierung löschen möchten?',
    deleteActivation: 'Geplante Aktivierung löschen',
    stopTitle: 'Deaktivierung',
    stopChoice: 'Bitte wählen Sie wann der Benefit deaktiviert werden soll.',
    stopConfirmation1:
      'Falls der Mitarbeiter ihn schon genutzt hat, wird er zum Ende des aktuellen Monats deaktiviert, ansonsten zum <strong>Ende des letzten Monats</strong>.',
    stopConfirmation2: 'Der Benefit wird zum <strong>Ende des aktuellen Monats</strong> deaktiviert.',
    stopButton: 'Deaktivieren',
    stopButton1: 'Baldmöglichst deaktivieren',
    stopButton2: 'Deaktivierung planen',
    nonCashLimitWarning:
      'Betrag würde im gewählten Zeitraum die steuerfreie Sachbezugsgrenze von monatlich 50€ um {{exceededNonCashLimitAmount, euro}} überschreiten',
    nonCashLimitWarningGeneric:
      'Der Benefit $t(common:benefit.{{benefit}}) kann nur für Mitarbeiter aktiviert werden, welche die steuerfreie Sachbezugsgrenze von monatlich 50€ damit nicht überschreiten.',
    invoiceCreatedWarning: 'Diese Aufmerksamkeit wurde bereits in Rechnung gestellt',
    budgetExceededWarning:
      'Achtung: Nicht genug Gutschein Budget vorhanden. Gutscheine müssen bis Ende des Kalendermonats dem Mitarbeiter zufließen. Dies kann nur sichergestellt werden, wenn uns die Zahlung bis zum Ende des Monats erreicht.',
    successCreate: 'Aktivierung erfolgreich erstellt',
    successUpdate: 'Aktivierung erfolgreich aktualisiert',
    terminationDateCapped: 'Aktivierung aktualisiert. Das Enddatum wurde auf das Kündigungsdatum ({{date,monthAndYear}}) begrenzt.',
    successDelete: 'Aktivierung erfolgreich gelöscht',
    successStop: 'Benefit erfolgreich deaktiviert',
    successPause: 'Benefit erfolgreich pausiert',
    activationError: {
      conflict: 'Ausgewählter Bereich existiert bereits',
      activationAlreadyStopped: 'Die Aktivierung endet bereits in diesem Monat und kann nicht früher beendet werden',
      flexConflict: 'Das Flex Budget kann nur exklusiv aktiviert werden',
      missingCreditCard: 'Bitte bestellen Sie zuerst eine Kreditkarte',
      terminationDateExceeded: 'Die Aktivierung kann nicht nach dem Kündigungsdatum des Mitarbeiters beginnen',
      activeContract: 'Deaktivierung nicht möglich, solange ein Bikeleasing-Vertrag aktiv ist. Bitte beenden Sie zuerst die Verträge.',
    },
    inuseError: {
      default: 'Benefit wurde im gewählten Zeitraum bereits verwendet.',
      COUPONS_V2: 'Deaktivieren erst zum Ende des Folgemonats möglich, da Gutschein Rechnung schon erstellt',
    },
    userBenefitPage: {
      activations: 'Aktivierungen',
      employeeData: 'Mitarbeiterdaten',
      activeSince: 'Seit dem {{date,date}} aktiviert',
    },
    userGiftsPage: {
      payouts: 'Auszahlungen',
      payoutDate: 'Auszahlungsdatum',
      occasion: 'Anlass',
      recurring: 'Wiederkehrend',
      amount: 'Betrag',
      status: 'Status',
      employee: 'Mitarbeiter',
      active: 'Nächste Auszahlung am {{val, date}}',
      deleteConfirmation: 'Sind Sie sicher, dass Sie die geplante Auszahlung löschen möchten?',
    },
    report: {
      couponDeadlineWarning:
        'Den Report der Sachbezüge erhalten sie gesondert per E-Mail. Sie können diesen erneut verschicken, wenn Sie auf "Historie anzeigen" klicken.',
      reportDialogMessage:
        'Dieser Report dient Ihnen im Falle einer Steuer- oder Sozialversicherungsprüfung als Dokumentation aller eingegangenen Belege und der dafür ausgezahlten Beträge.',
      receiptExportButton: 'Belege als CSV exportieren',
      receiptExportTooltip: 'Detailreport herunterladen',
      tooltip: 'Bitte laden Sie den Report einmalig herunter, um den automatischen Versand zu aktivieren',
      lastExport: 'Letzter Export am {{date,date}}',
      lodas: {
        title: 'Bearbeitungsstatus {{reportMonth,monthAndYearShort}}',
        button: 'Integration Lohnbuchhaltung',
      },
      confirmDialog: {
        header: 'E-Mail Report deaktivieren?',
        body: 'Wollen Sie den E-Mail Report deaktivieren?',
      },
      mailCheckbox: 'Automatischer Report',
      employeeList: {
        header: {
          name: 'Mitarbeiter',
          employeeNumber: 'Personalnummer',
          department: 'Abteilung',
          validated: 'Bearbeitet',
          sum: 'Summe',
        },
      },
      reportDownloadDialog: {
        title: 'Detailreport Information',
        actionSuccess: 'Herunterladen',
        exportMonth: 'Buchungen exportieren für',
        exportMonthHelper: 'Wählen Sie einen Monat, um nur die Buchungen dieses Monats zu exportieren',
      },
      successExportDialog: {
        header: 'Integration Lohnbuchhaltung',
        title: 'Lohndaten wurden erfolgreich exportiert!',
        question: 'Wollen Sie in Zukunft Ihren Report per E-Mail erhalten?',
        checkbox: 'Mir die Lohndaten-Reports jeden Monat per E-Mail automatisch zuschicken',
        detailCheckbox: 'Mir die Detailreports für jeden Monat per E-Mail automatisch zuschicken',
        submitButton: 'Bestätigen',
      },
      tabs: {
        export: 'Lohndatenexport',
        documents: 'Dokumente',
      },
      noDocuments: 'Keine Dokumente verfügbar',
    },
    settingsDialog: {
      title: 'Einstellungen für Benefit {{benefit}}',
      settings: 'Einstellungen',
      moreSettings: 'Weitere Einstellungen',
      exportType: 'Lohnbuchhaltungssystem',
      exportTypeLong: 'Gewähltes Lohnbuchhaltungssystem',
      exportTypeHint: 'Bitte wenden Sie sich an unseren Support, falls Sie Ihr Lohnbuchhaltungsssystem ändern möchten.',
      salaryTypeInvalidCharacters: 'Die Lohnart darf keine Semikolons, Anführungszeichen, Tabs oder Zeilenumbrüche enthalten',
      salaryTypeNumeric: 'Die Lohnart muss eine Zahl mit 1 bis 6 Ziffern sein (ohne führende 0)',
      exportSuccess:
        'Lohndaten wurden erfolgreich exportiert!\n\nAktivieren Sie rechts den automatischen Versand, um den Report in Zukunft per E-Mail zu erhalten.',
      exportEmployeeNumberWarning:
        'Für ein oder mehrere aktive Mitarbeiter war zum Zeitpunkt der Report-Erstellung keine gültige numerische Personalnummer hinterlegt. Im Report wurde stattdessen die E-Mail-Adresse der Mitarbeiter eingetragen.\n\nBitte hinterlegen Sie die Personalnummern in den Mitarbeiterstammdaten.',
      selectExportType: 'Lohnbuchhaltungssystem festlegen',
    },
    benefitSelector: {
      benefit: 'Benefit',
      subheader: 'Benefits',
      all: 'Alle',
    },
    employeeTabs: {
      configureNow_zero: 'Jetzt für Mitarbeiter konfigurieren',
      configureNow_one: 'Jetzt für {{count}} Mitarbeiter konfigurieren',
      configureNow: 'Jetzt für {{count}} Mitarbeiter konfigurieren',
      configureNowAll: 'Jetzt für alle Mitarbeiter konfigurieren',
      editConfiguration_zero: 'Konfiguration für Mitarbeiter ändern',
      editConfiguration_one: 'Konfiguration für {{count}} Mitarbeiter ändern',
      editConfiguration: 'Konfiguration für {{count}} Mitarbeiter ändern',
      editConfigurationAll: 'Konfiguration für alle Mitarbeiter ändern',
      noRecordsToDisplay: 'Dieser Benefit ist noch für keine Mitarbeiter aktiviert.',
      confirmed: 'bestätigt',
      pleaseSelect: 'Bitte wählen Sie in der Tabelle die gewünschten Mitarbeiter.',
      tab: {
        active: 'Benefit aktiv',
        inactive: 'Benefit inaktiv',
        all: 'Alle',
      },
      header: {
        nonCashBenefits: 'Art des Sachbezugs',
        status: 'Benefit aktiv',
        notInterested: 'Kein Interesse',
        creditCardStatus: 'Status',
      },
      status: {
        active: 'Seit {{startDate,monthAndYearShort}}',
        inactive: 'Nein',
        activeFrom: 'Ab {{startDate,monthAndYearShort}}',
      },
      creditCardStatus: {
        ACTIVE: 'Gültig bis {{expirationDate,monthAndYearShort}}',
        ORDERED: 'Bestellt am {{orderDate,date}}',
        EXPIRED: 'Abgelaufen',
      },
    },
    subPage: {
      news: 'Nachrichten',
      employees: 'Mitarbeiter',
      receipts: 'Belege',
      payrollReport: 'Lohndatenexport',
      documents: 'Dokumente',
      settings: 'Einstellungen',
    },
    bulkEditDialog: {
      title: 'Konfiguration ändern',
      noEditable: 'Es wurden keine Mitarbeiter gefunden, für die der Benefit aktualisiert werden kann.',
      employeeListError: 'Die Liste der Mitarbeiter konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
      deactivateError: '{{count}} Mitarbeiter konnten nicht deaktiviert werden',
      deactivateError_one: 'Ein Mitarbeiter konnte nicht deaktiviert werden',
      deactivateSomeErrors: '{{successCount}} Mitarbeiter deaktiviert, {{errorCount}} übersprungen',
      deactivateSuccess: '{{count}} Mitarbeiter wurden deaktiviert',
      deactivateSuccess_one: 'Ein Mitarbeiter deaktiviert',
      pauseError: '{{count}} Mitarbeiter konnten nicht pausiert werden',
      pauseError_one: 'Ein Mitarbeiter konnte nicht pausiert werden',
      pauseSomeErrors: '{{successCount}} Mitarbeiter pausiert, {{errorCount}} übersprungen',
      pauseSuccess: '{{count}} Mitarbeiter wurden pausiert',
      pauseSuccess_one: 'Ein Mitarbeiter pausiert',
      updateError: '{{count}} Mitarbeiter konnten nicht aktualisiert werden',
      updateSomeErrors: '{{successCount}} Mitarbeiter aktualisiert, {{errorCount}} übersprungen',
      updateSuccess: '{{count}} Mitarbeiter wurden aktualisiert',
      updateSuccess_one: '{{count}} Mitarbeiter aktualisiert',
      updatedCount: '{{count}} aktualisiert',
      tabs: {
        deactivate: 'Benefit deaktivieren',
        changeOptions: 'Optionen ändern',
        pauseBenefit: 'Benefit pausieren',
      },
      deactivate: {
        mode: {
          info: 'Bitte wählen Sie, zu welchem Termin Sie den Benefit deaktivieren möchten:',
          nearestDate: {
            label: 'Baldmöglichst',
            hint: 'Falls der Mitarbeiter den Benefit schon genutzt hat, wird es zum Ende des aktuellen Monats deaktiviert, ansonsten zum Ende des letzten Monats.',
          },
          endOfMonth: {
            label: 'Ende des Monats',
            hint: 'Der Benefit wird zum Ende des aktuellen Monats deaktiviert.',
          },
          custom: {
            label: 'Eigenes Enddatum festlegen',
            hint: 'Wählen Sie unten den letzten Monat, in dem der Mitarbeiter den Benefit noch nutzen kann.',
          },
        },
        endDate: 'Enddatum',
      },
      changeOptions: {
        info: 'Wählen Sie unten die neuen Optionen des aktuellen Benefits. Diese gelten ab dem nächstmöglichen Termin für alle gewählten Mitarbeiter.',
      },
      errorModal: {
        title: 'Änderung konnte nicht durchgeführt werden',
        text: 'Für folgende Mitarbeiter kann die Änderung leider nicht übernommen werden, bitte entfernen Sie sie aus der Auswahl und versuchen Sie es erneut:',
      },
      pauseForm: {
        hint: 'Falls der Mitarbeiter den Benefit schon genutzt hat, kann er frühestens zum Ende des aktuellen Monats pausiert werden, ansonsten ist auch eine Pausierung zum Ende des letzten Monats möglich. Das Enddatum ist in der Pausierung eingeschlossen.',
        text: 'Wählen Sie, in welchem Zeitraum Sie den Benefit pausieren möchten:*',
      },
      editActivationsResultDialog: {
        messageTitle: 'Achtung',
        downloadButton: 'Liste herunterladen',
        csvHeaderFirstName: 'Vorname',
        csvHeaderLastName: 'Nachname',
        csvHeaderMail: 'E-Mail',
        csvHeaderEmployeeNumber: 'Personalnummer',
        csvHeaderDepartment: 'Abteilung',
        csvHeaderExternalId: 'Externe ID',
        csvHeaderStartDate: 'Vertragsstart',
        csvHeaderEndDate: 'Vertragsende',
        contractUntil: 'Vertrag bis {{date}}',
      },
      deactivateResultDialog: {
        title: 'Hinweis: Angepasste Deaktivierungsdaten',
        message:
          '{{count}} Mitarbeiter haben einen aktiven Vertrag. Das Deaktivierungsdatum wurde auf das Vertragsende verschoben. Laden Sie die Liste der betroffenen Mitarbeiter herunter.',
        csvFilename: 'angepasste-deaktivierungsdaten.csv',
      },
      deactivateBlockedDialog: {
        title: 'Deaktivierung nicht möglich',
        message:
          '{{count}} Mitarbeiter haben einen aktiven Vertrag, daher konnte die Deaktivierung nicht erfolgen. Laden Sie die Liste der betroffenen Mitarbeiter herunter.',
        csvFilename: 'deaktivierung-blockiert.csv',
      },
      pauseResultDialog: {
        title: 'Pausieren nicht möglich',
        message:
          '{{count}} Mitarbeiter haben einen aktiven Vertrag, daher konnte das Pausieren nicht erfolgen. Laden Sie die Liste der betroffenen Mitarbeiter herunter. Die Deaktivierung kann im Tab "Benefit deaktivieren" erfolgen.',
        csvFilename: 'pausierung-blockiert.csv',
      },
    },
    editDialog: {
      title: 'Aktivierung bearbeiten',
      noEditable: 'Kein Mitarbeiter gefunden, für den der Benefit aktualisiert werden kann.',
      deactivateError: 'Benefit konnte nicht deaktiviert werden',
      deactivateSomeErrors: 'Benefit deaktiviert, {{errorCount}} übersprungen',
      deactivateSuccess: 'Benefit erfolgreich deaktiviert',
      pauseError: 'Benefit konnte nicht pausiert werden',
      pauseSomeErrors: 'Benefit pausiert, {{errorCount}} übersprungen',
      pauseSuccess: 'Benefit erfolgreich pausiert',
      updateError: 'Mitarbeiter konnte nicht aktualisiert werden',
      updateSomeErrors: 'Mitarbeiter aktualisiert, {{errorCount}} übersprungen',
      updateSuccess: 'Mitarbeiter aktualisiert',
      tabs: {
        deactivate: 'Benefit deaktivieren',
        changeOptions: 'Optionen ändern',
        pauseBenefit: 'Benefit pausieren',
      },
      resultMessageTitle: 'Achtung',
      deactivateResultDialog: {
        title: 'Hinweis: Angepasstes Deaktivierungsdatum',
        message: 'Der Mitarbeiter hat einen aktiven Vertrag. Das Deaktivierungsdatum wurde auf {{date,monthAndYear}} verschoben.',
      },
      deactivateBlockedDialog: {
        title: 'Deaktivierung nicht möglich',
        message: 'Der Mitarbeiter hat einen aktiven Vertrag, daher konnte die Deaktivierung nicht erfolgen.',
      },
      pauseResultDialog: {
        title: 'Pausieren nicht möglich',
        message:
          'Der Mitarbeiter hat einen aktiven Vertrag, daher konnte das Pausieren nicht erfolgen. Die Deaktivierung kann im Tab "Benefit deaktivieren" erfolgen.',
      },
    },
    LUNCH: {
      title: 'Essenszuschuss',
      since: 'Seit',
      unlimited: 'Unbegrenzt',
      overview: '$t(benefitsModule:LUNCH.title) Auswertung',
      receipts: 'Belege',
      maxDailyLimitError: 'Steuerlich auf {{value,euro}} begrenzt',
      infoTextFull: `Sie können das arbeitstägliche Mittagessen Ihrer Mitarbeiter steuerbegünstigt bezuschussen. Ihre Mitarbeiter können dabei Belege von gekauften Mahlzeiten und Supermarkteinkäufen einreichen, sich als Team gemeinsames Essen liefern lassen oder vor Ort kochen und erhalten mit der Gehaltsauszahlung eine Erstattung.
      <br><br>
      Probonio überprüft alle Essensbelege auf die steuerrechtlichen Anforderungen, berechnet die Erstattungen und archiviert alle Belege. Ihre Mitarbeiter erhalten die Erstattung des Essenszuschusses netto zusammen mit ihrer Gehaltsauszahlung des Folgemonats. Die Übermittlung der Abrechnungsdaten erfolgt dabei automatisiert an Ihr gewünschtes Lohnprogramm, wie z.B. Datev LODAS oder Lexware.
        <br><br>
        <strong>Um die steuerlichen Vorteile des Essenszuschusses zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Für den Essenszuschuss muss eine Zusatzvereinbarung zum Arbeitsvertrag erfolgen.</li>
        <li>Der Essenszuschuss kann durch die 15-Tage-Regel an maximal 15 Arbeitstagen gewährt werden. Im Zuge der 15-Tage-Regelung fällt der Anspruch von Teilzeitbeschäftigten unter Umständen geringer aus.</li>
        <li>Der maximale steuerfreie Erstattungsbetrag pro Tag liegt bei {{lunchDailyLimit, euro}} (= {{lunchMonthlyLimit, euro}} pro Monat).</li>
        <li>Zur Erstattung der Belege müssen Mitarbeiter einen vollständigen und lesbaren Beleg ihres Mittagessens einreichen (z.B. Foto eines Supermarktbelegs).</li>
        <li>Der Essenszuschuss für Mitarbeiter, die durchschnittlich mehr als 3 Tage pro Monat oder bis zu 3 Monate pro Jahr ihre Tätigkeit nicht vor Ort ausführen, unterliegt den Bedingungen des Verpflegungsmehraufwands. Hierfür lässt sich Probonio jedoch nicht verwenden.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Essenszuschuss',
        appSpecific: 'App Essenszuschuss',
      },
      fields: {
        mealsPerMonth: 'Mahlzeiten / Monat',
        perMeal: '€ / Mahlzeit',
        maxAmount: 'Höchstbetrag',
        flatRateTaxation: 'Maximale Erstattung',
        flatRateTaxationOn: 'Ja',
        flatRateTaxationOff: 'Nein',
        taxationType: {
          SIMPLE_TAXATION: 'Pauschalversteuerung komplett vermeiden',
          FLAT_RATE_TAXATION: 'Maximale Erstattung nutzen (empfohlen)',
        },
        salaryConversation: 'Entgeltumwandlung (Gehaltsumwandlung)',
      },
      settings: {
        title: 'Einstellungen für Belegupload',
        info: 'Hier können Sie festlegen, bis zu welchem Tag des Monats Ihre Mitarbeiter Belege hochladen können. Wählen Sie einen Tag vor Ende des aktuellen Monats, falls Sie Ihre Lohnabrechnung zum aktuellen Monatsende abschließen müssen.<br/><br/>Der automatische Versand des Lohndaten-Reports erfolgt aufgrund der Belegprüfung 4 Tage nach dem gewählten Tag. Fällt dieser Termin auf ein Wochenende, verschiebt sich der Versand auf den übernächsten Werktag.',
        successToast: 'Änderungen wurden gespeichert',
        periodCloseDelay: {
          title: 'Spätestes Datum des Beleguploads',
          info: 'Wählen Sie, je nach Anforderung, einen Tag zum Ende des aktuellen Monats oder Start des Folgemonats. Der Belegupload ist immer bis zum Ende des Geschäftstages (EOB) möglich.',
          currentMonth_one: '{{count}} Tag vor Monatsende',
          currentMonth_other: '{{count}} Tage vor Monatsende',
          endOfMonth: 'Zum Ende des Monats',
          nextMonth: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_one: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_two: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_few: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_other: 'Bis zum {{count}}. Tag des Folgemonats',
        },
      },
    },
    MOBILITY: {
      title: 'Mobilität',
      subTitle: 'Auswertung',
      overview: '$t(benefitsModule:MOBILITY.title) Auswertung',
      receipts: 'Belege',
      infoTextFull: `Sie können Ihre Mitarbeiter bei ihrer täglichen Mobilität mit einem steuerfreien bzw. flexiblen Mobilitätsbudget unterstützen. Um das Mobilitätsbudget zu nutzen, können Ihre Mitarbeiter Rechnungsbelege für die Nutzung von verschiedenen Mobilitätsformen einreichen.
      <br><br>
      Ihre Mitarbeiter erhalten die Erstattung ihrer Mobilitätskosten zusammen mit ihrer Gehaltsauszahlung des Folgemonats. Die Übermittlung der Abrechnungsdaten erfolgt dabei automatisiert an Ihr gewünschtes Lohnprogramm, wie z.B. Datev LODAS oder Lexware.
      <br><br>
      <strong>Für die steuerfreie bzw. flexible Nutzung des Mobilitätsbudgets gelten folgende Regelungen:</strong>
        <ul>
        <li>Mit dem steuerfreien Mobilitätsbudget können Mitarbeiter den öffentlichen Nahverkehr für private und berufliche Fahrten und den öffentlichen Fernverkehr für berufliche Fahrten steuerfrei nutzen.</li>
        <li>Auch das Deutschlandticket können Arbeitgeber steuerfrei erstatten.</li>
        <li>Mit dem flexiblen Mobilitätsbudget können Mitarbeiter alle Arten von Mobilität flexibel, jedoch <strong>nicht steuerfrei</strong> nutzen.</li>
        <li>Das Mobilitätsbudget lässt sich generell sowohl monatlich als auch jährlich zur Verfügung stellen.</li>
        <li>Zur Erstattung der Kosten müssen Mitarbeiter einen vollständigen und lesbaren Beleg ihrer genutzten Mobilität einreichen, welchen wir für Sie auf Korrektheit prüfen.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Mobilität',
        appSpecific: 'App Mobilität',
      },
      fields: {
        monthlyLimit: 'Betrag',
        taxationType: {
          TAXABLE: 'Flexibles Mobilitätsbudget',
          TAX_FREE: 'Steuerfreier Mobilitätszuschuss',
        },
        taxationTypeColumn: 'Flexible Mobilität',
      },
    },
    INTERNET: {
      title: 'Internetpauschale',
      subTitle: 'Auswertung',
      overview: '$t(benefitsModule:INTERNET.title) Auswertung',
      receipts: 'Nutzung',
      downloadReceipt: 'Bestätigung herunterladen',
      infoTextFull: `Sie können Ihre Mitarbeiter bei ihren privaten laufenden Internetkosten im eigenen zuhause unterstützen. Hierbei spielt es keine Rolle, ob Ihre Mitarbeiter im Homeoffice oder direkt vor Ort arbeiten oder für welche Zwecke das Internet genutzt wird. Während die Internetpauschale von Arbeitgebern mit 25% pauschal versteuert wird, müssen Mitarbeiter für den Zuschuss weder Steuern noch Sozialversicherungsbeiträge bezahlen.
      <br><br>
      Bis zu dem monatlichen Betrag von 50€ reicht es aus, wenn Mitarbeiter eine Erklärung zu den Gebühren ihrer laufenden Internetkosten abgeben. Die jährliche Bestätigung dieser Erklärung wird automatisch über die Probonio-App eingeholt, wodurch für Arbeitgeber hier kein Verwaltungsaufwand anfällt.
      <br><br>
      Da für Mitarbeiter für den Zuschuss keine Abgaben anfallen, erhalten sie die Erstattung der Internetpauschale netto zusammen mit ihrer Gehaltsauszahlung des Folgemonats. Die Übermittlung der Abrechnungsdaten erfolgt dabei automatisiert an Ihr gewünschtes Lohnprogramm, wie z.B. Datev LODAS oder Lexware.
      <br><br>
        <strong>Um die steuerlichen Vorteile der Internetpauschale zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Die Erstattung der Internetkosten erfolgt zusätzlich zum Gehalt.</li>
        <li>Mitarbeiter müssen für den Zuschuss weder Steuern noch Sozialversicherungsbeiträge bezahlen, weshalb dieser für sie komplett steuerfrei ist.</li>
        <li>Arbeitgeber versteuern die laufenden Internetkosten bis zu einem monatlichen Freibetrag von 50€ bzw. 600€ jährlich mit pauschal 25%. Die Pauschalversteuerung können Arbeitgeber ggf. aber auch an den Mitarbeiter übertragen, was Sie in Ihrem entsprechendem Lohnbuchhaltungssystem konfigurieren können.</li>
        <li>Die Kosten können vom Arbeitgeber nur bis nur bis zur tatsächlich aufgewendeten Höhe pauschal besteuert werden.</li>
        <li>Der Internetzuschuss kann nur gewährt werden, wenn die Kosten für die Internetverbindung vom Mitarbeiter selbst und nicht von anderen Personen getragen werden.</li>
        <li>Bei Vertragsänderungen muss der Arbeitgeber informiert werden.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Internetpauschale',
        appSpecific: 'App Internetpauschale',
      },
      fields: {
        monthlyBudget: 'Max. Betrag',
      },
    },
    KITA: {
      title: 'Kita-Zuschuss',
      fields: {
        monthlyBudget: 'Betrag',
      },
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Kita-Zuschuss',
        appSpecific: 'App Kita-Zuschuss',
      },
      infoTextFull: `<strong>Unterstützen Sie Ihre Mitarbeiter finanziell bei den laufenden Kosten für die Kinderbetreuung.</strong>  Dabei spielt es keine Rolle, ob die Betreuung in einer Kita, bei einer Tagespflegeperson oder in einer ähnlichen Einrichtung erfolgt. Mitarbeiter müssen lediglich verbindlich in der App ihre tatsächlichen monatlichen Betreuungskosten bestätigen. Zusätzliche Nachweise zu den Betreuungskosten – z. B. Vertragsunterlagen oder Zahlungsbelege – können bei Bedarf direkt in der Probonio-App für Mitarbeiter oder im Arbeitgeber-Portal hochgeladen werden.       
      <br><br>
       Der steuerfreie Zuschuss wird mit dem Gehalt des Folgemonats ausgezahlt. Die Übermittlung an Ihr Lohnprogramm (z. B. DATEV LODAS oder Lexware) erfolgt automatisch.
        <br><br>
        <strong>Um die steuerlichen Vorteile des Kita-Zuschuschusses zu nutzen, gelten folgende Regelungen:</strong>
      <ul>
       <li>Die Erstattung der Betreuungskosten erfolgt zusätzlich zum Gehalt.</li>
      <li>Für den Zuschuss fallen weder Steuern noch Sozialversicherungsbeiträge an – er ist für Mitarbeiter vollständig steuerfrei.</li>
      <li>Der Kita-Zuschuss kann nur gewährt werden, wenn die Betreuungskosten tatsächlich von dem Mitarbeiter selbst getragen werden.</li>
      <li>Ändern sich die Betreuungskosten, ist der Arbeitgeber darüber zu informieren.</li>
      </ul>`,
      intervals: 'Nutzung',
      documentTypes: {
        CONTRACT: 'Vertrags- und Kostennachweise',
        PAYMENT_OVERVIEW: 'Zahlungsnachweise',
        OTHER: 'Sonstiges',
      },
      menu: {
        info: 'Laden Sie hier relevante Dokumente für den Kita-Zuschuss Ihrer Mitarbeiter hoch.',
        button: 'Dokument hochladen',
        dialog: {
          title: 'Kita-Zuschuss Dokument-Upload',
          upload: 'Datei auswählen',
          employee: 'Mitarbeiter *',
          documentName: 'Dokumentname',
          documentType: 'Dokumenttyp',
          success: 'Upload erfolgreich',
          tooltip: {
            CONTRACT: 'z.B. Betreuungsvertrag, Vertragszusätze, Kostenbescheinigung',
            PAYMENT_OVERVIEW:
              'z.B. Quittungen über bezahlte Gebühren, Banküberweisungsnachweise, Jahresbescheinigungen über bezahlte Gebühren',
            OTHER: 'z.B. Nachweise über öffentliche Teilförderungen, Nachweis über Arbeitgeberzuschuss bei Direktzahlung an die Kita',
          },
        },
      },
      tables: {
        intervals: {
          title: 'Nutzung',
          employee: 'Mitarbeiter',
          startDate: 'Beantragt am',
          refund: 'Zuschuss',
        },
        documents: {
          title: 'Dokumente',
          employee: 'Mitarbeiter',
          documentType: 'Dokumenttyp',
          documentName: 'Dokumentname',
          uploadDate: 'Hochgeladen am',
          actions: {
            download: 'Herunterladen',
            delete: 'Löschen',
            deleteTooltip: 'Nur selbst hochgeladene Dokumente können gelöscht werden',
            deleteConfirmTitle: 'Dokument löschen',
            deleteConfirmHint: 'Sind Sie sicher, dass Sie das ausgewählte Dokument löschen möchten?',
            deleteSuccess: 'Dokument wurde gelöscht',
          },
        },
      },
    },
    BAV: {
      title: 'Betriebliche Altersvorsorge',
      subTitle: 'Freischaltung für Mitarbeiter',
      contracts: 'Verträge',
      contractDetails: 'Vertrag von {{name}}',
      overview: '$t(benefitsModule:BAV.title) Konfiguration',
      infoTextFull: `Sie können als Arbeitgeber Ihre Mitarbeiter mit einem steuerbegünstigten Zuschuss zur betrieblichen Altersvorsorge unterstützen. Mit dieser Betriebsrente erhalten Ihre Mitarbeiter einen zusätzlichen Beitrag im Rentenalter und profitieren von Steuervorteilen.
      <br><br>
      Durch Probonio können Ihre Mitarbeiter sich selbst über die Vorteile der bAV informieren und eine anbieterunabhängige Beratung mit unseren bAV-Experten per App buchen. Die Kosten für die bAV können Mitarbeiter direkt in der App kalkulieren und erhalten so eine genaue Aufstellung der finanziellen Konditionen. Zudem lassen sich alle Infos und Dokumente zum laufenden Vertrag jederzeit in der Probonio-App einsehen.
      <br><br>
        <strong>Für das Angebot einer betrieblichen Altersvorsorge gelten folgende Regelungen:</strong>
        <ul>
        <li>Arbeitgeber sind gesetzlich dazu verpflichtet, einen Vertrag für eine betriebliche Altersvorsorge in Form einer Entgeltumwandlung für ihre Mitarbeiter abzuschließen, sofern diese den Wunsch danach äußern.</li>
        <li>Im Falle einer Entgeltumwandlung sind Arbeitgeber dazu verpflichtet, mindestens 15% der Beiträge Ihrer Mitarbeiter zu bezuschussen.</li>
        <li>Seit 2023 kann pro Mitarbeiter ein zusätzlicher sozialversicherungsfreier Zuschuss in Form der Entgeltumwandlung von maximal 292€ monatlich, sprich 3.504€ pro Jahr, gewährt werden.</li>
        <li>Bis zu einem monatlichen Beitrag zur betrieblichen Altersvorsorge von 584€ monatlich, sprich jährlich 7.008€, fällt keine Lohnsteuer an.</li>
        <li>Die Höhe der steuer- und sozialversicherungsfreien Beiträge variiert jährlich, da sie an die Beitragsbemessungsgrenze für die Rentenversicherung angepasst werden.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Betriebliche Altersvorsorge',
        appSpecific: 'App Betriebliche Altersvorsorge',
      },
      fields: {
        additionalPaymentPercent: '% Zuzahlung',
        vwlConversion: 'VWL Umwandlung',
      },
    },
    COUPONS: {
      availableTitle: '{{count}} Gutschein Anbieter für diese Konfiguration verfügbar',
      availableTitleWithAmount: '{{count}} Gutschein-Anbieter für den Betrag von {{amount,euro-float}} verfügbar',
      available: 'Verfügbar:',
      unavailable: 'Nicht verfügbar:',
      split: 'Durch Kombination verfügbar:',
      title: 'Sachbezug',
      infoTitle: 'Gutscheine',
      infoTextFull: `Sie können Ihren Mitarbeitern über den Sachbezug monatlich bis zu 50 Euro zur Verfügung stellen. Das Budget kann bei einer Vielzahl von Partnern von Probonio eingelöst werden.
<br><br>
      <strong>Aufmerksamkeiten</strong> 
          <br/>
          Sie können Ihren Mitarbeitern mit dem Modul für Aufmerksamkeiten ein steuerfreies Geschenk zu besonderen persönlichen Anlässen über den Sachbezug bereiten. Die Mitarbeiter können sich dabei einen gewünschten Gutschein unserer Gutscheinpartner auswählen. Über die Aufmerksamkeit können Ihre Mitarbeiter dann die Gutscheine in der Probonio-App für verschiedene Angebote und Produkte des ausgewählten Gutscheinpartners einlösen.
          <br/><br/>
          <strong>Um die steuerlichen Vorteile der Aufmerksamkeiten zu nutzen, gelten folgende Regelungen:</strong>
          <ul>
          <li>Die Aufmerksamkeit muss zusätzlich zum Gehalt erfolgen und darf dementsprechend auch nicht in Form einer Gehaltsumwandlung ausgegeben werden.</li>
          <li>Die Aufmerksamkeit muss zeitnah zum persönlichen Anlass erfolgen.</li>
          <li>Beim persönlichen Anlass muss es sich um besondere Ereignisse im Leben des Mitarbeiters handeln, wie bspw. um Geburtstage, Jubiläen oder die Geburt eines Kindes. Weihnachten und andere Feiertage können deshalb <strong>nicht</strong> als persönlicher Anlass gewertet werden.</li>
          <li>Es sollten jährlich nicht mehr als 3 Aufmerksamkeiten pro Mitarbeiter verschenkt werden.</li>
          <li>Es können auch im selben Monat mehrere Aufmerksamkeiten verschenkt werden.</li>
          <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
          </ul>
          `,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Sachbezug',
        appSpecific: 'App Sachbezug',
      },
      infoTextFullWithFitness: `
        <strong>Gutscheine</strong> 
        <br/>Sie können Ihren Mitarbeitern über den Sachbezug monatlich bis zu 50 Euro als Gutscheinbudget zur Verfügung stellen. Das Budget kann bei einer Vielzahl von Gutscheinpartnern von Probonio eingelöst werden.
        <br/><br/>
        Um Ihren Mitarbeitern die Gutscheine anzubieten, lässt sich das Gutschein-Budget mit nur wenigen Klicks aufladen und jederzeit flexibel anpassen. Durch die standardgemäße Einstellung zur automatischen Aufladung, erhalten Sie jeden Monat automatisch eine Rechnung für die Kosten, die im nächsten Monat anfallen.
        <br><br>
        Aus steuerrechtlichen Gründen müssen Gutscheine den Mitarbeitern immer im entsprechenden Monat zufließen. Ansonsten würde das Guthaben für Ihre Mitarbeiter verfallen. Um zu vermeiden, dass Guthaben für Ihre Mitarbeiter verfällt, ist standardmäßig ein automatischer Gutscheinzufluss für Ihre Mitarbeiter eingestellt. Sollte ein aktiver Mitarbeiter daher bis zum Ende des Monats noch keinen Gutschein gewählt haben und ebenso keine automatische Auswahl getroffen sein, erhält er automatisch einen von Ihnen festgelegten Gutschein.
        <br/><br/>
          <strong>Um die steuerlichen Vorteile der Sachbezugsgutscheine zu nutzen, gelten folgende Regelungen:</strong>
          <ul>
          <li>Die Gutscheine müssen zusätzlich zum Gehalt erfolgen und dürfen dementsprechend auch nicht in Form einer Gehaltsumwandlung ausgegeben werden.</li>
          <li>Ihre Mitarbeiter müssen ihren Gutschein im entsprechenden Monat in der Probonio-App auswählen. Den Zeitpunkt, bis wann Ihre Mitarbeiter einen Gutschein auswählen dürfen, können Sie jederzeit unter den Einstellungen konfigurieren. Den Steuerreport erhalten Sie am darauffolgenden Tag oder spätestens am 01. des Folgemonats.</li>
          <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
          </ul>
          <br/><br/>`,
      fields: {
        monthlyBudget: 'Betrag',
        nonCashBenefits: 'Art des Sachbezugs',
      },
      deadlineActivationWarning:
        'Das Bestelldatum für Gutscheine ist bereits überschritten. Es wird empfohlen, die Aktivierung erst ab dem Folgemonat zu starten.',
    },
    FITNESS: {
      title: 'Firmenfitness',
      grantBenefit: 'Firmenfitness für Mitarbeiter freischalten',
      amountHint: 'Firmenfitness ist nur für einen Mindestbetrag von 25 €, 40 € oder maximal 50 € verfügbar',
    },
    AT_LUNCH: {
      title: 'Essenszuschuss',
      maxDailyLimitError: 'Steuerlich auf {{value,euro}} begrenzt',
      changePlaceInfo: 'Bitte beachten Sie, dass diese Änderungen nicht für bestehende Arbeitstage gelten.',
      payrollReport: {
        info: 'Durch das Herunterladen des Lohndatenexports wird die Zuweisung der Arbeitstage zu den Essensbelegen unveränderbar. Bitte stellen Sie sicher, dass alle Daten korrekt sind, bevor Sie fortfahren.',
      },
      receipts: { title: 'Belege' },
      fields: {
        place: {
          title: 'Zulässige Belege',
          RESTAURANT: 'Belege für Essen von inländischen Gaststätten und zugehörige Lieferdienste (bis {{money, euro}})',
          SUPERMARKET: 'Belege für Lebensmittel von inländischen Anbietern (bis {{money, euro}}) ',
        },
        dailyLimit: 'Betrag / Arbeitstag',
      },
      settings: {
        title: 'Einstellungen',
        info: 'Konfigurieren Sie die Gültigkeit von Arbeitstagen.',
        example: 'Mit der aktuellen Konfiguration kann der Arbeitstag vom {{day}} bis zum {{expiration}} eingelöst werden.',
        successToast: 'Änderungen wurden gespeichert',
        atLunchDayExpiryMonths: {
          title: 'Gültigkeit von Arbeitstagen',
          info: 'Stellen Sie ein nach wie vielen Monaten der Arbeitstag verfällt. Arbeitstage verfallen immer zum Monatsende.',
          unit: 'Monate zum Ende des Monats',
        },
        atLunchFiscalYearEnd: {
          title: 'Ende des Geschäftsjahres',
          info: 'Hier können Sie einen Zeitpunk einstellen, zu welchem die gesammelten Arbeitstage für ein Geschäftsjahr spätestens verfallen.',
        },
        fiscalYearHint:
          'Das Ende des Geschäftsjahres und die Fristen für den Belegupload können in den <0>Unternehmenseinstellungen</0> konfiguriert werden.',
      },
      days: {
        title: 'Arbeitstage',
        table: {
          name: 'Name',
          mail: 'E-Mail',
          employeeNumber: 'P. Nr.',
          date: 'Datum',
          expirationDate: 'Einlösbar bis',
          amount: 'Betrag',
          usedAmount: 'Verwendet',
          placeTitle: 'Zulässige Belege',
          place: {
            SUPERMARKET: 'Gaststätte, Restaurant, Supermarkt, Imbiss',
            RESTAURANT: 'Gaststätte, Restaurant',
          } satisfies Record<ATLunchDayListElementDTOPlaceEnum, string>,
        },
        import: {
          upload: 'Hochladen',
          success: '{{createdCount}} Arbeitstage erfolgreich importiert',
          noChanges: 'Keine Änderungen notwendig',
          skipMissing: 'In der Datei nicht vorhandene Tage löschen.',
          template: 'Ausgefüllte Vorlage',
          state: {
            IMPORT_FAILED: 'Import ist in $t(benefitsModule:AT_LUNCH.days.import.line) abgebrochen. Überprüfen Sie die Import-Datei.',
            NO_VALID_LINES: 'Keine validen Zeilen gefunden.',
            SOME_VALID_LINES: 'Ungültige Zeilen werden beim Import übersprungen.',
          },
          dryRun: {
            notDeleted: '{{count}} können nicht gelöscht werden ',
            createdCount: '{{count}} werden erstellt ',
            deletedCount: '{{count}} werden gelöscht ',
          },
          result: {
            notDeleted: '{{count}} wurden nicht gelöscht ',
            createdCount: '{{count}} wurden erstellt ',
            deletedCount: '{{count}} wurden gelöscht ',
          },
          title: 'Arbeitstage importieren',
          info: 'Importieren Sie die Arbeitstage Ihrer Mitarbeiter. Diese Tage werden als Budget für den Essenszuschuss verwendet. Es können nur Arbeitstage für Mitarbeiter importiert werden, die zum Datum des Arbeitstages einen aktiven Essenszuschuss haben.',
          hint: 'Importieren Sie die Arbeitstage Ihrer Mitarbeiter',
          line: 'Zeile {{line}}',
          summary: 'Zusammenfassung',
          errorLineCount_one: 'Es wurde {{count}} Problem erkannt',
          errorLineCount_other: 'Es wurden {{count}} Probleme erkannt',
          errorCount: '{{count}} Probleme gefunden',
          errorReason: {
            INVALID_DATE: 'Ungültiges Datum',
            MISSING_EMPLOYEE: 'Kein passender Mitarbeiter gefunden',
            MISSING_ACTIVATION: 'Mitarbeiter hat keinen aktiven Essenszuschuss',
          } satisfies Record<ATLunchLineErrorDTOLineErrorsEnum, string>,
        },
      },
      infoTextFull: `Gemeinsames Essen verbindet – auch Ihr Team! Mit dem Essenszuschuss von Probonio genießt Ihre Belegschaft täglich steuerfreie Vorteile, die sie überall einlösen können: ob beim Mittagessen in der Gaststätte, beim Lieferdienst oder beim Einkauf im Supermarkt.
      <br><br>
     Als Arbeitgeber entschieden Sie sich für eine der beiden möglichen Varianten:
        <ul>
        <li>Bis zu {{supermarketLimit, euro}} pro Arbeitstag für Einkäufe im Lebensmittelhandel.</li>
        <li>Bis zu {{restaurantLimit, euro}} pro Arbeitstag für Mahlzeiten in Gaststätten oder zugehörigen Lieferdiensten.</li>
        </ul>
        Pro Arbeitstag entsteht ein steuerfreier Betrag, der wie auf einem Sparkonto gesammelt werden kann. Mitarbeiter bezahlen ihre Mahlzeiten oder Einkäufe zunächst selbst, laden die Belege über die Probonio-App hoch und nach Prüfung wird der Betrag im nächstmöglichen Gehaltslauf rückerstattet. So lässt sich das Guthaben flexibel einsetzen – ob täglich für den schnellen Snack oder gebündelt für ein größeres Essen im Restaurant. 
Das Essensguthaben ist flexibel nutzbar und passt sich dem Alltag der Mitarbeiter im Rahmen der Arbeitgeberrichtlinien an – vom Restaurantbesuch über die Pizza im Home-Office bis zum Wochenendeinkauf. <br/> <br/>
Nicht erstattungsfähig sind Alkohol, Tabakwaren, Non-Food-Artikel, Pfand oder Trinkgeld.`,
    },
    AT_MOBILITY: {
      title: 'Öffi-Ticket',
      receipts: { title: 'Belege' },
      fields: {
        budgetPeriod: 'Budgetzeitraum',
        monthlyLimit: 'Monatliches Limit',
        yearlyLimit: 'Jährliches Limit',
        refundType: 'Rückerstattungsart',
        refundTypeOptions: {
          MONTHLY: 'Aliquot',
          MONTHLY_SHORT: 'Monat',
          YEARLY: 'Einmalig',
          YEARLY_SHORT: 'Jahr',
        },
        yearlyRefundWarning:
          'Bei der Rückerstattungsart „Einmalig" wird das gesamte Jahresbudget in einem Betrag erstattet — unabhängig davon, ob der Mitarbeiter erst im Laufe des Jahres eingetreten ist oder das Unternehmen vor Jahresende verlässt. Bitte beachten Sie die möglichen lohnsteuerlichen Auswirkungen.',
        refundTypeChangeInfo:
          'Ein Wechsel der Rückerstattungsart berücksichtigt keine bereits geleisteten Zahlungen im laufenden Jahr. Der Mitarbeiter erhält das neue Budget in voller Höhe — unabhängig davon, was bisher ausbezahlt wurde.',
        allowGroupTickets: {
          label: 'Familien- & Gruppentickets erlaubt',
        },
      },
      infoTextFull: `Sie können Ihre Mitarbeiter bei ihrer täglichen Mobilität mit einem steuerfreien Jobticket unterstützen. Um das Mobilitätsbudget zu nutzen, können Ihre Mitarbeiter Rechnungsbelege für die Nutzung von öffentlichen Verkehrsmitteln einreichen.
      <br><br>
      Ihre Mitarbeiter erhalten die Erstattung ihrer Mobilitätskosten zusammen mit ihrer Gehaltsauszahlung des Folgemonats. Die Rückerstattung kann entweder als Einmalbetrag oder aliquot über den Zeitraum der Gültigkeitsdauer des Tickets erfolgen.
      <br><br>
      Die Übermittlung der Abrechnungsdaten erfolgt dabei an Ihr gewünschtes Lohnprogramm.
      <br><br>
      Für die steuerfreie bzw. flexible Nutzung des Mobilitätsbudgets gilt die gestzliche Grundlage gemäß <risLink>§ 26 Z 5 lit. b EStG 1988</risLink> sowie die Lohnsteuerrichtlinie <findokLink>LStR Rz 750a ff</findokLink> in tagesaktueller Fassung.
      <br><br>
      Bitte beachten Sie mögliche lohnsteuerliche Auswirkungen, falls das Beschäftigungsverhältnis während der Gültigkeitsdauer endet und bereits eine Rückerstattung stattgefunden hat.`,
      settings: {
        title: 'Einstellungen für Belegupload',
        info: 'Hier können Sie festlegen, bis zu welchem Tag des Monats Ihre Mitarbeiter Belege hochladen können.',
        successToast: 'Änderungen wurden gespeichert',
        refundTypeHint:
          'Diese Einstellung hat nur Auswirkung, wenn für das jeweilige Budget die Rückerstattungsart „Aliquot" gewählt ist. Bei „Einmalig" wird der Uploadschluss über das Ende des Geschäftsjahres und die Frist für den Belegupload gesteuert, die in den <0>Unternehmenseinstellungen</0> konfiguriert werden können.',
        periodCloseDelay: {
          title: 'Spätestes Datum des Beleguploads',
          info: 'Wählen Sie, je nach Anforderung, einen Tag zum Ende des aktuellen Monats oder Start des Folgemonats. Der Belegupload ist immer bis zum Ende des Geschäftstages (EOB) möglich.',
          currentMonth_one: '{{count}} Tag vor Monatsende',
          currentMonth_other: '{{count}} Tage vor Monatsende',
          endOfMonth: 'Zum Ende des Monats',
          nextMonth: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_one: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_two: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_few: 'Bis zum {{count}}. Tag des Folgemonats',
          nextMonth_ordinal_other: 'Bis zum {{count}}. Tag des Folgemonats',
        },
      },
    },
    COUPONS_V2: {
      title: 'Sachbezug Flex, Aufmerksamkeiten & Sachzuwendungen nach 37b',
      infoTextFull: `
      <strong>Sachbezug Flex</strong> 
      <0 /><br>
      Sie können Ihren Mitarbeitern über den Sachbezug monatlich bis zu 50 Euro als Gutscheinbudget zur Verfügung stellen. Das Budget kann bei einer Vielzahl von Gutscheinpartnern von Probonio eingelöst werden.
      <br><br>
      Durch das Flex Modul können Ihre Mitarbeiter ihr Guthaben in Form von Probonio Gutscheinen ansparen. So müssen sie nicht zwangsläufig jeden Monat einen Gutschein unserer Partner auswählen. Zudem erhalten sie exklusiven Zugriff auf weitere bekannte Gutscheinpartner.
      <br><br>
      Die Rechnungen werden fünf Werktage vor Ende des Monats für den kommenden Monat erstellt und Ihnen automatisch zugesendet. Hierbei ist zu erwähnen, dass die Gutscheine nur bis zum 15. Tag im Monat für den aktuellen Monat konfiguriert werden können.
      <br><br>
        <strong>Um die steuerlichen Vorteile der Sachbezugsgutscheine zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Die Gutscheine müssen zusätzlich zum Gehalt erfolgen und dürfen dementsprechend auch nicht in Form einer Gehaltsumwandlung ausgegeben werden.</li>
        <li>Ihre Mitarbeiter müssen ihren Gutschein nicht im entsprechenden Monat in der Probonio-App auswählen, sondern können dies auch erst später tun und so für größere Anschaffungen sparen.</li>
        <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
        </ul>
        <br><br>
        <strong>Aufmerksamkeiten</strong> 
        <0 /><br>
        Sie können Ihren Mitarbeitern mit dem Modul für Aufmerksamkeiten ein steuerfreies Geschenk zu besonderen persönlichen Anlässen über den Sachbezug bereiten. Die Mitarbeiter können sich dabei einen gewünschten Gutschein unserer Gutscheinpartner auswählen. Über die Aufmerksamkeit können Ihre Mitarbeiter dann die Gutscheine in der Probonio-App für verschiedene Angebote und Produkte des ausgewählten Gutscheinpartners einlösen.
        <br><br>
        <strong>Um die steuerlichen Vorteile der Aufmerksamkeiten zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Die Aufmerksamkeit muss zusätzlich zum Gehalt erfolgen und darf dementsprechend auch nicht in Form einer Gehaltsumwandlung ausgegeben werden.</li>
        <li>Die Aufmerksamkeit muss zeitnah zum persönlichen Anlass erfolgen.</li>
        <li>Beim persönlichen Anlass muss es sich um besondere Ereignisse im Leben des Mitarbeiters handeln, wie bspw. um Geburtstage, Jubiläen oder die Geburt eines Kindes. Weihnachten und andere Feiertage können deshalb <strong>nicht</strong> als persönlicher Anlass gewertet werden.</li>
        <li>Es sollten jährlich nicht mehr als 3 Aufmerksamkeiten pro Mitarbeiter verschenkt werden.</li>
        <li>Es können auch im selben Monat mehrere Aufmerksamkeiten verschenkt werden.</li>
        <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
        </ul>
        <br><br>
        <strong>Sachzuwendungen nach 37b</strong> 
        <0 /><br>
        Sie können Ihren Mitarbeitern nach § 37b EStG Geschenke als Sachzuwendungen bis zu einem Wert von 10.000 Euro jährlich gewähren und diese mit 30% pauschal versteuern. Dadurch haben Arbeitgeber die Möglichkeit, größere Geschenke an Arbeitnehmer über 60 Euro steuerbegünstigt zu verschenken. Die Sachzuwendung erhalten Ihre Mitarbeiter in Form von Probonio Gutscheinen, die flexibel zu einem beliebigen Zeitpunkt bei unseren Gutscheinpartnern eingelöst werden können.
      <br><br>
      Die pauschal versteuerten Geschenke können zusätzlich zum 50 Euro Sachbezug und zu Aufmerksamkeiten erfolgen. Zudem ist im Gegensatz zu den Aufmerksamkeiten kein besonderer persönlicher Anlass des Mitarbeiters erforderlich, um die Steuervorteile nutzen zu können.
      <br><br>
      Wichtig ist, dass die Sachzuwendung entsprechend in der Lohnabrechnung angegeben wird. Wir senden Ihnen hierfür eine monatliche Abrechnung als Import-Datei für das Lohnprogramm Ihrer Wahl zu. Lohnbuchhalter oder Steuerberater können die relevanten Daten mit wenigen Klicks in das verwendete Lohnprogramm importieren, so dass die Sachzuwendungen automatisch auf der Gehaltsabrechnung erscheinen.
      <br><br>
      <strong>Um die steuerlichen Vorteile der Aufmerksamkeiten zu nutzen, gelten folgende Regelungen:</strong>
      <ul>
      <li>Die Sachzuwendung muss zusätzlich zum Gehalt erfolgen und darf dementsprechend auch nicht in Form einer Gehaltsumwandlung ausgegeben werden.</li>
      <li>Die Sachzuwendung kann nicht über eine andere Möglichkeit nach § 40 Abs. 2 EStG pauschal versteuert werden.</li>
      <li>Die Sachzuwendung wird nicht von einer anderen Pauschalierungsregel beeinflusst.</li>
      <li>Die Sachzuwendung fällt nicht unter die Regelungen der steuerfreien Sachbezüge (50 Euro Sachbezug und Aufmerksamkeiten).</li>
      <li>Die Sachzuwendung liegt nicht überwiegend im eigenbetrieblichen Interesse des Arbeitgebers.</li>
      <li>Ihre Mitarbeiter können die Gutscheine, die i.d.R. 3 Jahre gültig sind, ansparen und später einlösen.</li>
      </ul>`,
      fields: {
        monthlyBudget: 'Betrag',
      },
    },
    GIFTS: {
      title: 'Aufmerksamkeit',
      dialogCreateTitle: 'Neue Aufmerksamkeit hinzufügen',
      dialogEditTitle: 'Aufmerksamkeit bearbeiten',
      completed: 'abgeschlossen',
      paymentFailed: 'unzureichendes Guthaben',
      paymentPending: 'geplant',
      fields: {
        amount: 'Betrag',
        occasion: 'Anlass',
        recurring: 'Diese Aufmerksamkeit soll jährlich wiederholt werden',
        description: 'Nachricht an Ihren Mitarbeiter',
        inviteWhenActive: 'Mitarbeiter einladen, sobald die Aufmerksamkeit fällig wird',
        sendMailWhenActive: 'Mitarbeiter auch per Mail informieren',
      },
      placeHolderInput: {
        inputLabel: 'Nachricht an Ihren Mitarbeiter',
        errorMessage: 'Bitte geben Sie unter 1000 Zeichen ein',
        firstNameChipLabel: 'Vorname',
        lastNameChipLabel: 'Nachname',
      },
    },
    INCENTIVES: {
      title: 'Sachzuwendung 37b',
      dialogCreateTitle: 'Neuen Sachzuwendung 37b hinzufügen',
      dialogEditTitle: 'Sachzuwendung 37b bearbeiten',
      completed: 'abgeschlossen',
      paymentFailed: 'unzureichendes Guthaben',
      paymentPending: 'geplant',
      fields: {
        amount: 'Betrag',
        occasion: 'Anlass',
        recurring: 'Diese Aufmerksamkeit soll jährlich wiederholt werden',
        recurringInfo:
          'Bitte klären Sie mit Ihrem Steuerbüro, ob für Ihren Anwendungsfall eine jährliche Wiederholung eingerichtet werden kann, um die steuerrechtlichen Vorgaben einzuhalten.',
        description: 'Nachricht an Ihren Mitarbeiter',
        inviteWhenActive: 'Mitarbeiter einladen, sobald die Aufmerksamkeit fällig wird',
        sendMailWhenActive: 'Mitarbeiter auch per Mail informieren',
      },
      placeHolderInput: {
        inputLabel: 'Nachricht an Ihren Mitarbeiter',
        errorMessage: 'Bitte geben Sie unter 1000 Zeichen ein',
        firstNameChipLabel: 'Vorname',
        lastNameChipLabel: 'Nachname',
      },
      maxIncentiveAmountWarning:
        'Es dürfen maximal 10.000€ pro Jahr und Mitarbeiter ausgeschüttet werden, diese Auszahlung würde die maximale Summe pro Jahr überschreiten',
      remainingAmountAvailable: 'Restlicher Verfügbarer Betrag: {{money}}',
    },
    BIKE: {
      title: 'Firmenrad',
      subTitle: 'Freischaltung für Mitarbeiter',
      contracts: 'Verträge',
      contractDetails: 'Vertrag von {{name}}',
      overview: '$t(benefitsModule:BIKE.title) Konfiguration',
      otherProvider: 'Andere',
      invalidUrl: 'Die URL muss gültig sein und mit https:// anfangen',
      infoTextFull: `Sie können für Ihre Mitarbeiter ein Firmenrad als nachhaltiges Mobilitätsmittel mieten, kaufen oder leasen. Das Dienstfahrrad können Ihre Mitarbeiter sich frei aussuchen und sowohl für private als auch berufliche Zwecke nutzen.
      <br><br>
      Das Angebot eines Firmenrads ist für Sie und Ihre Mitarbeiter steuerlich begünstigt, wodurch Sie je nach Umsetzung des Angebots einige Kosten sparen können.
      <br><br>
      <strong>Für das Angebot eines Firmenrads gelten folgende Regelungen:</strong>
        <ul>
        <li>Wird das Firmenrad als Gehaltsextra zusätzlich zum ohnehin geschuldeten Lohn angeboten, ist es für Mitarbeiter komplett steuerfrei.</li>
        <li>Wird das Firmenrad als Gehaltsumwandlung angeboten, verringern sich die Sozialversicherungs- und Lohnsteuerbeiträge durch den Abzug der Leasingrate vom Bruttogehalt.</li>
        <li>Nutzen Mitarbeiter das Fahrrad für private Zwecke, muss das Firmenrad als geldwerter Vorteil versteuert werden (seit 2019: Versteuernder Betrag = monatlich 0,25% des Fahrrad-Bruttopreises).</li>
        <li>Fahrräder mit Motorunterstützung von bis zu 45 km/h fallen nicht unter die Regelungen für Diensträder, sondern für Firmenwagen.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Firmenrad',
        appSpecific: 'App Firmenrad',
      },
      fields: {
        employerGrant: 'Arbeitgeberzuschuss',
        employerExtras: 'Welche Leistungen übernehmen Sie zusätzlich?',
        platformName: 'Anbieter',
        platformUrl: 'Anbieterportal-URL',
      },
      employerExtra: {
        INSPECTION: 'Inspektion',
        INSURANCE: 'Versicherung',
      },
    },
    NEWS: {
      title: 'Mitarbeiterkommunikation',
      articleTitle: {
        createTitle: 'Nachricht erstellen',
        modifyTitle: 'Nachricht bearbeiten',
        showTitle: 'Nachricht ansehen ({{status}})',
      },
      articleSubTitle: {
        createSubTitle: 'Neue Nachricht',
        modifySubTitle: 'Vorhandene Nachricht',
      },
      subPage: {
        overview: 'Überblick',
        readConfirmation: 'Lesebestätigung',
        reactions: 'Reaktionen',
      },
      articles: 'Nachricht',
      drafts: 'Entwürfe',
      published: 'Veröffentlicht',
      expired: 'Abgelaufen',
      hintText: 'Sie können hier Nachrichten erstellen, die Ihre Mitarbeiter in der App sehen können.',
      addNewArticlesButton: 'Neue Nachricht erstellen',
      articleCreator: {
        successCreate: 'Nachricht erstellt',
        successUpdate: 'Nachricht aktualisiert',
        successPublish: 'Nachricht veröffentlicht',
        errorPublishDateInPast: 'Der Veröffentlichungszeitpunkt liegt in der Vergangenheit. Bitte wählen Sie einen neuen Zeitpunkt.',
        errorRemovalDateBeforeRelease: 'Der Ablaufzeitpunkt muss nach dem Veröffentlichungszeitpunkt liegen.',
        errorRemovalDateInPast: 'Der Ablaufzeitpunkt muss in der Zukunft liegen.',
        errorTitle: 'Titel ist erforderlich - darf maximal 100 Zeichen lang sein',
        errorPublishDate: 'Veröffentlichungszeit ist erforderlich',
        imageHeader: 'Titelbild',
        imageDescription: 'Dieses Bild wird den Mitarbeitern oben in der Kachel angezeigt.',
        articleHeader: 'Titel und Nachrichtentext',
        reactionsHeader: 'Reaktionen',
        reactionsDescription: 'Hier können Sie festlegen, ob Reaktionen auf die Nachricht erlaubt sind.',
        recipientGroupHeader: 'Empfängerkreis',
        recipientGroupDescription: 'In diesem Schritt können Sie die Empfänger der Nachricht setzen.',
        recipientGroupSendingToggle: 'An alle Mitarbeiter senden',
        recipientGroupSendingPreContinue: 'Mit',
        recipientGroupSendingPostContinue: 'Mitarbeitern fortfahren',
        recipientGroupSendingSavedRecipientsContinue: 'Mit gespeicherten Mitarbeitern fortfahren',
        dispatchTimeHeader: 'Versandzeitpunkt',
        dispatchTimeDescription: 'Hier können sie den Versandzeitpunkt festlegen.',
        completeHeader1: 'Abschließen',
        completeHeader2: 'Zusammenfassung',
        completeHeader3: 'Detailansicht',
        completeSubHeader: 'Überprüfen Sie alle Angaben vor der Veröffentlichung Ihrer Nachricht.',
        completeDescription: 'In diesem Schritt können Sie alle Angaben überprüfen und die Nachricht veröffentlichen.',
        nextStep: 'Weiter',
        previousStep: 'Zurück',
        yes: 'Ja',
        no: 'Nein',
        receivedFrom: 'Gesendet an ({{count}})',
        scheduledFor: 'Geplant für ({{count}})',
        confirmedBy: 'Hinweis: {{count}} Mitarbeiter haben die Nachricht schon gelesen & bestätigt.',
        confirmedByOne: 'Hinweis: {{count}} Mitarbeiter hat die Nachricht schon gelesen & bestätigt.',
        confirmedByEditing:
          'Hinweis: {{count}} Mitarbeiter haben die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Lesebestätigungen zurückgesetzt.',
        confirmedByEditingOne:
          'Hinweis: {{count}} Mitarbeiter hat die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Lesebestätigung zurückgesetzt.',
        confirmedByEditingBoth:
          'Hinweis: {{count}} Mitarbeiter haben die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Lesebestätigungen und Reaktionen zurückgesetzt.',
        confirmedByEditingBothOne:
          'Hinweis: {{count}} Mitarbeiter hat die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Lesebestätigung und Reaktionen zurückgesetzt.',
        confirmedByEditingReactions:
          'Hinweis: {{count}} Mitarbeiter haben die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Reaktionen zurückgesetzt.',
        confirmedByEditingReactionsOne:
          'Hinweis: {{count}} Mitarbeiter hat die Nachricht schon gelesen & bestätigt. Durch das Aktualisieren werden die Reaktionen zurückgesetzt.',
        resetConfirmations: 'Lesebestätigungen zurücksetzen',
        resetConfirmationsSuccess: 'Lesebestätigungen wurden zurückgesetzt',
        resetReactions: 'Reaktionen zurücksetzen',
        resetReactionsSuccess: 'Reaktionen wurden zurückgesetzt',
        resetPartialFailure: 'Artikel wurde gespeichert, aber das Zurücksetzen ist fehlgeschlagen.',
        showMore: 'Zeige weitere Mitarbeiter an',
        showLess: 'Zeige weniger Mitarbeiter an',
        usedFilters: 'Angewendete Filter',
        searchTextFilter: 'Gesuchter Text',
        costCenterFilter: 'Kostenstelle',
        departmentFilter: 'Abteilung',
        workLocationFilter: 'Arbeitsstätte',
        benefitFilter: 'Benefit',
        articleDescription: 'Hier können Sie den Titel und den Text Ihrer Nachricht setzen.',
        settingsHeader: 'Nachrichteneinstellungen',
        settingsDescription:
          'Allgemeine Einstellungen zur Veröffentlichung und Rückzug einer Nachricht. Bei keiner Änderung der Veröffentlichungszeit wird die Nachricht sofort veröffentlicht.',
        publishArticle: 'Nachricht veröffentlichen',
        saveAsDraft: 'Als Entwurf speichern',
        planArticle: 'Nachricht planen',
        updateArticle: 'Nachricht aktualisieren',
        clearStartDateTooltip: 'Startdatum entfernen',
        clearEndDateTooltip: 'Enddatum entfernen',
        attachments: {
          dialogTitle: 'Anhang hinzufügen',
          header: 'Anhänge',
          description: 'Laden Sie Dateien hoch, die mit dieser Nachricht geteilt werden sollen (max. 10 Dateien, max. 10 MB pro Datei).',
          removeTooltip: 'Anhang entfernen',
          fileSizeError: 'Die Datei darf maximal 10 MB groß sein.',
          limitReached: 'Maximal 10 Anhänge erlaubt.',
        },
      },
      readConfirmationTab: {
        ALL: 'Alle',
        SEEN: 'Noch nicht bestätigt',
        CONFIRMED_SEEN: 'Bestätigt',
        NOT_SEEN: 'Noch nicht gesehen',
        confirmationStatus: 'Bestätigungsstatus',
        downloadConfirmationStatus: 'Lesebestätigungen herunterladen',
        downloadSuccess: 'CSV-Export erfolgreich abgeschlossen',
        filterLabel: 'Status',
        refresh: 'Aktualisieren',
      },
      reactionsTab: {
        columns: {
          reaction: {
            label: 'Reaktion',
          },
          createdAt: {
            label: 'Erstellt am',
          },
        },
      },
      fields: {
        title: 'Titel',
        releaseDateTime: 'Veröffentlichung',
        removalDateTime: 'Ablaufzeitpunkt',
        articleStatus: 'Nachrichtenstatus',
        PUBLISHED: 'Veröffentlicht',
        AVAILABLE: 'Bereit zur Veröffentlichung',
        DRAFT: 'Entwurf',
        EXPIRED: 'Abgelaufen',
        noResults: 'Keine Nachrichten vorhanden',
        editPublishedDisabled: 'Veröffentlichte Nachrichten können nicht bearbeitet werden',
        deleteButton: 'Nachricht löschen',
        confirmDelete: 'Sind Sie sicher, dass Sie die ausgewählte Nachricht löschen möchten?',
        expireButton: 'Nachricht zurücknehmen',
        confirmExpire:
          'Sind Sie sicher, dass Sie die ausgewählte Nachricht zurücknehmen möchten? Sie erhält den Status abgelaufen und wird für die Mitarbeiter in der App nicht mehr sichtbar sein.',
        deleteArticleSuccess: 'Nachricht wurde gelöscht',
        expireArticleSuccess: 'Veröffentlichung zurückgenommen',
      },
      labels: {
        image: 'Bild hochladen',
        title: 'Titel',
        description: 'Text',
        releaseDate: 'Veröffentlichungszeit:',
        removalDate: 'Ablaufzeitpunkt:',
        toBePublished: 'Soll veröffentlicht werden',
        readConfirmation: 'Lesebestätigung',
        enableReactions: 'Reaktionen zulassen',
        enableReactionsTooltip: 'Wenn aktiviert, können Mitarbeitende in der App mit einem Emoji auf die Nachricht reagieren.',
        readConfirmationReminder: 'Benachrichtigungshäufigkeit',
        confirmationNotificationWEEKLY: 'Wöchentlich erinnern',
        confirmationNotificationMONTHLY: 'Monatlich erinnern',
        confirmationNotificationNONE: 'Keine Erinnerung schicken',
        publishNow: 'Jetzt veröffentlichen',
      },
    },
    FLEX: {
      title: 'Flex Budget',
      infoTextFull: `Sie können Ihre Mitarbeiter über das Probonio Flex Budget mit der maximalen Flexibilität bei der Benefit-Nutzung unterstützen. Innerhalb des festen Flex Budgets können Ihre Mitarbeiter den Essenszuschuss, die Internetpauschale und das flexible Mobilitätsbudget nutzen und so das verfügbare Budget nach individuellem Bedarf auf die verschiedenen Benefits verteilen.
        <br/><br/>
        Ihre Mitarbeiter erhalten die Erstattung ihrer Kosten zusammen mit ihrer Gehaltsauszahlung des Folgemonats. Die Übermittlung der Abrechnungsdaten erfolgt dabei automatisiert an Ihr gewünschtes Lohnprogramm, wie z.B. Datev LODAS oder Lexware. 
        <br/><br/>
        <strong>Für die Nutzung des Flex Budgets gelten folgende Regelungen:</strong>
        <ul>
          <li>Der Essenszuschuss kann durch die 15-Tage-Regel an maximal 15 Arbeitstagen gewährt werden. Der maximale steuerfreie Erstattungsbetrag pro Tag liegt bei {{lunchDailyLimit, euro}} (= {{lunchMonthlyLimit, euro}} pro Monat).</li>
          <li>Arbeitgeber können laufende Internetkosten bis zu einem monatlichen Freibetrag von 50€ bzw. 600€ jährlich mit 25% pauschal versteuern.</li>
          <li>Mit dem flexiblen Mobilitätsbudget können Mitarbeiter alle Arten von Mobilität flexibel, jedoch nicht steuerfrei nutzen.</li>
          <li>Zur Nutzung der steuerlichen Vorteile müssen die festgelegten Freigrenzen des Essenszuschusses und der Internetpauschale eingehalten werden. Probonio stellt hierbei die Einhaltung der Freigrenzen sicher.</li>
        </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Flex Budget',
        appSpecific: 'App Flex Budget',
      },
      cardSubtitle: 'Mitarbeiter kann aus den folgenden Benefits flexibel wählen und kombinieren:',
      fields: {
        monthlyBudget: 'Monatl. Budget',
        nonCashBenefits: 'Art des Sachbezuges',
      },
    },
    RECREATION: {
      title: 'Erholungsbeihilfe',
      infoTextFull: `Die Erholungsbeihilfe ist eine Unterstützung, die Arbeitgeber ihren Mitarbeitern zur Erholung gewähren können. 
      Sie kann in Form von Barzuschüssen oder Sachbezügen erfolgen, z.B. wenn der Arbeitgeber einen Vertrag mit einem Hotel abschließt.
      <br/><br/>
      Die steuerliche Behandlung von Erholungsbeihilfen ist jedoch komplex. In der Regel handelt es sich um steuerpflichtigen Arbeitslohn, der jedoch in begrenztem Umfang durch die Möglichkeit der Pauschalversteuerung steuerlich begünstigt ist.
      Steuerpflichtige Erholungsbeihilfen können mit einem festen Pauschsteuersatz von 25 Prozent pauschal besteuert werden, wenn die Beihilfen insgesamt in einem Kalenderjahr 156 Euro für den einzelnen Arbeitnehmer, 104 Euro für dessen Ehegatten und 52 Euro für jedes Kind nicht übersteigen.
      <br/><br/>
      Der Arbeitgeber hat die Pauschalsteuern zu übernehmen, eine Abwälzung ist aber zulässig.
      Die pauschal besteuerten Erholungsbeihilfen sind sozialversicherungsfrei.`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Erholungsbeihilfe',
        appSpecific: 'App Erholungsbeihilfe',
      },
      maxBudgetHint:
        'Der Höchstbetrag errechnet sich aus {{recreationBaseAmount,euro-float}} + {{recreationPartnerAmount,euro-float}} für den Partner (verheiratet oder eingetragene Lebenspartnerschaft) + {{recreationChildAmount,euro-float}} pro Kind. Erhöht sich der Höchstbetrag (z. B. durch Änderung von Familienstand oder Anzahl der Kinder), können Sie das Budget hier manuell anpassen. Verringert sich der steuerliche Höchstbetrag (z.B. durch Änderung von Familienstand) und liegt das aktuell gewährte jährliche Budget darüber, erfolgt die Anpassung automatisch auf den neuen Höchstbetrag.',
      maxBudgetHintMulti:
        'Der Höchstbetrag errechnet sich aus {{recreationBaseAmount,euro-float}} + {{recreationPartnerAmount,euro-float}} für den Partner (verheiratet oder eingetragene Lebenspartnerschaft) + {{recreationChildAmount,euro-float}} pro Kind. Bei der Freischaltung wird für jeden Mitarbeiter automatisch der jeweilige Höchstbetrag als jährliches Budget gesetzt. Das Budget können Sie anschließend individuell in den Details des jeweiligen Mitarbeiters anpassen.',
      individualBudget: 'individuell nach MA',
      fields: {
        civilStatus: 'Familienstand',
        numberOfKids: 'Anzahl Kinder',
        yearlyBudget: 'Jährl. Budget',
      },
    },
    CUSTOM: {
      fields: {
        monthlyGrant: 'Monatl. Betrag',
        supplier: 'Anbieter',
        comment: 'Weitere Informationen',
      },
    },
    BIKELEASING_V2: {
      title: 'Bikeleasing',
      infoTextVideos: {
        managerSpecific: 'Anleitung Bikeleasing in Probonio',
        appSpecific: 'Wie Bikeleasing funktioniert',
      },
      bulkEditDialog: {
        deactivateBlockedDialog: {
          title: 'Deaktivierung nicht möglich',
          message:
            '{{count}} Mitarbeiter haben einen aktiven Vertrag. Die Deaktivierung ist erst möglich, wenn die Verträge beendet wurden. Laden Sie die Liste der betroffenen Mitarbeiter herunter.',
          csvFilename: 'deaktivierung-blockiert.csv',
        },
        pauseResultDialog: {
          title: 'Pausieren nicht möglich',
          message:
            '{{count}} Mitarbeiter haben einen aktiven Vertrag, daher konnte das Pausieren nicht erfolgen. Die Verträge müssen zuerst beendet werden. Laden Sie die Liste der betroffenen Mitarbeiter herunter.',
          csvFilename: 'pausierung-blockiert.csv',
        },
      },
      editDialog: {
        deactivateBlockedDialog: {
          title: 'Deaktivierung nicht möglich',
          message: 'Der Mitarbeiter hat einen aktiven Vertrag. Die Deaktivierung ist erst möglich, wenn der Vertrag beendet wurde.',
        },
        pauseResultDialog: {
          title: 'Pausieren nicht möglich',
          message:
            'Der Mitarbeiter hat einen aktiven Vertrag, daher konnte das Pausieren nicht erfolgen. Der Vertrag muss zuerst beendet werden.',
        },
      },
    },
    BIKELEASING: {
      title: 'Bikeleasing',
      infoTextFull: `Mithilfe der Bikeleasing-Integration können Sie das Probonio-Portal mit dem Bikeleasing-Portal verknüpfen.
    <br><br>
    So funktioniert die Verknüpfung:
    <ul>
      <li>Nach der Verknüpfung der Accounts können Sie Ihren Mitarbeitern das Bikeleasing-Benefit freischalten.</li>
      <li>Mitarbeiter, denen das Benefit freigeschaltet ist, sehen in der Probonio-App die gewählten Konditionen.</li>
      <li>Probonio importiert in regelmäßigen Abständen die Mitarbeiterdaten aus dem Bikeleasing-Portal.</li>
      <li>Zur korrekten Zuordnung müssen die Personalnummern in beiden Portalen gepflegt sein.</li>
      <ul>
        <li>Im Probonio-Portal können Sie diese unter dem Punkt "Mitarbeiter" pflegen.</li>
        <li>Im Bikeleasing-Portal ist dies unter "Verträge" möglich - alternativ können die Arbeitnehmer diese selbst pflegen.</li>
      </ul>
      <li>Um die Synchronisierung erneut anzustoßen, klicken Sie den Button "Jetzt synchronisieren" unter dem Punkt "Integration".</li>
    </ul>`,
      infoTextVideos: {
        managerSpecific: 'Arbeitgeber-Portal Bikeleasing',
        appSpecific: 'App Bikeleasing',
      },
      fields: {
        condition: 'Bikeleasing Kondition',
        bikeleasingSecret: {
          label: 'Bikeleasing Secret',
          connectButton: 'Verbinden',
          conflictMessage: 'Dieser Bikeleasing Account ist bereits verknüpft.',
          successMessage: 'Verbindung hinzugefügt',
        },
      },
      addCondition: 'Neue Verbindung hinzufügen',
      deleteCondition: 'Verbindung trennen',
      confirmDeleteCondition:
        'Sind Sie sicher, dass Sie die ausgewählte Verbindung zu Bikeleasing trennen möchten?<br/><br/>Dadurch werden die zugehörigen Informationen aus dem Probonio-System entfernt, und bestehende Benefit-Aktivierungen für Mitarbeiter zum Ende des Vormonats beendet.',
      lastSync: '<strong>Letzte Sychronisierung</strong>: {{date , datetime}}',
      syncErrorDescription: {
        AUTH: 'Probonio konnte sich nicht bei Bikeleasing anmelden. Bitte prüfen Sie im Bikeleasing Portal ob die Verbindung noch verfügbar ist.',
        UNAVAILABLE: 'Konnten Bikleasing nicht erreichen. Bitte versuchen Sie es später erneut',
        INTERNAL: 'Bei der Synchronisation ist ein Fehler aufgetreten.',
      },
      syncError: 'Sync erfolgreich',
      syncSuccess: 'Synchronisierung erfolgreich',
      integrationSubTitle: 'Verbindungen',
      integration: {
        title: 'Integration',
        info: 'Diese Integration ermöglicht es Ihnen, die Stammdaten Ihrer Mitarbeiter und Konditionen direkt von Bikeleasing an Probonio zu übertragen',
        guide: {
          title: 'Sie haben bereits einen Bikeleasing-Account',
          info: {
            title: 'Anleitung',
            description:
              'Verbinden Sie ganz einfach Probonio mit Bikeleasing. Durch die Integration werden in Bikeleasing gepflegte Daten nach Probonio übertragen.',
          },
          howTo: {
            title: 'So verbinden Sie Ihren Bikeleasing-Account mit dem Probonio Arbeitgeber-Portal',
            description: `Um das Bikeleasing Portal mit dem Probonio Arbeitgeberportal zu verbinden, müssen Sie diese paar Schritte befolgen:`,
            stepByStep: `<ol>
            <li>Melden Sie sich bei Bikeleasing unter <0>dieser Adresse</0> an und navigieren Sie zur Seite <strong>Weitere Benefits</strong></li>
            <li>Auf dieser Seite müssen Sie die Datenschutzerklärung akzeptieren und auf <strong>Account verknüpfen</strong> klicken.</li>
            <li>Nun erhalten Sie einen <strong>Firmencode</strong> und ein <strong>Client Secret</strong>, welche Sie in Ihre Zwischenablage kopieren können und auf dieser Seite unterhalb eintragen. Drücken Sie daraufhin auf verbinden, werden alle Bikeleasing Konditionen und Verträge zu Probonio synchronisiert.</li>
            </ol>`,
          },
        },
        bikeleasingPortal: 'Jetzt Kunde werden',
        form: {
          companyCode: 'Arbeitgeber-Code',
          externalId: 'BL-Nutzer-ID',
          bikeleasingSecret: 'Client Secret',
          connect: 'Verbinden',
          connectionError: 'Anmeldung bei Bikeleasing API fehlgeschlagen',
        },
      },
      connectNow: 'Gleich gehts los verbinden Sie nur noch Ihren Bikeleasing-Account!',
      noAccount: {
        title: 'Sie haben noch keinen Bikeleasing-Account',
        info1:
          'Als Probonio-Kunde wissen Sie, wie Sie Ihr Team mit steuerfreien Benefits begeistern und Ihr Employer Branding stärken können',
        info2:
          'Ein besonders beliebter Benefit ist das Dienstrad-Leasing, das dank steuerlicher Förderung und der Möglichkeit zur Gehaltsumwandlung besonders attraktiv ist. Mit dem Bikeleasing-Service können Sie und Ihr Team ganz einfach und ohne Risiko von diesen Vorteilen profitieren.',
      },
      advantages: {
        title: 'Ihre Vorteile beim Dienstrad-Leasing mit dem Bikeleasing-Service',
        lessCosts: {
          title: 'Weniger Kosten',
          description: 'Dank steuerlicher Förderung und Gehaltsumwandlung sparen Arbeitgeber und Beschäftigte.',
        },
        climateFriendly: {
          title: 'Mehr Nachhaltigkeit',
          description: 'Mit Dienstrad-Leasing fördern Sie umweltfreundliche und gesunde Mobilität in Ihrem Unternehmen.',
        },
        security: {
          title: 'Umfassende Absicherung',
          description: 'Kündigung, Krankheit oder Elternzeit Ihrer Mitarbeiter sind ebenso abgesichert wie Diebstahl, Unfallschäden & Co.',
        },
      },
      createNow: {
        title: 'Jetzt Bikeleasing-Kunde werden',
        description: 'Registrieren Sie sich jetzt, um Ihr Team schon bald mit dem Dienstrad-Angebot des Bikeleasing-Service zu begeistern.',
      },
      questions: {
        title: 'Sie haben Fragen zum Bikeleasing-Service?',
        description:
          'Kontaktieren Sie das Bikeleasing-Team gerne per E-Mail an {{mail}} oder telefonisch unter {{tel}}. Mehr Informationen rund um das Dienstrad-Leasing finden Sie unter <0> {{web}} </0>',
      },
      companyCode: 'Arbeitgeber-Code',
      conditionDetailDialog: {
        alert: 'Sie benötigen mindestens eine Verbindung mit einem Bikeleasing-Konto.',
        alertAction: 'Verbindungen',
        noOptions: 'Keine Konditionen verfügbar',
        title: 'Arbeitgebercode : {{companyCode}} - Konditionen',
      },
      leasingDurationInMonths: 'Leasingdauer in Monaten',
      allowedBikeTypes: 'Fahrradarten',
      maxNumberOfBikesPerEmployee: 'max. Anzahl Fahrräder/Mitarbeiter',
      minPurchasePrice: 'Fahrradmindestwert (Brutto)',
      maxPurchasePrice: 'Fahrradhöchstwert (Brutto)',
      employerContribution: 'Arbeitgeberanteil',
      priceRestrictions: {
        maxTotalPurchasePriceForAllBikes: 'Maximalbetrag/Mitarbeiter (Brutto)',
      },
      contracts: 'Verträge',
      contractIntro: 'Die Daten des abgeschlossenen Bikeleasing-Vertrags werden unten angezeigt.',
      contractAppInfo: 'Die Daten sind für den Mitarbeiter in der Probonio-App einsehbar.',
      contractDetails: 'Vertrag von {{name}}',
      contractsTable: {
        noResults: 'Keine Einträge vorhanden',
        header: {
          name: 'Mitarbeiter',
          startDate: 'Leasingbeginn',
          endDate: 'Leasingende',
          contractNumber: 'Vertragsnummer',
          bike: 'Fahrrad',
          status: 'Status',
        },
      },
      contract: {
        status: {
          EmployeeApprovalRequired: 'Deine Freigabe erforderlich',
          EmployerApprovalRequired: 'Freigabe Arbeitgeber erforderlich',
          ChangeRequested: 'Änderung beantragt',
          CancelledOrRejected: 'Storniert/Abgelehnt',
          CancellationPending: 'Stornierung ausstehend',
          EmployerApprovalDone: 'Freigabe Arbeitgeber erfolgreich',
          BikeTransferRequired: 'Radübergabe erforderlich',
          BikeTransferDone: 'Radübergabe erfolgreich',
          Active: 'Aktiv',
          Expiring: 'Auslaufend',
          Finished: 'Beendet',
          Requested: 'Beantragt',
          BikeShipped: 'Rad versendet',
          fallback: 'Unbekannt',
        },
        contractNumber: 'Vertragsnummer',
        trailerRecommendedRetailPrice: 'Anhänger UVP',
        recommendedRetailPrice: 'UVP',
        purchasePrice: 'Kaufpreis',
        employerContribution: 'Arbeitgeberzuschuss',
        salaryConversion: 'Gehaltsumwandlung',
        leasingDuration: 'Leasing Dauer',
        benefitInKind: 'Geldwerter Vorteil',
        insuranceCoverage: 'Versicherungsschutz',
        startDate: 'Beginn',
        transferDate: 'Übergabe-Datum',
        leasingRate: 'Leasing-Rate',
        endDate: 'Ende',
        brand: 'Marke',
        model: 'Modell',
        frameSize: 'Rahmengröße',
        items: 'Accessories',
        lockBrand: 'Schlossmarke',
      },
      section: {
        contract: 'Vertragsdaten',
        leasing: 'Leasing',
        bike: 'Fahrraddaten',
        benefits: 'Ihre Leistungen',
      },
    },
    CREDIT_CARD: {
      title: 'Sachbezugskarte',
      subTitle: 'Kreditkarten',
      infoTextFull: `Mit der Sachbezugskarte können Sie Ihren Mitarbeitern ein monatliches Budget von bis zu 50 Euro zur Verfügung stellen. Die Karte kann bei Einkäufen flexibel bei allen Mastercard-Akzeptanzstellen innerhalb der ausgewählten Region eingesetzt werden.
        <br/><br/>
        Dabei gilt
        <ul>
        <li>Die Karte ist eine Zusatzleistung zum Gehalt (keine Gehaltsumwandlung) und kann alternativ zu digitalen Gutscheinen oder Firmenfitness gewählt werden.</li>
        <li>Das Guthaben auf der Karte kann beliebig lange angespart werden und muss nicht bis zum jeweiligen Abrechnungsdatum ausgegeben werden.</li>
        <li>Die Karte kann flexibel bei über 1,2 Mio. Mastercard-Akzeptanzstellen deutschlandweit genutzt werden, innerhalb des definierten Einsatzgebiets.</li>
        <li>Die Bestellung der Karte erfolgt durch den Arbeitgeber. Die Karte und die PIN werden per Post an die Mitarbeiter geschickt.</li>
        <li>Die Karte kann in Apple Pay und Google Wallet übertragen werden.</li>
        <li>Eine Barauszahlung ist ausgeschlossen. Die Karte ist eine Prepaid-Karte.</li>
        <li>Nutzung als Plastikkarte und digital (Apple/Google Pay) – auch für Mitarbeiter ohne App geeignet (Mit dem Code auf der Rückseite der physischen Karte kann über eine extra App die Karte digitalisiert auf dem Handy gespeichert werden).</li>
        </ul>`,
      tab: {
        activeCards: 'Aktive Karten',
        allCards: 'Alle Karten',
        charging: 'Budgetaufladung',
      },
      cardsTable: {
        noResults: 'Keine Kreditkarten vorhanden',
        header: {
          cardIBAN: 'IBAN',
          status: 'Status',
          balance: 'Guthaben',
          createdAt: 'Bestellt am',
          expiryDate: 'Ablaufdatum',
          deliveryMode: 'Liefermodus',
        },
        status: {
          ACTIVE: 'Aktiv',
          ORDERED: 'Bestellt',
          EXPIRED: 'Abgelaufen',
          PENDING: 'Angelegt',
          ERROR: 'Fehler',
        },
        deliveryMode: {
          COMPANY_ADDRESS: 'Firmenadresse',
          PERSONAL_ADDRESS: 'Privatadresse',
        },
      },
      chargeNotificationsTable: {
        noResults: 'Es wurden noch keine Aufladungen durchgeführt',
        header: {
          createdAt: 'Datum',
          billingMonth: 'Abrechnungsmonat',
          totalAmount: 'Aufladungsbetrag',
          chargeItemsCount: 'Anzahl Mitarbeiter',
          chargeItems: 'Einzelbeträge',
        },
        column: {
          billingMonth: '{{date,monthAndYear}}',
        },
      },
      chargeAccountHint: {
        title: 'Budget-Aufladung für Sachbezugskarten',
        info: `Bitte überweisen Sie den fälligen Betrag jeweils zum Monatsende, um eine rechtzeitige Aufladung der Karten für den Folgemonat sicherzustellen.
          Über die fällige Aufladung werden Sie auch per E-Mail benachrichtigt. Beachten Sie, dass die Verbuchung Ihrer Aufladung bis zu 5 Werktage in Anspruch nehmen kann.
          <br/><br/>
          Verwenden Sie für die Überweisung folgende Daten:
          <ul>
          <li><b>IBAN</b>: {{chargingAccountIBAN}}</li>
          <li><b>BIC</b>: {{chargingAccountBIC}}</li>
          <li><b>Kreditinstitut</b>: {{chargingAccountBankName}}</li>
          <li><b>Betrag</b>: {{amountText}}</li>
          <li><b>Verwendungszweck</b>: {{billingMonthText}}</li>
          </ul>`,
        infoAmount: '{{amount,euro}}',
        infoAmountMissing: 'Aufladebetrag, der Ihnen in der Benachrichtigungs-Mail mitgeteilt wurde',
        infoBillingMonth: '{{billingMonth,monthAndYear}}',
        infoBillingMonthMissing: '(Monat und Jahr)',
      },
      orderCards: {
        title: 'Kreditkarten bestellen',
        description:
          'Hier können Sie Kreditkarten für Ihre Mitarbeiter bestellen. Die Karten werden in der Regel innerhalb von 5 Werktagen geliefert. Die Kosten für die Karten betragen 10 Euro pro Karte, die Ihnen nach der Bestellung in Rechnung gestellt werden. <br/><br/>Bitte beachten Sie, dass die Karten nur für Mitarbeiter mit eingetragener Personalnummer und gültiger Adresse bestellt werden können.<br/><br/>Legen Sie zuerst die Verfügungsmöglichkeit fest, bevor Sie die Mitarbeiter auswählen. <br/> Die Verfügungsmöglichkeit bestimmt, in welchen Postleitzahl-Gebieten die Sachbezugskarte genutzt werden kann. Diese regionale Einschränkung ist notwendig, damit der steuerfreie Sachbezug korrekt angewendet werden kann.',
        stepLabel: {
          employees: 'Mitarbeiter auswählen',
          deliveryMode: 'Lieferadresse',
          summary: 'Bestellung abschließen',
        },
        searchLabel: 'Verfügungsmöglichkeit auswählen',
        searchPlaceholder: 'Suche nach Region oder PLZ-Bereich',
        noOptions: 'Keine Ergebnisse',
        pleaseSearch: 'Suchbegriff eingeben',
        selectVariantError: 'Bitte wählen Sie eine Verfügungsmöglichkeit aus',
        selectableEmployeesHint:
          'Beachten Sie, dass nur Mitarbeiter mit eingetragener Personalnummer, gültiger Adresse und Geburtsdatum für die noch keine Kreditkarte bestellt ist, auswählbar sind.',
        summaryInfo:
          'Nachfolgend finden Sie eine Zusammenfassung Ihrer Bestellung.<br/><br/>Klicken Sie auf <strong>Bestellung abschließen</strong>, um die Kreditkarten zahlungspflichtig zu bestellen.<br/><br/>Beachten Sie, dass die Aktivierung der Karten bis zu 5 Werktage in Anspruch nehmen kann.',
        summary: 'Zusammenfassung',
        noEmployeesWarning:
          'Es wurden keine Mitarbeiter für die Bestellung gefunden. Beachten Sie, dass für die Bestellung eine eingetragene Personalnummer, gültige Adresse und Geburtsdatum erforderlich ist.<br/><br/>Bitte korrigieren Sie Ihre Auswahl im vorigen Schritt.',
        summaryFields: {
          employeeCount: 'Anzahl Kreditkarten',
          deliveryMode: 'Lieferadresse',
        },
        finished: {
          someErrors: 'Es wurden Kreditkarten für {{successCount}} Mitarbeiter bestellt, {{errorCount}} wurden übersprungen.',
          error: 'Ihre Bestellung konnte nicht aufgegeben werden. Bitte versuchen Sie es erneut, oder wenden Sie sich an unseren Support.',
          success: 'Ihre Bestellung wurde erfolgreich aufgegeben.',
        },
        actions: {
          next: 'Weiter',
          previous: 'Zurück',
          order: 'Bestellung abschließen',
        },
        deliveryMode: {
          label: 'Lieferadresse',
          PERSONAL_ADDRESS: 'Privatadresse des Mitarbeiters',
          PERSONAL_ADDRESS_description: 'Die Karte wird direkt an die Privatadresse des Mitarbeiters gesendet.',
          COMPANY_ADDRESS: 'Firmenadresse',
          COMPANY_ADDRESS_description: 'Die Karte wird an die Firmenadresse gesendet.',
        },
      },
      budgetPanel: {
        cards: 'Karten',
        budget: 'Budget',
        orderCardsButton: 'Karten bestellen',
        activeCards: 'Aktive Karten',
        currentBudget: 'Aktuelles Guthaben',
        openCharges: 'Offene Aufladungen',
        remainingBudget: 'Verbleibendes Guthaben',
        missingBudget: 'Fehlendes Guthaben',
        nextMonthForecast: 'Voraussichtliches Guthaben',
        lastSync: '<strong>Aktualisiert:</strong> {{date,datetime}}',
        infoButtonLabel: 'Konto & Aufladungen',
        infoDialog: {
          title: 'Konto & Aufladungen',
          chargeOverviewTab: 'Aufladungsübersicht',
          accountInfoTab: 'Kontoinformationen',
          currentMonthTitle: 'Dieser Monat',
          nextMonthTitle: 'Nächster Monat (Prognose)',
          accountHolder: 'Kontoinhaber',
          iban: 'IBAN',
          ibanMissing: 'Nicht hinterlegt',
          amountNextCycle: 'Betrag nächster Zyklus',
          deadlineNextCycle: 'Frist nächster Zyklus',
          openAmount: 'Offener Betrag',
          escrowInfo:
            'Dieses Konto ist ein Treuhandkonto. Ihr Unternehmen ist Empfänger des Guthabens. Die Gelder werden treuhänderisch für Ihr Unternehmen verwaltet.',
        },
      },
    },
    DISCOUNT_CODE: {
      title: 'Mitarbeiterrabatte',
      activatedTitle: 'Mitarbeiterrabatte, die begeistern – kostenlos für Arbeitgeber.',
      activatedDescription:
        'Ihre Mitarbeiter erhalten Zugang zu exklusiven Rabattcodes von über 200 Top-Marken – von bekannten Namen wie RTL+, Tchibo oder New Balance bis hin zu nachhaltigen Brands wie Flixtrain, Koro oder Avocadostore. Über 1.000 € Ersparnis pro Jahr für Ihre Mitarbeiter – Die Freischaltung erfolgt komplett kostenlos und ohne zusätzlichen Verwaltungsaufwand für Sie als Arbeitgeber.<br><br>Einfach starten. Mehrwert schaffen. Mitarbeiter begeistern.',
      header: 'Das neue Probonio Benefit – Exklusive Rabatte für Ihre Mitarbeiter, komplett kostenlos für Arbeitgeber',
      discountAmountTitle: '5% bis 50% Rabatt',
      discountAmountDescription: 'Flexible Rabatte, feste Beträge oder kostenlose Probemonate',
      freeForEmployersTitle: 'Kostenlos für Arbeitgeber',
      freeForEmployersDescription: 'Komplett kostenfrei. Einfache Integration in Ihr bestehendes Probonio System',
      allInTheAppTitle: 'Alles in der App',
      allInTheAppDescription: 'Mitarbeiter sehen alle Rabatte und Anbieter direkt in ihrer Probonio-App',
      howItWorks: `So funktioniert's`,
      automaticRedemptionTitle: 'Automatische Einlösung',
      automaticRedemptionDescription: 'Rabatte werden automatisch über vorhandene Links aufgelöst oder per Code eingelöst',
      fairUseTitle: 'Faire Nutzung',
      fairUseDescription: 'Mitarbeiter können maximal 5 Codes pro Tag abrufen',
      discountTypes: 'Rabatt-Arten',
      fixedAmounts: 'Feste Beträge',
      freeTrials: 'Kostenlose Probemonate',
      popularBrands: 'Beliebte Marken im Angebot',
      plus100More: '+ 100 weitere',
    },
    CAR: {
      title: 'JobAuto',
      settings: {
        title: 'Einstellungen',
      },
      activate: {
        alert: {
          infoTitle: 'Company ID anpassen',
          infoDescription:
            'Wenn Sie die Company ID aus Ihrem JobAuto Portal im Probonio Portal anpassen möchten, können Sie dies in den <settings>JobAuto-Einstellungen</settings> vornehmen.',
          title: 'Aktivierung nicht möglich',
          description:
            'Eine Aktivierung ist derzeit noch nicht möglich, weil keine Company ID hinterlegt wurde. Diese können Sie unter den <settings>JobAuto-Einstellungen</settings> ändern.',
        },
      },
      infoTextFull:
        '<p>Mit dem FINN JobAuto können Sie Ihren Mitarbeitern ein Auto-Abo als attraktives und klimafreundliches Benefit anbieten. Das Auto-Abo wird über eine Gehaltsumwandlung ermöglicht; dadurch können Mitarbeiter bis zu 40% gegenüber einem regulären Auto-Abo sparen.</p><p><strong>So funktioniert es:</strong></p><ul><li>Arbeitgeber schließen einen Rahmenvertrag mit FINN ab und legen die Konditionen im FINN-Unternehmensportal fest.</li><li>Mitarbeiter wählen anschließend ihr Fahrzeug und schließen den individuellen Nutzungsvertrag direkt mit FINN ab.</li><li>Die monatlichen Kosten des Auto-Abos werden per Gehaltsumwandlung aus dem Bruttogehalt des Mitarbeiters finanziert.</li><li>Der Benefit ist im Probonio-Portal für Arbeitgeber kostenneutral.</li><li>Mit Care+ sind Arbeitgeber in besonderen Ereignissen zusätzlich abgesichert.</li><li>Arbeitgeber können frei entscheiden, ob ausschließlich E-Fahrzeuge oder auch andere Antriebsarten zur Auswahl stehen.</li></ul>',

      benefitTemplates: {
        editItemDialog: {
          info: 'Wenn Sie die Company ID aus Ihrem JobAuto Portal im Probonio Portal anpassen möchten, können Sie dies in den <settings>Einstellungen</settings> vornehmen.',
        },
      },
      bulkEditDialog: {
        changeOptions: {
          info: ' ',
        },
        pauseForm: {
          text: '<strong>Bitte beachten:</strong> Die Deaktivierung betrifft nur die Anzeige in der Mitarbeiter-App und hat keinen Einfluss auf den laufenden Vertrag. <br>$t(benefitsModule:bulkEditDialog.pauseForm.text)',
        },
        deactivate: {
          mode: {
            info: '<strong>Bitte beachten:</strong> Die Deaktivierung betrifft nur die Anzeige in der Mitarbeiter-App und hat keinen Einfluss auf den laufenden Vertrag. <br>$t(benefitsModule:bulkEditDialog.deactivate.mode.info)',
          },
        },
      },
      info: {
        title: 'JobAuto für Sie als Arbeitgeber',
        description: 'JobAuto - das günstige Auto Abo dank Gehaltsumwandlung',
        learnMore: 'Jetzt mehr erfahren',
        connected: 'Mein Unternehmen ist schon bei JobAuto',
      },
      learnMore: {
        title: 'Begeistern Sie Ihr Team mit FINN | JobAuto',
        description:
          'Als Probonio-Kunde wissen Sie, wie Sie Ihr Team mit steuerfreien Benefits begeistern und Ihr Employer Branding stärken können. Ein besonders beliebter Benefit ist JobAuto von FINN, das dank steuerlicher Förderung und der Möglichkeit zur Gehaltsumwandlung besonders attraktiv ist. Mit JobAuto können Sie und Ihr Team ganz einfach und ohne Risiko von diesen Vorteilen profitieren.',
        save: 'Bis zu 40% Ersparnis auf die monatliche Aborate',
        convert: 'Kostenneutral dank Bruttogehaltsumwandlung',
        select: 'Breite Auswahl an schnell verfügbaren Fahrzeugen',
        reserve: 'Buchung in weniger als 5 Minuten und Haustürlieferung',
        time: 'Flexible Laufzeiten zwischen 6-24 Monaten',
        include: 'Inklusive Versicherung, Steuer, GEZ sowie Wartung und Verschleiß',
        package: 'Umfangreiches Ausfallmanagement für Unerwartetes dank Care+ Paket',
        part: '~30% EV Anteil & CO₂ Kompensation',
      },
      hint: {
        where: {
          title: 'Wo finde ich meine Company ID?',
          description: 'In Ihrem FINN JobAuto Portal unter Einstellungen > Rechnung',
          button: 'Zum Portal',
        },
        customer: {
          title: 'Jetzt JobAuto-Kunde werden',
          description: 'Registrieren Sie sich jetzt, um Ihr Team mit JobAuto von FINN zu begeistern.',
          button: 'Jetzt Kunde werden',
        },
        faq: {
          title: 'Sie haben Fragen zum JobAuto Service?',
          description:
            'Kontaktieren Sie das FINN Team gerne per E-Mail an <email>jobauto@finn.com</email>. Mehr Informationen rundum JobAuto finden Sie unter <site>finn.com/jobauto</site> oder in den <faq>FAQs</faq>.',
        },

        description: 'JobAuto - das günstige Auto Abo dank Gehaltsumwandlung',
      },
      connect: {
        title: 'Company ID bearbeiten',
        description:
          'Hier können Sie Ihre FINN JobAuto-Company ID ändern. Die ID wird automatisch in den Registrierungslink für Mitarbeiter eingefügt, damit diese direkt Ihrem Unternehmen zugeordnet werden.',
        form: {
          name: 'Company ID',
          hint: 'Format: Ganzzahl, 10-12 Stellen',
          error: 'Nur Zahlen mit 10-12 Stellen erlaubt.',
          success: 'Company ID wurde gespeichert',
        },
        alert: {
          title: 'Hinweis',
          description:
            'Nach dem Speichern erhalten Ihre Mitarbeiter bei der Registrierung den aktualisierten Link mit der neuen Company ID. Stellen Sie sicher, dass die ID korrekt ist, bevor Sie die Änderungen speichern.',
        },
      },
    },
    IT_LEASING: {
      title: 'IT-Leasing',
      info: {
        title: 'IT-Leasing für Sie als Arbeitgeber',
        description: 'Haben Sie bereits einen OwnIT@home Account?',
        learnMore: 'Jetzt mehr erfahren',
        connected: 'Mein Unternehmen ist schon bei IT Leasing',
      },
      activate: {
        alert: {
          infoTitle: 'Registrierungslink anpassen',
          infoDescription:
            'Wenn Sie den Registrierungslink aus Ihrem OwnIT@home Portal im Probonio Portal anpassen möchten, können Sie dies in den <settings>IT-Leasing-Einstellungen</settings> vornehmen.',
          title: 'Aktivierung nicht möglich',
          description:
            'Eine Aktivierung ist derzeit noch nicht möglich, weil kein Registrierungslink hinterlegt wurde. Diese können Sie unter den <settings>IT-Leasing-Einstellungen</settings> ändern.',
        },
      },
      infoTextFull:
        "<strong>IT-Leasing mit OwnIT@home</strong><br>Mit OwnIT@home bieten Sie Ihren Mitarbeitern hochwertige IT-Geräte wie Laptops, Tablets. Smartphones u.v.m. steuerlich begünstigt zu nutzen - bis zu 30% Ersparnis sind möglich.<br><br><strong>So funktioniert's:</strong><ul><li>Sie als Arbeitgeber schließen einen Leasing- und Rahmenvertrag als Grundlage für die Bereitstellung des Benefits.</li><li>Ihre Mitarbeiter wählen anschließend ihre Wunschgeräte im Shop aus.</li><li>Die monatlichen Kosten werden über eine steuerfreie Entgeltumwandlung gemäß § 3 Nr. 45 EStG aus dem Bruttogehalt finanziert.</li><li>Für Sie als Arbeitgeber ist der Benefit kostenneutral mit minimalem administrativen Aufwand.</li></ul>",
      bulkEditDialog: {
        changeOptions: {
          info: ' ',
        },
        pauseForm: {
          text: '<strong>Bitte beachten:</strong>  Die Pausierung betrifft nur die Anzeige in der Mitarbeiter-App und hat keinen Einfluss auf den laufenden Vertrag. <br>$t(benefitsModule:bulkEditDialog.pauseForm.text)',
        },
        deactivate: {
          mode: {
            info: '<strong>Bitte beachten:</strong> Die Deaktivierung betrifft nur die Anzeige in der Mitarbeiter-App und hat keinen Einfluss auf den laufenden Vertrag. <br>$t(benefitsModule:bulkEditDialog.deactivate.mode.info)',
          },
        },
      },
      settings: {
        title: 'Einstellungen',
      },
      connect: {
        title: 'Ihr OwnIT@home Konto verbinden',
        description: 'Geben Sie Ihren Registrierungslink aus dem OwnIT@home Portal ein, damit Ihre Mitarbeiter den Benefit nutzen können.',
        form: {
          name: 'Registrierungslink',
          hint: 'Format: https://...',
          error: 'Bitte richtigen Link eingeben',
          success: 'Arbeitgebelink wurde gespeichert',
        },
        saveButton: 'Link hinterlegen',
        alert: {
          title: 'Hinweis',
          description:
            'Nach dem Speichern erhalten Ihre Mitarbeiter bei der Registrierung den aktualisierten Link. Stellen Sie sicher, dass der Link korrekt ist, bevor Sie die Änderungen speichern.',
        },
      },
      learnMore: {
        about: {
          title: 'Was ist OwnIT@home?',
          description:
            'Mit OwnIT@home steht Unternehmen eine kostenneutrale und innovative Möglichkeit zur Verfügung, die Nutzung moderner Technologien nachhaltig zu fördern. Es ermöglicht Ihren Mitarbeitern, hochwertige IT-Geräte wie Laptops, Tablets, Smartphones u.v.m. steuerlich begünstigt zu nutzen - bis zu 30% Ersparnis möglich.',
        },
        howItWorks: {
          title: "Wie funktioniert's?",
          description:
            'Das Programm basiert auf dem Prinzip der Entgeltumwandlung, bei dem ein Teil des Bruttogehalts für die Finanzierung der Geräte verwendet wird. Der große Vorteil: Die private Nutzung dieser Geräte bleibt gemäß § 3 Nr. 45 EStG steuerfrei, sodass sowohl Unternehmen als auch Mitarbeiter profitieren.',
        },
        advantages: {
          title: 'Vorteile für Arbeitgeber',
          first: {
            title: 'Attraktivität als Arbeitgeber:',
            description:
              'Präsentieren Sie sich als fortschrittlichen Arbeitgeber, der seinen Mitarbeitern einen innovativen IT-Benefit bietet und damit deren digitale Entwicklung gezielt fördert.',
          },
          second: {
            title: 'Keine Zusatzkosten',
            description:
              'OwnIT@home ist eine kostenneutrale Lösung, da die Geräte über eine <strong>steuerfreie Entgeltumwandlung</strong> finanziert werden. Auch für Implementierung und Service fallen keine Kosten an.',
          },
          third: {
            title: 'Minimaler administrativer Aufwand',
            description:
              'Die Einrichtung und Verwaltung von OwnIT@home erfolgt vollständig digital über unser benutzerfreundliches Portal.',
          },
        },
      },
      hint: {
        where: {
          title: 'Wo finde ich den Registrierungslink?',
          description: '<ul><li>In Ihrem OwnIT@home Portal unter "Startseite" → "Probonio Anbindung"</li></ul>',
        },
        customer: {
          title: 'Sie haben noch kein OwnIT@home?',
          description: 'Registrieren Sie Ihr Unternehmen und begeistern Sie Ihr Team schon bald mit dem IT-Benefit.',
          button: 'Jetzt Kunde werden',
        },
        faq: {
          title: 'Fragen zu OwnIT@home?',
          description: 'Kontaktieren Sie das OwnIT Team gerne per Mail an <email>hr-support@own-it.de</email>.',
        },
        support: {
          title: 'Haben Sie Probleme?',
          description: 'Kontaktieren Sie den OwnIT Support <supportEmail>hr-support@own-it.de</supportEmail>.',
        },
      },
    },
    WELLPASS: {
      title: 'Firmenfitness',
      subTitle: 'EGYM Wellpass Fitness-Benefit',
      settings: {
        title: 'Einstellungen',
      },
      connect: {
        title: 'Bestehende Wellpass-Mitgliedschaften übertragen',
        description:
          'Wenn Sie EGYM Wellpass bereits nutzen, können Sie bestehende Mitgliedschaften per CSV-Export in Probonio übernehmen. Wir gleichen die Daten mit Ihren Mitarbeitenden ab und speichern die Wellpass-E-Mail-Adresse.',
        steps: {
          export: {
            title: 'Wellpass-Formular ausfüllen',
            description: 'Öffnen Sie das Wellpass-Formular über den Link und schließen Sie den Onboarding-Prozess bei Wellpass ab.',
            button: 'Wellpass-Formular öffnen',
            imageAlt: 'Screenshot: CSV-Export im Wellpass-Portal',
            imageCaption: 'Beispiel: „Übersicht als CSV exportieren“ im Wellpass-Portal.',
          },
          importEmployees: {
            title: 'Mitgliedschaften importieren',
            description: 'Laden Sie die exportierte CSV hoch, um Mitarbeiter zuzuordnen (E-Mail).',
            sections: {
              loginPortal: {
                title: 'Wellpass-Portal öffnen',
                description:
                  'Melden Sie sich im Wellpass-Portal an und navigieren Sie zu <strong>Mitgliedschaftsverwaltung</strong> und exportieren Sie die Mitgliedschaften als CSV.',
                button: 'Zum Portal',
              },
              upload: {
                title: 'CSV hochladen und importieren',
                description:
                  'Laden Sie die exportierte CSV von Wellpass hoch. Probonio ordnet die Mitarbeiter automatisch anhand von Name und Geburtsdatum zu.',
                button: 'CSV hochladen',
                importedBadge: 'Letzter Import am {{date}}',
                importedSummary:
                  'Ergebnis des letzten Imports: {{total}} Zeilen, {{updated}} aktualisiert, {{unchanged}} unverändert, {{notFound}} nicht gefunden, {{notPossible}} nicht möglich.',
                tableHeaderStartDate: 'Beginn',
                tableHeaderActivationStartDate: 'Aktivierungsbeginn',
                tableHeaderEmployeeName: 'Mitarbeiter',
                tableHeaderWellpassEmail: 'Wellpass E-Mail',
                tableHeaderProbonioEmail: 'Probonio E-Mail',
                tableHeaderNewBenefits: 'Neue Benefits',
                tableHeaderStatus: 'Status',
              },
              activate: {
                title: 'Synchronisation aktivieren',
                description:
                  'Damit die Synchronisation zu EGYM Wellpass aktiviert wird und der Benefit genutzt werden kann, müssen Sie die Synchronisation aktivieren. <strong>Dieser Schritt kann nicht rückgängig gemacht werden.</strong>',
                button: 'Synchronisation starten',
                startConfirmTitle: 'Synchronisation jetzt aktivieren?',
                startConfirmDescription:
                  'Damit wird die Synchronisation mit EGYM Wellpass gestartet. <strong>Dieser Schritt kann nicht rückgängig gemacht werden.</strong>',
                startConfirmButton: 'Synchronisation jetzt starten',
                confirmTitle: 'Es gibt Mitarbeitende, die nicht aktiviert werden konnten',
                confirmDescription:
                  'Die folgenden {{count}} Mitarbeitenden konnten beim letzten Import nicht aktiviert werden. Bitte prüfen Sie die Daten, bevor Sie die Synchronisation starten.',
                confirmButton: 'Trotzdem aktivieren',
                tableHeaderName: 'Name',
                tableHeaderEmail: 'E-Mail',
                success: 'Synchronisation erfolgreich aktiviert.',
                error: 'Aktivierung der Synchronisation fehlgeschlagen. Bitte versuchen Sie es erneut.',
              },
            },
          },
        },
        importedEmployees: {
          title: 'Importierte Mitarbeitende',
          description: '{{count}} Mitarbeitende wurden importiert und können nun für Benefits aktiviert werden.',
          empty: 'Es wurden keine Mitarbeitenden importiert.',
        },
        activateImported: {
          button: 'Benefits für importierte Mitarbeitende aktivieren',
          result: '{{success}} aktiviert, {{error}} konnten nicht aktiviert werden',
        },
        sync: {
          enableButton: 'Synchronisation aktivieren',
          enabled: 'Synchronisation aktiviert',
        },
        enrich: {
          title: 'Wellpass-CSV hochladen',
          description:
            'Laden Sie die exportierte CSV von Wellpass hoch (Vorname, Nachname, Geburtsdatum). Probonio versucht automatisch, die Probonio-E-Mail anhand von Name und Geburtsdatum zu ermitteln. Fehlende E-Mails können Sie manuell ergänzen.',
          rowsLoaded: '{{count}} Zeilen geladen.',
          matchButton: 'E-Mails automatisch ermitteln',
          rematchButton: 'Erneut abgleichen',
          proceedButton: 'Weiter zum Import',
          allMatched: 'Alle {{matched}} Mitarbeiter wurden automatisch gefunden.',
          partialMatch: '{{matched}} gefunden, {{ambiguous}} mehrdeutig, {{notFound}} nicht gefunden — bitte manuell ergänzen.',
          error: 'Abgleich fehlgeschlagen. Bitte versuchen Sie es erneut.',
          table: {
            firstName: 'Vorname',
            lastName: 'Nachname',
            birthDate: 'Geburtsdatum',
            startDate: 'Beitrittsdatum',
            probonioMail: 'Probonio E-Mail',
            status: 'Status',
          },
          status: {
            MATCHED: 'Gefunden',
            AMBIGUOUS: 'Mehrdeutig',
            NOT_FOUND: 'Nicht gefunden',
          },
        },
        import: {
          title: 'Wellpass Mitgliedschaften verknüpfen',
          steps: {
            upload: 'CSV hochladen',
            enrich: 'Mitarbeiter abgleichen',
            preview: 'Vorschau',
            done: 'Fertig',
          },
          next: 'Weiter',
          fileSelected: '{{name}} ausgewählt.',
          importSuccess: 'Import abgeschlossen.',
          cancel: 'Abbrechen',
          close: 'Schließen',
          preview: 'Ergebnisse prüfen',
          importNow: 'Jetzt verknüpfen',
          importDisabledAfterSettingsChange:
            'Die Benefit-Einstellungen wurden nach der letzten Prüfung geändert. Bitte zuerst „Erneut prüfen“ ausführen, dann verknüpfen.',
          previewOutdated:
            'Die Benefit-Einstellungen haben sich geändert — die Vorschau unten passt nicht mehr. Bitte „Erneut prüfen“, bevor Sie verknüpfen.',
          statusPreviewOutdated: 'Vorschau veraltet — erneut prüfen',
          ready: '{{count}} Zeilen erkannt. Sie können den Import starten.',
          carrierSettingsPreview: 'Einstellungen für die Benefit-Aktivierungen',
          carrierSettingsHint: 'Diese Optionen gelten für die neuen Benefit-Aktivierungen, die beim Import erstellt werden.',
          noNewActivationRequired: 'Für diesen Import werden keine neuen Benefit-Aktivierungen erstellt.',
          previewAgain: 'Erneut prüfen',
          summary: {
            updated: 'Aktualisiert',
            unchanged: 'Unverändert',
            notFound: 'Nicht gefunden',
            notPossible: 'Nicht möglich (inkl. Budget & Nutzung)',
            ignoredFutureStart: 'Ignoriert (Beginn in 2+ Monaten)',
          },
          errors: {
            parseWithLine: 'Fehler in Zeile {{line}}:',
            missingRequiredField: 'Pflichtfeld fehlt: {{field}}',
            invalidDateFormat: 'Ungültiges Datumsformat. Bitte nutzen Sie z. B. 30.01.2025.',
            duplicateMailInFile:
              '{{column}} „{{email}}“ ist in mehreren Zeilen enthalten (Zeilen {{lines}}). Bitte Duplikate entfernen oder korrigieren.',
            unknown: 'Datei konnte nicht gelesen werden.',
            previewFailed: 'Prüfung fehlgeschlagen. Bitte versuchen Sie es erneut.',
            submitFailed: 'Import fehlgeschlagen. Bitte versuchen Sie es erneut.',
          },
          table: {
            startDate: 'Startdatum Wellpass Mitgliedschaft',
            wellpassMail: 'Wellpass E-Mail',
            probonioMail: 'Probonio E-Mail',
            employee: 'Mitarbeiter',
            activationStartDate: 'Aktiv ab',
            newBenefits: 'Neue Benefits',
            status: 'Status',
            empty: 'Keine Zeilen in dieser Vorschau.',
          },
          status: {
            UPDATED: 'Aktualisiert',
            UNCHANGED: 'Unverändert',
            NOT_FOUND: 'Nicht gefunden',
            NOT_POSSIBLE: 'Nicht möglich',
            NOT_ENOUGH_BUDGET: 'Nicht genügend Budget',
            BLOCKED_BY_USAGE: 'Es wurde bereits {{benefit}} für diesen Monat genutzt.',
            IGNORED_FUTURE_START: 'Ignoriert — Beginn liegt zwei oder mehr Kalendermonate in der Zukunft.',
          },
        },
      },
      info: {
        title: 'EGYM Wellpass für Sie als Arbeitgeber',
        description: 'Bieten Sie Ihren Mitarbeiter Zugang zu einem umfangreichen Sport- und Wellnessangebot mit EGYM Wellpass.',
        learnMore: 'Jetzt mehr erfahren',
        alreadyCustomer: 'Bereits bei EGYM Wellpass registriert',
      },
      learnMore: {
        title: 'Begeistern Sie Ihr Team mit EGYM Wellpass',
        description:
          'Mit EGYM Wellpass erhalten Ihre Mitarbeitenden flexiblen Zugang zu einem Netzwerk aus über 13.500 Sport- und Gesundheitseinrichtungen. Nutzer können über die zugehörige App außerdem Online-Kurse, Live Sessions sowie Yoga- und Meditations-Apps nutzen.',
        liked: 'Beliebtes Benefit zur Stärkung des Employer Brandings',
        config: 'Einfache Verwaltung über das Probonio-Portal',
        flexible: 'Flexibel: zahlreiche Standorte deutschlandweit, monatlich kündbar',
        fitness: 'Zugang zu tausenden Sport- und Wellnessangeboten: Fitnessstudios, Schwimmbäder, Yogastudios, Boulderhallen, u.v.m. ',
        health: 'Förderung von Gesundheit und Wohlbefinden Ihrer Mitarbeitenden',
        team: 'Stärkt die Zufriedenheit Ihres Teams',
      },
      registered: {
        title: 'Sind Sie bereits Kunde bei EGYM Wellpass?',
        description:
          'Wenn Sie bereits Kunde bei EGYM Wellpass sind führen wir Sie durch diesen Migrationsprozess um bestehende Mitgliedschaften nach Probonio zu übertragen.',
      },
      hint: {
        register: {
          title: 'Jetzt bei EGYM Wellpass registrieren',
          description:
            'Registrieren Sie Ihr Unternehmen bei EGYM Wellpass, um Ihrem Team Zugang zu einem umfangreichen Sport- und Wellnessangebot zu ermöglichen.',
          button: 'Jetzt anfragen',
        },
      },
      process: {
        title: 'So funktioniert es',
        step1: {
          titles: {
            title: 'Anfragen & Registrieren',
            done: 'Angefragt & registriert',
          },
          description:
            'Klicken Sie auf den Button “Jetzt anfragen”, um sich bei EGYM Wellpass zu registrieren. Sie werden direkt zu EGYM Wellpass weitergeleitet, um Ihre Registrierung zu starten. Sie können den Status des Prozesses hier nachverfolgen.',
        },
        step2: {
          titles: {
            title: 'Unternehmens-Identifikationsprozess abschließen',
            done: 'Unternehmens-Identifikationsprozess abgeschlossen',
          },
          description:
            'Nach der Anmeldung führt EGYM Wellpass einen Unternehmens-Identifikationsprozess durch. EGYM Wellpass wird entsprechende Unternehmensdaten und relevante Dokumente anfragen.',
        },
        step3: {
          titles: {
            title: 'Konfiguration wird synchronisiert',
            done: 'Konfiguration synchronisiert',
          },
          description:
            'Sobald Ihre Registrierung bei EGYM Wellpass für uns freigegeben wurde, wird die Konfiguration für Sie mit Probonio synchronisiert.',
        },
        step4: {
          titles: {
            title: 'Mitarbeiter verwalten',
            done: 'Mitarbeiter verwalten',
          },
          description:
            'Sobald die Konfiguration abgeschlossen ist, sehen Sie hier die Information “EGYM Wellpass ist aktiv”. Nun können Sie EGYM Wellpass für ausgewählte oder alle Mitarbeiter freischalten.',
        },
      },
      activated: {
        title: 'Konfiguration erfolgreich synchronisiert',
        description:
          'Herzlichen Glückwunsch! Ihr Unternehmen ist nun vollständig mit EGYM Wellpass synchronisiert und bereit für den nächsten Schritt.',
        usageLabel: 'Derzeitige Nutzung',
        usageValue: '{{count}} Mitarbeiter',
        budgetLabel: 'Monatliches Budget',
        budgetValue: '{{amount, euro-float}} / Mitarbeiter',
        registerLink: 'Registrierungslink für Mitarbeiter',
        toEmployees: 'Mitarbeiter verwalten',
      },
      support: {
        title: 'Sie haben Fragen zu EGYM Wellpass?',
        description:
          'Kontaktieren Sie das EGYM Wellpass Team gerne per E-Mail an <email>info@egym-wellpass.com</email>. Mehr Informationen rundum EGYM Wellpass finden Sie unter <site>www.egym-wellpass.com</site> oder in den <faq>FAQs</faq>.',
        button: 'Zum Support',
      },
    },
  },
  common: {
    clearFilter: 'Filter zurücksetzen',
    fileToBig: 'Die ausgewählte Datei ist zu groß. Maximum ist {{maxKB}}KB.',
    moreInformation: 'Weitere Informationen',
    noImageSelected: 'Kein Bild gewählt',
    countryCode: {
      DE: 'Deutschland',
      AT: 'Österreich',
    },
    role: {
      USER: {
        name: 'Mitarbeiter',
      },
      TENANT_ADMIN: {
        name: 'Administrator',
      },
      TENANT_ASSISTANT: {
        name: 'Auditor',
      },
    },
    editor: {
      placeholder: 'Hier Infotext schreiben...',
      attachments: 'Anhänge',
    },
    customBenefits: 'Eigene Benefits',
    moreBenefits: 'Weitere Benefits',
    deletedBenefit: 'Gelöschtes Benefit',
    benefit: {
      BAV: 'Altersvorsorge',
      LUNCH: 'Essenszuschuss',
      MOBILITY: 'Mobilität',
      COUPONS: 'Sachbezug',
      COUPONS_V2: 'Sachbezug Flex',
      INTERNET: 'Internetpauschale',
      GIFTS: 'Sachzuwendungen',
      FITNESS: 'Firmenfitness',
      WELLPASS: 'Firmenfitness',
      CUSTOM: 'Neues Benefit anlegen',
      RECREATION: 'Erholungsbeihilfe',
      KITA: 'Kita-Zuschuss',
      BIKE: 'Firmenrad',
      BIKELEASING_V2: 'Bikeleasing',
      BIKELEASING: 'Bikeleasing',
      NEWS: 'Mitarbeiterkommunikation',
      FLEX: 'Flex Budget',
      CREDIT_CARD: 'Sachbezugskarte',
      DISCOUNT_CODE: 'Mitarbeiterrabatte',
      AT_LUNCH: 'Essenszuschuss',
      AT_MOBILITY: 'Öffi-Ticket',
      CAR: 'JobAuto',
      IT_LEASING: 'IT Leasing',
    },
    userStatus: {
      ACTIVE: 'Aktiv',
      REGISTERED: 'Wartet auf Freigabe',
      PENDING: 'Eingeladen',
      CREATED: 'Nicht eingeladen',
      INVITATION_CODE: 'Registrierungscode erstellt',
      MAIL_DELIVERY_ERROR: 'Mail unzustellbar',
      EXPIRED: 'Einladung abgelaufen',
      INACTIVE: 'Ausgetreten',
      PLANNED_TERMINATION: 'Austritt geplant',
    },
    userStatusButton: {
      CREATED: 'Einladen',
      REGISTERED: 'Freigeben',
      EXPIRED: 'Neu einladen',
      PENDING: 'Neu einladen',
      SCHEDULED: 'Sofort einladen',
      tooltip: {
        createdTooltip: 'Mitarbeiter sofort einladen',
        registeredTooltip: 'Mitarbeiter sofort freigeben',
        pendingTooltip: 'Mitarbeiter sofort neu einladen',
        expiredTooltip: 'Mitarbeiter sofort neu einladen',
        scheduledTooltip:
          'Bei Knopfdruck wird der Mitarbeiter sofort eingeladen, ansonsten wird dieser automatisch zum {{scheduledInviteDate}} eingeladen.',
      },
    },
    employeeType: {
      FULL_TIME: 'Vollzeit',
      PART_TIME: 'Teilzeit',
      INTERN: 'Praktikum',
      STUDENT: 'Werkstudent',
      MINI_JOB: 'Minijob',
      APPRENTICESHIP: 'Ausbildung',
      TRAINING: 'Training',
      EXTERNAL: 'Extern',
      MISC: 'Sonstige',
    },
    civilStatus: {
      SINGLE: 'ledig',
      MARRIED: 'verheiratet',
      DIVORCED: 'verwitwet',
      WIDOWED: 'geschieden',
      CIVIL_UNION: 'eingetr. Lebenspartnerschaft',
      CIVIL_UNION_DECEASED: 'eingetr. Lebenspartnerschaft (Partner verstorben)',
      CIVIL_UNION_CANCELLED: 'eingetr. Lebenspartnerschaft aufgehoben',
    },
    buttons: {
      close: 'Schließen',
      abort: 'Abbrechen',
      create: 'Erstellen',
      save: 'Speichern',
      add: 'Hinzufügen',
      delete: 'Löschen',
      stop: 'Stoppen',
      discard: 'Verwerfen',
      next: 'Weiter',
      back: 'Zurück',
      upload: 'Hochladen',
      activate: 'Aktivieren',
      orderWithPayment: 'Zahlungspflichtig bestellen',
      saveDisabledTooltip: 'Bitte nehmen Sie Änderungen vor, um zu speichern',
      requestNow: 'Jetzt anfragen',
      confirm: 'Bestätigen',
      syncNextToolTip: 'Nächste Synchronisierung möglich: {{date , datetime}}',
      syncNow: 'Jetzt synchronisieren',
    },
    money: '{{money, euro}}',
    date: '{{date, date}}',
    dateTime: '{{date, datetime}}',
    confirmation: 'Bestätigung',
    confirmationModal: {
      title: 'Bestätigung erforderlich',
      confirm: 'Bestätigen',
    },
    unsavedChanges: {
      message: 'Ihre Änderungen im Formular wurden noch nicht gespeichert. Sind Sie sicher, dass Sie die Änderungen verwerfen möchten?',
      backToForm: 'Zurück zum Formular',
      discard: 'Änderungen verwerfen',
    },
    fileUpload: {
      dropHere: 'Datei hier ablegen',
      divider: 'oder',
      browse: 'Datei zum Hochladen auswählen',
      acceptTypes: 'Zulässige Dateiformate: <strong> {{acceptTypes}} </strong>',
    },
    loading: 'Wird geladen...',
    completed: '{{ progress }}% abgeschlossen',
    loadMoreData: 'Weitere Einträge laden',
    noResults: 'Keine Einträge vorhanden',
    inputRequired: 'Eingabe erforderlich',
    copyToClipboard: 'In Zwischenablage kopieren',
    copyToClipboardSuccess: 'Kopiert',
    noFileSelected: 'Keine Datei ausgewählt',
    materialReactTableLocale: MRT_Localization_DE,
    yes: 'Ja',
    no: 'Nein',
    anonymousEmployee: 'Neuer Mitarbeiter',
    anonymousEmployeeWithNumber: 'Neuer Mitarbeiter #{{employeeNumber}}',
    pleaseSelect: 'Bitte auswählen',
  },
  homePage: {
    title: 'Probonio Dashboard',
    subTitle: 'Willkommen {{name}}! 👋🏻',
    support: {
      title: 'Wir helfen gerne weiter.',
      question: 'Unterstützung gewünscht?',
      buttonText: 'Support anfragen',
      buttonText2: 'Support kontaktieren',
      dialogTitle: 'Kundenservice kontaktieren',
      description:
        'Wir helfen Ihnen gerne bei der Nutzung unseres Portals. Bei welchem Thema benötigen Sie Unterstützung? Bitte wählen Sie unten aus, um nützliche Kontaktmöglichkeiten zu erhalten.',
      whatsApp: 'WhatsApp Chat',
      manual: 'Helpcenter ansehen',
      calendar: 'Termin reservieren',
      cancel: 'Nein danke',
      confirm: 'Ja gerne',
      general: {
        title: 'Allgemeine Portalverwaltung',
        subtitle: 'Support für Ihr Konto, das Arbeitgeber-Portal oder andere Fragen',
        phone: 'Telefonnummer',
        whatsapp: 'Persönlicher WhatsApp Chat',
        mail: 'E-Mail',
      },
      helpCenter: 'Helpcenter anzeigen',
      benefits: {
        title: 'Mitarbeiterbenefits',
        subtitle: 'Unterstützung für alle anderen Benefits wie Mitarbeiterrabatte, Aufmerksamkeiten und mehr',
        generalSupport: 'Allgemeine Unterstützung',
        accounting: 'Buchhaltung',
        sales: 'Vertrieb',
        bikeleasing_v2: 'Bikeleasing',
        companyPension: 'Betriebliche Altersvorsorge',
        daycare: 'Kita-Zuschuss',
        employeeCommunication: 'Mitarbeiterkommunikation',
        discountCodes: 'Mitarbeiterrabatte',
        flexBudget: 'Flex Budget',
        giftCards: 'Sachbezug',
        internet: 'Internetpauschale',
        itLeasing: 'IT-Leasing',
        electricCar: 'JobAuto',
        lunch: 'Essenszuschuss',
        mobility: 'Mobilität',
        recreation: 'Erholungsbeihilfe',
      },
    },
  },
  usersPage: {
    title: 'Mitarbeiterstammdaten',
    addUser: 'Mitarbeiter anlegen',
    success: 'Erfolgreich angelegt',
    search: 'Suche',
    editMode: 'Benefit-Konfiguration ändern',
    closeEditMode: 'Bearbeitung beenden',
    inviteNewUsersButton: {
      buttonText: 'Alle Mitarbeiter einladen ({{count}})',
      confirmTitle: 'Mitarbeiter einladen',
      confirmText_one: 'Wollen Sie wirklich {{count}} Mitarbeiter einladen?',
      confirmText_other: 'Wollen Sie wirklich {{count}} Mitarbeiter einladen?',
    },
    reinviteUsersButton: {
      buttonText: 'Alle Mitarbeiter mit abgelaufenem Link wieder einladen ({{count}})',
      confirmTitle: 'Mitarbeiter mit abgelaufenem Link wieder einladen',
      confirmText_one: 'Wollen Sie wirklich {{count}} Mitarbeiter mit abgelaufenem Link wieder einladen?',
      confirmText_other: 'Wollen Sie wirklich {{count}} Mitarbeiter mit abgelaufenem Link wieder einladen?',
    },
    unlockAllEmployees: {
      buttonText: 'Alle Mitarbeiter freigeben ({{count}})',
      confirmTitle: 'Mitarbeiter freigeben',
      confirmText_one: 'Wollen Sie wirklich {{count}} Mitarbeiter freigeben?',
      confirmText_other: 'Wollen Sie wirklich {{count}} Mitarbeiter freigeben?',
    },
    tab: {
      duplicates: 'Duplikate',
      all: 'Alle',
      active: 'Aktiv',
      receivedFrom: 'Empfangen von',
      scheduledFor: 'Geplant für',
      registration: 'In Registrierung',
      inactive: 'Ausgetreten',
    },
  },
  registerPage: {
    redirecting: 'Weiterleitung',
    pleaseWait: 'Sie werden in Kürze zur Registrierung weitergeleitet, bitte warten...',
    linkExpired: 'Der Registrierungslink ist abgelaufen',
    useUpdatedLink:
      'Sie sollten bereits eine E-Mail mit einem neuen Link erhalten haben. Falls nicht, fordern Sie bitte einen neuen Link von Ihrem Arbeitgeber an.',
  },
  receiptsModule: {
    receiptsNotAllCheckedWarning:
      ' Es wurden noch nicht alle Belege von uns geprüft. Sollten Sie den Report nun herunterladen, sind die noch nicht geprüften Belege nicht enthalten.',
    periodNotClosed:
      'Vorsicht, die gewählte Abrechnungsperiode läuft noch bis zum {{val, date}}. Bisher noch nicht genutzte Benefits werden im Report nicht aufgeführt und können nicht ausgezahlt werden.',
    periodNotClosedReceipts:
      'Vorsicht, der Upload von Belegen ist noch bis zum {{periodCloseDay}}. möglich. Bisher noch nicht hochgeladene oder noch nicht bearbeitete Belege werden im Report nicht aufgeführt und können nicht ausgezahlt werden.',
    lodasParametersMissing: 'Bitte füllen Sie alle relevanten Lohnartenfelder aus.',
    salaryConversionParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird die Abrechnungsart „$t(benefitsModule:LUNCH.fields.salaryConversation)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeSalaryReduction)“.',
    mobilityTaxableParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird die Abrechnungsart „$t(benefitsModule:MOBILITY.fields.taxationType.TAXABLE)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeMobilityTaxable)“.',
    giftsParameterMissing:
      'An ein oder mehrere Mitarbeiter wurden Aufmerksamkeiten ausgegeben. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeGifts)“.',
    incentivesParameterMissing:
      'An ein oder mehrere Mitarbeiter wurden Sachzuwendungen 37b ausgegeben. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeIncentives)“.',
    employeeNumbersMissing:
      'Um den Steuerbericht zu erzeugen, ist für alle aktiven Mitarbeiter eine gültige numerische Personalnummer erforderlich. Bitte hinterlegen Sie diese in den Mitarbeiterstammdaten.',
    lunchTaxFreeParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:LUNCH.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeLunchTaxFree)“.',
    internetParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:INTERNET.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeInternet)“.',
    fitnessParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:FITNESS.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeFitness)“.',
    wellpassParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:WELLPASS.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeWellpass)“.',
    kitaParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:KITA.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeKita)“.',
    recreationParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:RECREATION.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeRecreation)“.',
    mobilityTaxFreeParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird die Abrechnungsart „$t(benefitsModule:MOBILITY.fields.taxationType.TAX_FREE)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeMobilityTaxFree)“.',
    creditCardParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:CREDIT_CARD.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeCreditCard)“.',
    couponsParameterMissing:
      'Für ein oder mehrere Mitarbeiter wird der Benefit „$t(benefitsModule:COUPONS.title)“ verwendet. Bitte hinterlegen Sie einen Wert im Feld „$t(receiptsModule:salaryTypeCoupons)“.',
    payrollExportHistoryModal: {
      title: 'Exporthistorie',
      showHistory: 'Historie anzeigen',
      rateLimit: 'Zu viele Anfragen',
      successToast: 'E-Mail wurde versendet',
      noResults: 'Es konnten keine Exporte gefunden werden',
      createdBy: 'Erstellt von',
      automaticDispatch: 'Automatischer Versand',
      resendExport: 'Export erneut versenden',
    },
    cancel: 'Abbrechen',
    download: 'Herunterladen',
    downloadHint: 'Report herunterladen',
    downloadTitle: 'Lohndatenexport generieren',
    consultantNumber: 'Beraternummer',
    consultantNumberHelper: 'Die Datev Beraternummer Ihres Steuerbüros',
    consultantNumberError: 'Nur Zahlen von 1000 bis 9999999 erlaubt.',
    tenantNumber: 'Mandantennummer',
    tenantNumberHelper: 'Die Mandandatennummer Ihres Steuerbüros für Ihr Unternehmen',
    tenantNumberError: 'Nur Zahlen von {{min}} bis {{max}} erlaubt.',
    salaryTypeLunchTaxFree: 'Lohnart Steuerfrei',
    salaryTypeLunchTaxFreeHelper: 'Diese Lohnart wird für die Abrechnung des steuerfreien Anteils verwendet',
    salaryTypeLunchTaxable: 'Lohnart Pauschalversteuert',
    salaryTypeLunchTaxableHelper: 'Diese Lohnart wird für die Abrechnung des pauschalversteuerten Anteils verwendet',
    salaryTypeMobilityTaxFree: 'Lohnart Steuerfrei',
    salaryTypeMobilityTaxFreeHelper: 'Diese Lohnart wird für die Abrechnung des steuerfreien Anteils verwendet',
    salaryTypeMobilityTaxable: 'Lohnart Steuerpflichtig',
    salaryTypeMobilityTaxableHelper: 'Diese Lohnart wird für die Abrechnung des vollversteuerten Anteils verwendet',
    salaryTypeSalaryReduction: 'Lohnart Gehaltsreduktion',
    salaryTypeSalaryReductionHelper: 'Über diese Lohnart wird die Gehaltsreduktion auf der Lohnabrechnung angezeigt.',

    salaryTypeCoupons: 'Lohnart Sachbezug 50',
    salaryTypeCouponsHelper: 'Diese Lohnart wird für die Abrechnung des Sachbezug 50 verwendet',
    salaryTypeGifts: 'Lohnart Aufmerksamkeiten',
    salaryTypeGiftsHelper: 'Diese Lohnart wird für die Abrechnung der Aufmerksamkeiten verwendet',
    salaryTypeFitness: 'Lohnart Firmenfitness',
    salaryTypeFitnessHelper: 'Diese Lohnart wird für die Abrechnung der Firmenfitness verwendet',
    salaryTypeWellpass: 'Lohnart Firmenfitness',
    salaryTypeWellpassHelper: 'Diese Lohnart wird für die Abrechnung von Firmenfitness verwendet',
    salaryTypeCreditCard: 'Lohnart Sachbezugskarte',
    salaryTypeCreditCardHelper: 'Diese Lohnart wird für die Abrechnung der Sachbezugskarte verwendet',
    salaryTypeIncentives: 'Lohnart Sachzuwendung 37b',
    salaryTypeIncentivesHelper: 'Diese Lohnart wird für die Abrechnung der Sachzuwendungen 37b verwendet',
    salaryTypeInternet: 'Lohnart Internetpauschale',
    salaryTypeInternetHelper: 'Diese Lohnart wird für die Abrechnung der Internetpauschale verwendet',
    salaryTypeKita: 'Lohnart Kita-Zuschuss',
    salaryTypeKitaHelper: 'Diese Lohnart wird für die Abrechnung des Kita-Zuschusses verwendet',
    salaryTypeATLunch: 'Lohnart Essenszuschuss',
    salaryTypeATLunchHelper: 'Diese Lohnart wird für die Abrechnung des Essenszuschusses verwendet',
    salaryTypeATMobilityHelper: 'Diese Lohnart wird für die Abrechnung des Öffi-Ticket-Zuschusses verwendet',
    salaryTypeATMobility: 'Lohnart Öffi-Ticket',
    salaryTypeRecreation: 'Lohnart Erholungsbeihilfe',
    salaryTypeRecreationHelper: 'Diese Lohnart wird für die Abrechnung der Erholungsbeihilfe verwendet',
    exportType: 'Exportieren als...',
    exportMonth: 'Report erstellen für',
    exportMonthHelper:
      'Die Abrechnungsperiode, welche im Export angegeben wird. Der vorausgewählte Monat ist nur in Ausnahmefällen zu verändern',
    exportSwitchInterval: 'Auswahl auf einen Zeitraum umschalten',
    exportSwitchMonth: 'Auswahl auf einen Monat umschalten',
    processingMonth: 'Bearbeitungsmonat',
    processingMonthDescription: 'Änderungen nur in Sonderfällen nötig',
    processingMonthHelper: 'Der Bearbeitungsmonat, welcher im Export angegeben wird. Im Normalfall ist dies der Abrechnungszeitraum + 1',
    flexBenefitsToInclude: 'Zu exportierende Benefits',
    selectExportDialog: {
      title: 'Integration zur Lohnbuchhaltung',
      introText: 'Welche Software verwenden Sie oder Ihr Steuerbüro für die Lohnabrechnung?',
      warning:
        '{{tenant}} als Lohnbuchhaltungsprogramm für Ihr Unternehmen festlegen? Diese Änderung kann im Zweifel nur über den Support rückgängig gemacht werden!',
      infoTestAccount:
        'Die Exports stehen in der Testversion leider nicht zur Verfügung, wir melden uns in Kürze bei Ihnen um das weitere Vorgehen zu besprechen und die Integration abzuschließen',
      close: 'Schließen',
      confirm: 'Bestätigen',
    },
    salaryConversion: 'Gehaltsumwandlung',
    salaryConversionDescription: 'Eingaben nur im Falle von Gehaltsumwandlung benötigt',
    settingsForm: {
      title: 'Einstellungen für Lohndatenexport',
      info: 'Konfigurieren Sie hier die Parameter für den Lohndatenexport des $t(benefitsModule:{{benefit}}.title) Benefits.',
      section: {
        automatedReports: {
          title: 'Automatischer Versand',
          info: 'Wählen Sie, ob Sie die Lohndaten-Reports jeden Monat automatisch per E-Mail erhalten möchten.',
        },
        tenantConsultantNumber: {
          title: 'Daten des Steuerbüros',
          info: 'Konfigurieren Sie Ihre Kundendaten, mit denen Sie Ihre Firma bei Ihrem Steuerbüro identifizieren.',
        },
        salaryTypes: {
          title: 'Lohnarten',
          info: 'Die Lohnarten werden für die Abrechnung der einzelnen Benefits in der Gehaltsabrechnung verwendet.',
          infoFreeText:
            'Die Lohnarten werden für die Abrechnung der einzelnen Benefits in der Gehaltsabrechnung verwendet. Bitte tragen Sie die Lohnarten genau so ein, wie sie in Ihrem Lohnbuchhaltungssystem benannt sind.',
        },
      },
    },
    imageView: {
      receipt: 'Beleg',
      rotate: 'Um 90° drehen',
      centerView: 'Ansicht zentrieren',
      downloadImage: 'Bild herunterladen',
      downloadPDF: 'PDF herunterladen',
    },
    receiptDetails: {
      drawerTitle: 'Beleg: $t(common:benefit.{{benefit}}) vom {{date,date}}',
      employee: 'Mitarbeiter',
      date: 'Datum',
      total: 'Betrag',
      status: 'Status',
      comment: 'Kommentar',
      postalCode: 'PLZ des Händlers',
      auditedBy: 'Geprüft von',
      probonioAudit: 'Probonio Belegprüfung',
      refund: 'Erstattungsbetrag',
      potentialRefund: 'Potentieller Erstattungsbetrag',
      lunch: {
        refundTaxable: 'Davon pauschalversteuert',
        refundTaxFree: 'Davon steuerfrei',
      },
      atLunch: {
        refund: {
          title: 'Zulässige Belege',
          SUPERMARKET: 'Supermarkt, Imbiss',
          RESTAURANT: 'Restaurant, Gaststätte',
        },
      },
      mobility: {
        refundTaxable: 'Erstattungsbetrag (vollversteuert)',
        refundTaxFree: 'Erstattungsbetrag (steuerfrei)',
        mobilityType: {
          title: 'Mobilitätsart',
          LOCAL_TRAIN: {
            title: 'Nahverkehrszug',
          },
          LOCAL_BUS: {
            title: 'Linienbus',
          },
          LONG_DISTANCE_TRAIN: {
            title: 'Fernzug',
          },
          LONG_DISTANCE_BUS: {
            title: 'Fernbus',
          },
          CAR: {
            title: 'PKW',
          },
          SHARING_OFFERS: {
            title: 'Sharing Angebote',
          },
          TAXI: {
            title: 'Taxi',
          },
          BIKE: {
            title: 'Fahrrad',
          },
          TIME_CARD: {
            title: 'Zeitkarte',
          },
          DEUTSCHLAND_TICKET: {
            title: 'Deutschland-Ticket',
          },
          OTHERS: {
            title: 'Sonstiges',
          },
        },
        travelPurpose: {
          title: 'Reisezweck',
          WORK: {
            title: 'Arbeitsweg',
          },
          PRIVATE: {
            title: 'Privatfahrt',
          },
        },
        validity: 'Gültigkeit',
        validityMonths: '{{validityMonths}} Monate ab {{validityStartDate,monthAndYear}}',
      },
      atMobility: {
        validityStartMonth: 'Start',
        durationMonths: 'Dauer',
      },
      recreation: {
        refund: 'Erstattungsbetrag (pauschalversteuert)',
      },
    },
    receiptChecklist: {
      LUNCH: [
        {
          checklistText: 'Beleg ist vollständig und gut lesbar',
        },
        {
          checklistText: 'Name und Adresse des ausstellenden Unternehmens enthalten',
        },
        {
          checklistText: 'Beleg ist aus Deutschland',
        },
        {
          checklistText: 'Gewähltes Datum stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Eingegebener Betrag stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Kein Alkohol, keine Non-Food Artikel',
        },
      ],
      AT_LUNCH: [
        {
          checklistText: 'Beleg ist vollständig und gut lesbar',
        },
        {
          checklistText: 'Name und Adresse des ausstellenden Unternehmens enthalten',
        },
        {
          checklistText: 'Beleg ist aus Österreich',
        },
        {
          checklistText: 'Gewähltes Datum stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Eingegebener Betrag stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Kein Alkohol, keine Non-Food Artikel',
        },
        {
          checklistText: 'Sofern erforderlich, Bindung an Zubereitung in Gaststätte oder durch Lieferdienst geprüft',
        },
      ],
      MOBILITY: [
        {
          checklistText: 'Beleg ist vollständig und gut lesbar',
        },
        {
          checklistText: 'Gewähltes Datum stimmt mit dem Beleg überein (Ticket)',
        },
        {
          checklistText: 'Gewähltes Datum stimmt mit dem Beleg überein (Monatskarte)',
        },
        {
          checklistText: 'Beleg ist aus dem Nah- oder Fernverkehr',
        },
        {
          checklistText: 'Eingegebener Betrag stimmt mit dem Beleg überein',
        },
      ],
      RECREATION: [
        {
          checklistText: 'Beleg ist vollständig und gut lesbar',
        },
        {
          checklistText: 'Name und Adresse des ausstellenden Unternehmens enthalten',
        },
        {
          checklistText: 'Eingegebener Betrag stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Beleg ist aus diesem Jahr',
        },
        {
          checklistText: 'Dieser Beleg entspricht den Kriterien für eine Erholungsbeihilfe',
        },
      ],
      AT_MOBILITY: [
        {
          checklistText: 'Beleg ist vollständig und gut lesbar',
        },
        {
          checklistText: 'Beleg ist aus Österreich',
        },
        {
          checklistText: 'Eingegebener Betrag stimmt mit dem Beleg überein',
        },
        {
          checklistText: 'Gültigkeitszeitraum stimmt mit dem Beleg überein',
        },
      ],
    },
    auditForm: {
      approvalCriteria: 'Annahmekriterien',
      rejectionReason: 'Ablehnungsgrund',
      receiptAudit: 'Belegprüfung',
      receiptAuditInfo:
        'Falls sie den aktuellen Beleg explizit akzeptieren oder ablehnen möchten, wählen Sie bitte die entsprechende Option.',
      revokeApprove: 'Annahme widerrufen',
      revokeReject: 'Ablehnung widerrufen',
      approveTitle: 'Wollen Sie den Beleg wirklich akzeptieren?',
      approveText: 'Die Probonio-Kontrolle wird verworfen und der Erstattungsbetrag wird ausgezahlt.',
      approve: 'Akzeptieren',
      rejectTitle: 'Wollen Sie den Beleg wirklich ablehnen?',
      rejectText:
        'Der Mitarbeiter wird informiert, der Ablehnungsgrund kann eingesehen werden und der Erstattungsbetrag wird nicht ausgezahlt.',
      reject: 'Ablehnen',
      updateSuccess: 'Beleg wurde aktualisiert',
      approvedByTenant:
        'Der Beleg wurde arbeitgeberseitig akzeptiert. Falls Sie Ihre Entscheidung ändern möchten, klicken Sie auf "Annahme widerrufen".',
    },
  },
  couponsModule: {
    reportDialogMessage:
      'Dieser Report enthält alle Informationen darüber, zu welchem Zeitpunkt dem Mitarbeiter ein Sachbezug in welcher Höhe gewährt wurde. Den Report können Sie bei Bedarf herunterladen oder als Anlage zu Ihrem Lohnkonto speichern.',
    successDeleteGift: 'Aufmerksamkeit erfolgreich gelöscht',
    giftAlreadyCompleted: 'Aufmerksamkeit wurde bereits ausgezahlt',
    budgetPage: {
      breadcrumbTitle: 'Sachbezug',
      breadcrumbTitleCoupons: 'Gutscheine',
      breadcrumbTitleGifts: 'Aufmerksamkeiten',
      subTitle: 'Bestellungen',
    },
    employeeTabs: {
      fitness: 'Firmenfitness',
      couponOrders: 'Gutscheinkäufe',
      creditCards: 'Kreditkarten',
      wellpass: 'Firmenfitness',
      gifts: 'Aufmerksamkeiten',
      incentives: 'Sachzuwendungen 37b',
      budgetOrders: 'Budget-Aufladungen',
      allTransactions: 'Alle Buchungen',
    },
    orderHistoryList: {
      search: 'Suche',
      includeCouponOrders: 'Gutscheinkäufe anzeigen',
      includeGiftCouponOrders: 'Aufmerksamkeiten anzeigen',
      export: 'Bestellungen als CSV exportieren',
    },
    ordersTable: {
      header: {
        date: 'Datum',
        employee: 'Mitarbeiter',
        amount: 'Betrag',
        details: 'Details',
      },
      row: {
        couponOrder: 'Gutscheinkauf',
        giftOrder: 'Aufmerksamkeit: $t(couponsModule:giftOccasions.{{occasion}})',
        incentiveOrder: 'Sachzuwendung 37b: $t(couponsModule:giftOccasions.{{occasion}})',
        budgetOrder: {
          COMPLETED: 'Budget-Aufladung',
        },
        budgetCorrection: 'Budget-Korrektur',
      },
      noResults: 'Keine Aufladungen von Budget oder Bestellungen von Gutscheinen vorhanden',
      noResultsFitness: 'Keine Firmenfitness Bestellungen vorhanden',
      noResultsCreditCard: 'Keine Kreditkarten Bestellungen vorhanden',
      noResultsWellpass: 'Keine Firmenfitness Bestellungen vorhanden',
      pendingBudgetOrders_one: 'Budget-Aufladung in Bearbeitung',
      pendingBudgetOrders_other: 'Budget-Aufladungen in Bearbeitung',
      pendingBudgetOrderItem: '<strong>{{amount, euro}}</strong> (bestellt am {{orderDate,date}} von {{firstName}} {{lastName}})',
      futureBudgetOrderItem: '<strong>{{amount, euro}}</strong> (wird bestellt zum {{orderDate,date}} von {{firstName}} {{lastName}})',
      pendingBudgetOrderItemAdmin: '<strong>{{amount, euro}}</strong> (bestellt am {{orderDate,date}})',
      futureBudgetOrderItemAdmin: '<strong>{{amount, euro}}</strong> (wird bestellt zum {{orderDate,date}})',
    },
    budgetPanel: {
      tabs: {
        expenses: 'Kosten',
        balance: 'Guthaben',
      },
      expectedExpenses: 'Aktueller Monat',
      budget: 'Gesamtes Guthaben:',
      orderButton: 'Aufladen',
      previousExpenses: 'Letzter Monat',
      upcomingExpenses: 'Nächster Monat',
      automaticTopUpActive: 'Automatisches Aufladen aktiv',
    },
    budgetPanelIncreaseBudgetDialog: {
      title: 'Budget verwalten',
      billingAddressPanel: {
        title: 'Rechnungsadresse',
        alert: 'Bitte geben Sie eine vollständige Rechnungsadresse ein.',
        saveButton: 'Speichern',
        editButton: 'Bearbeiten',
      },
      tabs: {
        manual: {
          title: 'Guthaben Aufladung',
          amount: 'Betrag',
          amountHelperText: 'Mindestbetrag: {{money, euro-float}}',
          currentBudget: 'Aktuelles Budget',
          newBudget: 'Neues Budget',
          expectedExpenses: 'Erwartete Kosten',
          integerRequired: 'Nur ganzzahlige Euro-Beträge',
          actions: {
            cancel: 'Abbrechen',
            confirm: 'Zahlungspflichtig Bestellen',
          },
        },
        automatic: {
          title: 'Automatische Aufladung',
          enableAutomaticRefill: 'Automatische Aufladung',
          infoText:
            'Sollten Sie die automatische Aufladung deaktivieren, so müssen Sie Guthabenaufladungen manuell im Arbeitgeber-Portal anmelden und erhalten erst dann eine Rechnung über den frei von Ihnen gewählten Betrag.',
          warnText:
            'Auch wenn die automatischen Aufladung aktiviert ist, muss die Überweisung noch manuell vorgenommen werden. Die Zahlungsart können Sie in den <0>Unternehmenseinstellungen</0> ändern.',
          actions: {
            cancel: 'Abbrechen',
            confirm: 'Bestätigen',
          },
          enabledSuccessMessage: 'Automatische Aufladung erfolgreich aktiviert',
          disabledSuccessMessage: 'Automatische Aufladung erfolgreich deaktiviert',
        },
      },
      successDialog: {
        title: 'Vielen Dank',
        orderCompleted: 'Bestellung erfolgreich abgesendet!',
        orderCompletedInfo: 'Die Rechnung und Zahlungsinformationen werden Ihnen zeitnah per Mail an {{tenantMail}} zugesandt',
        orderCompletedInfoSepa:
          '\nDer Betrag {{money, euro-float}} wird von folgendem Konto {{tenantIban}} innerhalb der nächsten Tage via SEPA abgebucht. \n \nBitte bedenken Sie, dass die Aufladung des Budgets im Arbeitgeber-Portal erst nach Zahlungseingang auf unserem Geschäftskonto erfolgt.',
        transferData: {
          title: 'Überweisungsdaten:',
          recipient: 'Empfänger:',
          iban: 'IBAN:',
          bic: 'BIC:',
          usage: 'Verwendungszweck:',
          amount: 'Betrag:',
          probonioData: {
            recipient: 'Probonio GmbH',
            iban: 'DE04 7435 0000 0021 1788 36',
            bic: 'BYLADEM1LAH',
          },
        },
        actions: {
          cancel: 'Abbrechen',
          confirm: 'Meldung schließen',
        },
      },
    },
    benefitSettings: {
      title: 'Einstellungen für Gutscheinzufluss',
      info: 'Hier haben Sie die Möglichkeit, verschiedene Einstellungen vorzunehmen, um den Gutscheinprozess für Ihre Mitarbeiter zu verwalten. Auf der aktuellen Seite können Sie festlegen, wann und wie Mitarbeiter Gutscheine erhalten, den Standardgutschein festlegen und die automatische Auswahl konfigurieren.',
      orderDeadline: {
        title: 'Tag des Monats, bis zu dem die Mitarbeiter Gutscheine wählen dürfen',
        info: 'Wählen Sie, bis zu welchem Tag Ihre Mitarbeiter spätestens einen Gutschein in der Probonio-App auswählen müssen. Erfolgt bis zum gewählten Tag keine Auswahl, erhält der Mitarbeiter automatisch den festgelegten Standardgutschein. Dies beeinflusst auch das Versanddatum des Lohndatenexports.',
      },
      fallbackCoupon: {
        title: 'Automatisch gewählter Gutschein',
        info: 'Ihre Mitarbeiter können in der Probonio-App selbstständig auswählen, welchen Gutschein sie monatlich automatisch erhalten wollen. Der hier gewählte Gutschein wird ausgegeben, falls Ihr Mitarbeiter keine eigene Auswahl trifft.',
      },
      automationBehaviour: {
        title: 'Verhalten des automatischen Gutscheinzuflusses',
        info: 'Legen Sie ein vom Standard abweichendes Verhalten für den automatischen Gutscheinzufluss fest.',
      },
      fields: {
        couponFallbackDefinitionId: {
          hint: 'Wählen Sie hier einen Gutschein, der automatisch zum {{couponOrderDeadline}} für Ihre Mitarbeiter ausgewählt wird, falls diese bis dahin in der Probonio-App keine Auswahl getroffen haben.',
          disabledTooltip:
            'Nur möglich, wenn der automatischen Gutscheinkauf nicht verhindert ist ($t(benefitsModule:settingsDialog.moreSettings))',
          emptyPlaceholder: 'Keine Auswahl',
        },
        couponOrderAutomate: {
          DEFAULT: {
            label: 'Gutscheinzufluss für aktive Nutzer',
            hint: 'Sollte ein aktiver Mitarbeiter bis zum {{couponOrderDeadline}} noch keinen Gutschein gewählt haben, so erhält er automatisch den Gutschein, welchen er für die automatische Auswahl gewählt hat. Sollte keine automatische Auswahl getroffen sein, ',
            hintWithFallback: ' erhält er einen “{{couponFallback}}” (Siehe oben) Gutschein.',
            hintWithoutFallback: ' erhält er für diesen Monat keinen Gutschein!',
          },
          FOR_ALL_USERS: {
            label: 'Gutscheinzufluss erzwingen',
            hint: 'Es wird zum {{couponOrderDeadline}} für alle Mitarbeiter, die noch keinen Gutschein gewählt haben automatisch ein Gutschein gewählt, auch wenn sich dieser noch nie angemeldet hat. Nutzer, welche von Ihnen auf Inaktiv gesetzt oder noch nicht freigegeben wurden sind davon ausgenommen.',
            disabledTooltip: 'Wenn Sie den Gutscheinzufluss erzwingen wollen, wählen Sie einen automatisch gewählten Gutschein.',
          },
          DISABLED: {
            label: 'Automatischen Gutscheinzufluss verhindern',
            hint: 'Ihre Mitarbeiter können keine automatische Auswahl mehr treffen. Sollten Mitarbeiter bis zum {{couponOrderDeadline}} keinen Gutschein gewählt haben, so erhalten sie keinen Gutschein für diesen Monat. Eine nachträgliche Wahl oder auch der Zufluss eines Gutscheins für einen vergangenen Monat ist steuerlich nicht möglich!',
            disabledTooltip:
              'Wenn sie den automatischen Gutscheinkauf verhindern wollen, wählen Sie als “$t(couponsModule:benefitSettings.fallbackCoupon.title)” - “$t(couponsModule:benefitSettings.fields.couponFallbackDefinitionId.emptyPlaceholder)”.',
          },
        },
      },
      couponOrderDeadline: {
        first: 'Monatsanfang',
        perDay: '{{value}}. des Monats',
        last: 'Ende des Monats',
      },
      couponOrderDeadlineHint: {
        first:
          'Dem Mitarbeiter wird zum Monatsanfang der im Vormonat gewählte Standardgutschein ausgegeben. Der automatische Versand des Reports erfolgt am Folgetag.',
        perDay:
          'Dem Mitarbeiter wird zum gewählten Tag ein Standardgutschein ausgegeben, falls zuvor kein anderer gewählt wurde. Der automatische Versand des Reports erfolgt am Folgetag ({{reportDay}}. des Monats).',
        last: 'Dem Mitarbeiter wird zum Monatsende ein Standardgutschein ausgegeben, falls zuvor kein anderer gewählt wurde. Der automatische Versand des Reports erfolgt zu Beginn des folgenden Monats.',
      },
      successToast: 'Änderungen wurden gespeichert',
    },
    giftOccasions: {
      BIRTHDAY: 'Geburtstag',
      SAINTS_DAY: 'Namenstag',
      CHILD_BIRTH: 'Geburt des Kindes',
      CHILD_BAPTISM: 'Taufe des Kindes',
      CHILD_COMMUNION: 'Kommunion des Kindes',
      CHILD_CONFIRMATION_CATH: 'Firmung des Kindes',
      CHILD_CONFIRMATION_PROT: 'Konfirmation des Kindes',
      WEDDING: 'Hochzeit',
      WEDDING_SILVER: 'Silberne Hochzeit',
      WEDDING_GOLD: 'Goldene Hochzeit',
      PASSED_EXAM: 'Bestandene Prüfung',
      COMPANY_ANNIVERSARY: 'Rundes Mitarbeiterjubiläum',
      ACHIEVEMENT: 'Zielerreichung',
      WORK_PERFORMANCE: 'Arbeitsleistung',
      COMMITMENT: 'Besonderes Engagement',
      PROPOSAL: 'Verbesserungsvorschlag',
      RECRUITMENT: 'Mitarbeiterwerbung',
      ATTENDANCE: 'Anwesenheitsbonus',
      SIGNING_BONUS: 'Antrittsprämie',
      PROFIT_SHARING: 'Erfolgsbeteiligung',
      OTHER: 'Anderes',
      description: {
        BIRTHDAY: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zu deinem Geburtstag sendet dir dein Probonio Team!',
        SAINTS_DAY: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zu deinem Namenstag sendet dir dein Probonio Team!',
        CHILD_BIRTH: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Geburt deines Kindes sendet dir dein Probonio Team!',
        CHILD_BAPTISM: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Taufe deines Kindes sendet dir dein Probonio Team!',
        CHILD_COMMUNION: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Kommunion deines Kindes sendet dir dein Probonio Team!',
        CHILD_CONFIRMATION_CATH:
          'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Firmung deines Kindes sendet dir dein Probonio Team!',
        CHILD_CONFIRMATION_PROT:
          'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Konfirmation deines Kindes sendet dir dein Probonio Team!',
        WEDDING: 'Alles Gute, {{firstName}} {{lastName}}, zur Hochzeit und eine glückliche, zufriedene Ehe wünscht dir dein Probonio Team!',
        WEDDING_SILVER:
          'Alles Gute, {{firstName}} {{lastName}}, zur Silberhochzeit und weiterhin viel Freude an der Ehe wünscht dir dein Probonio Team!',
        WEDDING_GOLD:
          'Alles Gute, {{firstName}} {{lastName}}, zur Goldenen Hochzeit und weiterhin viel Freude an der Ehe wünscht dir dein Probonio Team!',
        PASSED_EXAM: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur bestandenen Prüfung sendet dir dein Probonio Team!',
        COMPANY_ANNIVERSARY: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zum runden Firmenjubiläum sendet dir dein Probonio Team!',
        ACHIEVEMENT:
          'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zu deinen erreichten Zielen. Dein Probonio-Team feiert deine erreichten Meilensteine mit dir!',
        WORK_PERFORMANCE:
          'Ein großes Lob und Anerkennung gehen an dich, {{firstName}} {{lastName}}, für deine beeindruckende Arbeitsleistung! Wir möchten dir für deinen Einsatz danken!',
        COMMITMENT: 'Vielen Dank, {{firstName}} {{lastName}}, für deine außergewöhnliche Einsatzbereitschaft!',
        PROPOSAL: 'Vielen Dank, {{firstName}} {{lastName}}, für deinen wertvollen Verbesserungsvorschlag!',
        RECRUITMENT:
          'Wir möchten uns herzlich bei dir, {{firstName}} {{lastName}}, für deine Unterstützung bei der Mitarbeiterwerbung bedanken!',
        ATTENDANCE: 'Vielen Dank für deine kontinuierliche Anwesenheit {{firstName}} {{lastName}}!',
        SIGNING_BONUS:
          'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Antrittsprämie. Viel Erfolg in deiner Position wünscht dir dein Probonio Team!',
        PROFIT_SHARING: 'Herzliche Glückwünsche, {{firstName}} {{lastName}}, zur Erfolgsbeteiligung sendet dir dein Probonio Team!',
        OTHER: 'Herzliche Glückwünsche sendet dir dein Probonio Team!',
      },
      info: {
        COMPANY_ANNIVERSARY: 'Gültig sind lediglich runde Jubiläen der Firmenzugehörigkeit des Mitarbeiters, die auf fünf oder null enden.',
        OTHER:
          'Bei dem Anlass muss es sich um ein besonderes persönliches Ereignis handeln.  Feiertage wie Weihnachten oder Ostern gelten hierfür nicht!',
      },
    },
    giftsPage: {
      subTitle: 'Aufmerksamkeiten',
      goToEmployee: 'Zum Mitarbeiter',
      tab: {
        pending: 'Geplant',
        delivered: 'Zugeflossen',
      },
    },
    incentivesPage: {
      subTitle: 'Sachzuwendung 37b',
      tab: {
        pending: 'Geplant',
        delivered: 'Zugeflossen',
      },
    },
  },
  couponsV2Module: {
    reportDialogMessage:
      'Dieser Report enthält alle Informationen darüber, zu welchem Zeitpunkt dem Mitarbeiter ein Sachbezug in welcher Höhe gewährt wurde. Den Report können Sie bei Bedarf herunterladen oder als Anlage zu Ihrem Lohnkonto speichern.',
    successUpdate: 'Aktivierung erfolgreich aktualisiert',
    successDeleteGift: 'Zuwendung erfolgreich gelöscht',
    successCreate: 'Benefit erfolgreich erstellt',
    giftAlreadyCompleted: 'Aufmerksamkeit wurde bereits ausgezahlt',
    budgetPage: {
      breadcrumbTitle: 'Sachbezug Flex',
      subTitle: 'Buchungen',
      alertMessage: 'Es werden erst Rechnungen erstellt und Gutscheine ausgestellt, sobald SEPA vollständig eingerichtet ist.',
    },
    employeeTabs: {
      couponOrders: 'Alle Buchungen',
    },
    orderHistoryList: {
      search: 'Suche',
      export: 'Bestellungen als CSV exportieren',
    },
    ordersTable: {
      header: {
        date: 'Datum',
        deliveryDate: 'Datum des Zuflusses',
        employee: 'Mitarbeiter',
        amount: 'Betrag',
        status: 'Status',
        details: 'Details',
      },
      row: {
        couponOrder: 'Sachbezug',
        giftOrder: {
          GIFT: 'Aufmerksamkeit: $t(couponsModule:giftOccasions.{{occasion}})',
          INCENTIVE: 'Sachzuwendung 37b: $t(couponsModule:giftOccasions.{{occasion}})',
        },
        // c.f. CouponsV2TokenOrderStatus
        status: {
          INITIAL: 'Rechnung wird erstellt',
          INVOICE_CREATED: 'Zahlung ausstehend',
          PAID: 'bezahlt',
          AVAILABLE: 'bereit zur Einlösung',
          DELIVERED: 'zugeflossen',
          PAYMENT_FAILED: 'storniert',
          PENDING_REFUND: 'wird erstattet',
          CANCELLED: 'storniert',
        },
        deliveryDate: {
          notDelivered: 'Ausstehend',
        },
        employee: {
          deleted: 'Gelöschter Mitarbeiter',
        },
      },
      orderTypeFilter: {
        label: 'Buchungstyp',
        all: 'Alle',
        BENEFIT_ACTIVATION: 'Sachbezug',
        GIFT: 'Aufmerksamkeit',
        INCENTIVE: 'Sachzuwendung 37b',
      },
      orderStatusFilter: {
        label: 'Status',
      },
      noResults: 'Keine Bestellungen von Gutscheinen vorhanden',
    },
    gifts: {
      title: 'Zuwendungen',
      payouts: 'Auszahlungen',
      active: 'Nächste Auszahlung am {{val, date}}',
      deleteConfirmation: 'Sind Sie sicher, dass Sie die geplante Auszahlung stornieren möchten?',
      dialogCreateTitle: {
        GIFT: 'Neue Aufmerksamkeit hinzufügen',
        INCENTIVE: 'Neue Sachzuwendung 37b hinzufügen',
      },
      dialogEditTitle: {
        GIFT: 'Aufmerksamkeit bearbeiten',
        INCENTIVE: 'Sachzuwendung 37b bearbeiten',
      },
      fields: {
        payoutDate: 'Auszahlungsdatum',
        giftType: 'Typ',
        occasion: 'Anlass',
        recurringText: 'Diese Aufmerksamkeit soll jährlich wiederholt werden',
        recurring: 'Wiederkehrend',
        amount: 'Betrag',
        status: 'Status',
        inviteWhenActive: 'Mitarbeiter einladen, sobald die Zuwendung fällig wird',
        sendMailWhenActive: 'Mitarbeiter auch per Mail informieren',
        employee: 'Mitarbeiter',
      },
      addIncentive: 'Sachzuwendung 37b hinzufügen',
      addGift: 'Aufmerksamkeit hinzufügen',
      giftType: {
        GIFT: 'Aufmerksamkeit',
        INCENTIVE: 'Sachzuwendung 37b',
      },
      maxIncentiveAmountWarning:
        'Es dürfen maximal 10.000€ pro Jahr und Mitarbeiter ausgeschüttet werden, diese Auszahlung würde die maximale Summe pro Jahr überschreiten',
      placeHolderInput: {
        inputLabel: 'Nachricht an Ihren Mitarbeiter',
        firstNameChipLabel: 'Vorname',
        lastNameChipLabel: 'Nachname',
      },
      // c.f. CouponsV2GiftStatus
      status: {
        PENDING: 'geplant',
        INVOICE_CREATED: 'in Rechnung gestellt',
        DELIVERED: 'abgeschlossen',
        AVAILABLE: 'abgeschlossen',
      },
    },
    giftsPage: {
      breadcrumbTitle: 'Sachbezug Flex',
      subTitle: 'Sachzuwendungen',
      goToEmployee: 'Zum Mitarbeiter',
      tab: {
        pending: 'Geplant',
        delivered: 'Zugeflossen',
      },
    },
  },
  placeholderInput: {
    tooltip: 'Dieser Platzhalter wird automatisch mit dem {{label}} des Mitarbeiters befüllt',
  },
  customBenefitsModule: {
    title: 'Eigene Benefits',
    subTitle: 'Konfiguration',
    configureTab: 'Konfiguration',
    configureButton: 'Benefit konfigurieren',
    configureButtonHint: 'Dieser Benefit wird selbst verwaltet.',
    createDialog: {
      title: '{{customBenefit}} im Arbeitgeber Portal aktivieren?',
      description:
        'Wollen Sie diesen Benefit im Arbeitgeber Portal aktivieren? Nach der Aktivierung können Sie den Benefit individuell für Ihr Unternehmen konfigurieren. Erst nachdem Sie den Benefit einzelnen Mitarbeitern freigeschaltet haben wird er für diese sichtbar.',
      support:
        'Falls Sie Fragen zum Benefit {{customBenefit}} haben oder wir Sie bei der Suche nach einem geeigneten Partner unterstützen können, wenden Sie sich bitte an Ihren persönlichen Ansprechpartner.',
      confirm: 'Jetzt Konfigurieren',
      cancel: 'Abbrechen',
    },
    benefits: {
      JOB_BIKE: {
        title: 'Firmenfahrrad',
        description:
          'Mitarbeiter gesund halten und gleichzeitig noch was für die Umwelt tun? Mit JobRad können Sie für Ihre Mitarbeiter ein beliebiges Wunschrad leasen – vollständig als Gehaltsumwandlung oder mit einem Zuschuss. Ob für Arbeit, Sport oder Urlaub: Das JobRad ist ein ständiger Begleiter, der täglich Wertschätzung zeigt.',
      },
      URBAN_SPORTS_CLUB: {
        title: 'Urban Sports Club',
        description:
          'Die Gesundheit Ihrer Mitarbeiter mit einem flexiblen Sportangebot unterstützen? Urban Sport Club macht’s möglich! Bieten Sie Ihren Mitarbeitern die freie Wahl aus tausenden Sportangeboten. Damit unterstützen Sie nicht nur die Leistungsfähigkeit, sondern stärken auch die Mitarbeiterbindung und Attraktivität für neue Bewerber.',
        infoTextFull: `Sie können Ihre Mitarbeiter mit einem Zuschuss zum Firmenfitnessanbieter Urban Sports Club unterstützen. Über den Sachbezug haben Arbeitgeber die Möglichkeit, ihren Mitarbeitern den Beitrag für Urban Sports Club steuerfrei zu finanzieren.
        <br><br>
        Ihre Mitarbeiter haben die Möglichkeit, die Mitgliedschaft bei Urban Sports Club direkt über die App zu aktivieren, zu verwalten und auch zu nutzen. Zudem kann auch parallel zu Urban Sports Club das Modul für Sachbezugsgutscheine aktiviert werden, wodurch Mitarbeiter flexibel zwischen den Gutscheinen und Urban Sports Club wählen können.
        <br><br>
        <strong>Um die steuerlichen Vorteile von Urban Sports Club als Sachbezug zu nutzen, gelten folgende Regelungen:</strong>
        <ul>
        <li>Die Freigrenze von 50€ monatlich je Mitarbeiter darf nicht überschritten werden. Hier müssen auch ggf. weitere Sachbezüge wie steuerfreie Gutscheine oder Gesundheitsbudgets berücksichtigt werden.</li>
        <li>Der Zuschuss zum Fitnessstudio darf nicht in Form einer Gehaltsumwandlung erfolgen und wird zusätzlich zum ohnehin geschuldeten Lohn gewährt.</li>
        <li>Es darf keine Auszahlung des Fitnessstudiozuschusses in Form von Barlohn erfolgen.</li>
        <li>Der Mitgliedsvertrag muss monatlich kündbar sein.</li>
        <li>Der Mitgliedsvertrag muss zwischen dem Arbeitgeber und dem Firmenfitnessanbieter bestehen.</li>
        </ul>`,
        infoTextVideos: {
          managerSpecific: 'Arbeitgeber-Portal Urban Sports Club',
          appSpecific: 'App Urban Sports Club',
        },
      },
      INTERNET_FLAT_RATE: {
        title: 'Internetzuschuss',
        description:
          'Mit dem Internetzuschuss können Sie monatlich einen steuerfreien Betrag von bis zu 50€ direkt über das Gehalt auszahlen oder auch einmalige Kosten erstatten - steuerbegünstigt mit einer Pauschalsteuer von 25%. Hierbei sind sowohl Einrichtungskosten und laufende Gebühren für eine Flatrate als auch technische Geräte voll erstattungsfähig.',
      },
      EMPLOYEE_OFFERS: {
        title: 'Mitarbeiterangebote',
        description:
          'Ein Mitarbeiterprogramm, das begeistert: Mit Corporate Benefits können Sie Ihre Mitarbeitern Zugang zu attraktiven Mitarbeiterangeboten geben. Die vielfältigen Rabattcodes bei Marken wie Apple, Adidas oder Jochen Schweizer können Ihre Mitarbeiter direkt im Store oder online einlösen.',
      },
      EMPLOYEE_ACTIONS: {
        title: 'Mitarbeiteraktionen.de',
        description:
          'Sie möchten Ihren Mitarbeitern was Gutes tun und dabei den Spaßfaktor nicht vernachlässigen? Mit Mitarbeiteraktionen können Sie Ihren Mitarbeitern anhand von Rabattaktionen für Veranstaltungen, Erlebnisse, Gastronomie und Online-Shopping die Freizeit noch schöner gestalten und dabei parallel das Employer Branding stärken.',
      },
      HEALTH_BUDGET: {
        title: 'Gesundheitsbudget',
        description:
          'Gesundheit steht als Synonym für hohe Lebensqualität. Mit einem Gesundheitsbudget für Ihre Mitarbeiter investieren Sie nicht nur in deren Wohlbefinden, sondern steigern auch zugleich die Arbeitgeberattraktivität und Mitarbeiterbindung. Sowohl ambulante als auch stationäre und zahnärztliche Leistungen können durch ein Gesundheitsbudget ermöglicht werden.',
        infoTextFull: `Sie können für Ihre Mitarbeiter eine betriebliche Krankenversicherung abschließen, wodurch Ihren Mitarbeitern ein jährliches Gesundheitsbudget zur Verfügung gestellt wird. Das Gesundheitsbudget bietet einen zusätzlichen Schutz im Falle von Krankheit oder Verletzung.
          <br><br>
          Die Beiträge zur betrieblichen Krankenversicherung können steuerfrei über den 50€ Sachbezug abgerechnet werden.
          <br><br>
          <strong>Um die steuerlichen Vorteile des Gesundheitsbudgets als Sachbezug zu nutzen, gelten folgende Regelungen:</strong>
          <ul>
          <li>Die Freigrenze von 50€ monatlich je Mitarbeiter darf nicht überschritten werden. Hier müssen auch ggf. weitere Sachbezüge wie steuerfreie Gutscheine oder Fitnessstudio-Mitgliedschaften berücksichtigt werden.</li>
          <li>Das Gesundheitsbudget darf nicht in Form einer Gehaltsumwandlung erfolgen und wird zusätzlich zum ohnehin geschuldeten Lohn gewährt.</li>
          <li>Es darf keine Auszahlung des Gesundheitsbudgets in Form von Barlohn erfolgen.</li>
          </ul>`,
      },
      CAPITAL_FORMING_BENEFITS: {
        title: 'Vermögenswirksame Leistungen',
        description:
          'Geld ansparen ist für fast alle Menschen ein wichtiges Thema. Unterstützen Sie deshalb Ihre Mitarbeiter durch vermögenswirksame Leistungen bei Sparplänen wie Baufinanzierung oder ETF Sparplänen und binden Sie sie damit an Ihr Unternehmen.',
      },
      RECOVERY_SUPPORT: {
        title: 'Erholungsbeihilfe',
        description:
          'Die Erholung und das Wohlbefinden von Mitarbeitern nehmen heute einen hohen Stellenwert ein – auch für deren Leistungsfähigkeit. Entlasten Sie Ihre Mitarbeiter mit einem jährlichen Zuschuss zu entspannenden Aktivitäten, wie Urlaubsreisen oder Besuchen in Wellnesshotels.',
      },
      CUSTOM_BENEFIT: {
        title: 'Eigenes Benefit',
        description:
          'Sie haben weitere Benefits im Unternehmen? Über diese Schaltfläche können Sie auch diese flexibel in Probonio integrieren.',
      },
    },
    customBenefitCreatorPage: {
      deleteCustomBenefit: 'Benefit löschen',
      successDelete: 'Benefit erfolgreich gelöscht',
    },
    customBenefitDeletionModal: {
      title: 'Benefit löschen',
      text: 'Wollen Sie den Benefit {{title}} wirklich unwiderruflich löschen? Die Löschung ist nur möglich, sofern der Benefit nicht gerade aktiviert ist.',
      conflict: 'Der Benefit {{title}} kann nicht gelöscht werden, da er noch für {{employees}} Mitarbeiter aktiviert ist.',
    },
    customBenefitCreator: {
      successUpdate: 'Benefit erfolgreich geändert',
      successCreate: 'Benefit erfolgreich erstellt',
      subTitle: 'Weiteres Benefit',
      menu: {
        switch_active: 'Benefit aktiv',
      },
      content: {
        backButton: 'Zurück',
        nextButton: 'Weiter',
        confirmButton: 'Benefit speichern',
        summaryStep: {
          title: 'Kachel in der App',
          description: 'Im ersten Schritt Konfigurieren Sie den Namen, das Icon und das Titelbild des neuen Benefits',
          confirmButton: 'Weiter',
          nonCashRelevant: 'Sachbezugsrelevant',
          nonCashRelevantHelperText:
            'Ist dieser Benefit ein Sachbezug (z.B. Fitnesstudio, Versicherungen)? Falls aktiv werden Sie gewarnt, sollten Sie die Gesamtobergrenze von 50€ für den Nutzer übersteigen.',
          switch: 'Als Kachel in der Mitarbeiter-App anzeigen',
          switchHelperText:
            'Soll Mitarbeitern für diesen Benefit eine Kachel in der Mitarbeiter App angezeigt werden? Mitarbeiter sehen die Kachel erst, nachdem der Benefit für Sie individuell freigeschalten wurde',
          inputTitle: 'Titel',
          inputHelperText:
            'Bestimmen Sie einen Titel für Ihren Benefit, der Titel wird den Mitarbeitern in Ihrer Mitarbeiter-App angezeigt',
          selectPictureText: 'Titelbild auswählen',
          selectPictureHelperText: 'Laden Sie ein passendes Titelbild für die Kachel hoch',
          muiIconsHelperText: 'Wählen Sie ein passendes Icon für den Benefit',
        },
        textStep: {
          title: 'Benefit Beschreibung',
          description: 'Schreiben Sie nun einen Text für den Benefit. Der Text wird den Mitarbeitern in der App angezeigt',
        },
        visualisationStep: {
          benefitAmountThisMonth: 'Diesen Monat erhalten',
          benefitAmountOverall: 'Insgesamt erhalten',
          availableAmount: 'von möglichen {{amount, euro-float}}',
          amount: '{{amount, euro-float}}',
          title: 'Weitere Einstellungen',
          description: 'Im letzten Schritt konfigurieren Sie die Visualisierung und Vergütung des Benefits',
          switch: 'In monetärer Visualisierung anzeigen',
          switchHelperText:
            'Soll der Benefit den Mitarbeitern in der App visualisiert werden? Nur empfohlen für monetäre Benefits. Mitarbeiter sehen den Zuschuss des Benefits erst in der Visualisierung, nachdem der Benefit für Sie individuell freigeschalten wurde.',
          inputTitle: 'Üblicher Zuschuss',
          inputHelperText:
            'Legen Sie hier fest, wie hoch der übliche monatliche Zuschuss für diesen Benefit ist. Dieser Wert wird dann als Standard Wert verwendet, wenn Sie einem Mitarbeiter den Benefit freischalten',
        },
      },
    },
    topPanel: {
      description:
        'Wenn Sie bereits andere Benefits im Unternehmen anbieten, können Sie diese auch über Probonio darstellen und Ihre Mitarbeiter darüber informieren.',
    },
    changeMode: {
      lightMode: 'Hellmodus',
      darkMode: 'Dunkelmodus',
    },
  },
  tenantModule: {
    title: 'Unternehmenseinstellungen',
    tab: {
      paymentSettings: 'Rechnungsinformationen',
      hrSystem: 'Integration Personio',
      kombo: 'Integration HR System',
      benefitTemplates: 'Vorlagen',
      customisationSettings: 'Corporate Design',
      benefitSorting: 'Benefit-Sortierung',
      invoices: 'Rechnungen',
      fiscalYear: 'Geschäftsjahr & Fristen',
    },
    imageError: 'Bitte verwenden Sie eine Bild Datei.',
    paymentSettings: {
      title: 'Rechnungsinformationen',
      info: 'Verwalten Sie hier Ihre Einstellungen zu den Rechnungsinformationen. Die Einstellungen können selbstständig von Ihnen angepasst werden.',
      address: {
        title: 'Firmendaten',
        info: 'Hinterlegen Sie hier bitte Ihre Firmenanschrift und Mail-Adresse. Diese kann jederzeit von Ihnen angepasst werden. Alle Rechnungen erhalten Sie an diese Mail-Adresse. Sie können im entsprechenden Feld einen abweichenden Firmennamen angeben, der auf der erstellten Rechnung erscheinen soll.',
      },
      successToast: 'Änderung erfolgreich gespeichert',
      errorToast: 'Änderung konnte nicht gespeichert werden',
      notMoreThanFive: 'Bitte nicht mehr als fünf E-Mail-Adressen eingeben!',
      rlvLocked:
        'Der Firmenname kann nicht geändert werden, solange ein aktiver Rahmenleasingvertrag (RLV) besteht. Bitte wenden Sie sich an <0>rlv@bikeleasing.de</0>.',
      fields: {
        tenantName: 'Firmenname',
        tenantInvoiceName: 'Abweichender Firmenname auf Rechnungen',
        tenantStreet: 'Straße / Hausnummer',
        tenantStreetLine2: 'Adresszusatz (optional)',
        tenantRegion: 'Bundesland',
        tenantAddressCountry: 'Land',
        tenantCountryCode: 'Firmensitz',
        tenantPostalCode: 'Postleitzahl',
        tenantCity: 'Ort',
        tenantLegalForm: 'Gesellschaftsform',
        tenantImage: 'Firmenlogo (horizontal)',
        tenantMail: 'Kontakt E-Mail',
        invoiceEmailList: 'E-Mail-Adressen für Rechnungen',
        isAddressEnabled: 'Adresse',
      },
    },
    paymentMethods: {
      title: 'Zahlungsarten',
      info: 'Unsere Zahlungsoptionen sind einfach und sicher. Die Zahlung ist via Überweisung Vorkasse und SEPA Firmenlastschrift möglich.',
      active: 'Aktiv',
      inProgress: 'In Bearbeitung',
      activate: 'Wählen',
      bankTransfer: 'Überweisung Vorkasse',
      bankTransferInfo:
        'Bezahlen Sie Ihre Rechnungen via Überweisung Vorkasse. Wählen Sie selbst zwischen einer Einmalüberweisung oder einer Echtzeitüberweisung.',
      sepa: 'SEPA Firmenlastschrift',
      sepaInfo:
        'Bezahlen Sie Ihre Rechnungen bequem und einfach via SEPA-Lastschrift. Der Vorteil: Sie zahlen immer pünktlich, da das Geld automatisch eingezogen wird. Richten Sie Ihr Firmenlastschriftmandat jetzt in nur fünf Schritten ein.',
      methodName: 'Zahlungsart: $t(tenantModule:paymentMethods.{{paymentMethod}})',
      sepaInProgress: '(SEPA Firmenlastschrift in Bearbeitung)',
      changeHint: 'Die Zahlungsart können Sie in den <0>Unternehmenseinstellungen</0> ändern.',
      fileConflict: {
        uploadMandate: 'Bitte unterschreiben Sie das Dokument vor dem Upload',
        uploadConfirmation: 'Bitte laden Sie hier die Bankbestätigung hoch',
      },
      maxFileSize: 'Maximale Dateigröße: 5 MB',
      confirmChange: {
        title: 'Zahlungsart ändern',
        text: 'Sie zahlen aktuell bequem via SEPA Firmenlastschrift. Sind sie sicher, dass Sie zum manuellen Überweisungs-Prozess zurück wechseln möchten?',
      },
      sepaStepper: {
        invalidIban: 'Ungültige oder nicht unterstützte IBAN',
        step: {
          bankInfo: {
            title: 'Bankdaten',
            header: 'Bankdaten',
            info: 'Tragen Sie hier Ihre IBAN ein und laden Sie die Mandatsvorlage herunter. In der Vorlage werden alle relevanten Informationen wie IBAN, BIC, Ihr Kreditinstitut sowie Ihre Mandatsreferenznummer automatisch für Sie eingetragen.',
            downloadButton: 'Vorlage herunterladen',
            pleaseDownload: 'Bitte laden sie die Mandats-Vorlage herunter, um fortzufahren',
            field: {
              iban: 'IBAN',
              ibanHelper: 'Akzeptierte Länder: {{countries}}',
              bic: 'BIC',
              bankName: 'Kreditinstitut',
            },
          },
          uploadMandate: {
            title: 'Lastschriftmandat',
            header: 'Lastschriftmandat hochladen',
            info: `Bitte füllen Sie das soeben heruntergeladene Dokument aus, unterschreiben Sie es und laden Sie es anschließend hier hoch. Senden Sie zusätzlich das ausgefüllte Dokument an Ihre Bank und bitten Sie um eine schriftliche Bestätigung der Hinterlegung, die Sie im nächsten Schritt bei uns einreichen. Beachten Sie, dass bei der SEPA-Firmenvariante die Lastschrift vor Einlösung durch Ihre Bank überprüft wird. Daher ist es erforderlich, eine Kopie des Lastschriftmandats bei Ihrer Bank zu hinterlegen. Die Bestätigung der Hinterlegung ist im kommenden Schritt einzureichen. Beispielsweise akzeptieren wir sowohl eine ausgefüllte Vorlage Ihrer Bank als auch einen Bankstempel auf Ihrem ausgefüllten Lastschriftmandat.`,
            downloadLink: 'Hochgeladenes Lastschriftmandat',
            clearTitle: 'Lastschriftmandat löschen',
            clearText:
              'Sind Sie sicher, dass Sie das hochgeladene Lastschriftmandat zurücksetzen wollen? Sie müssen dieses Dokument sowie die Bankbestätigung dann erneut hochladen.',
          },
          submitMandate: {
            title: 'Mandat übermitteln',
            info: 'Bitte senden Sie das ausgefüllte und unterschriebene SEPA-Lastschriftmandat an Ihre Bank und bitten Sie um eine schriftliche Bestätigung der Hinterlegung. Diese Bestätigung können Sie im nächsten Schritt bei uns hochladen.',
            checkBox: 'Hiermit bestätige ich, dass ich das Mandat an meine Bank übermittelt habe.',
          },
          uploadConfirmation: {
            title: 'Bestätigung SEPA',
            header: 'Bankbestätigung hochladen',
            info: 'Sobald Ihre Bank Ihnen die Hinterlegung des SEPA-Firmenlastschriftmandats schriftlich bestätigt hat, können Sie die Bestätigung hier hochladen. Ohne die Bestätigung Ihrer Bank, können wir das Mandat leider nicht zum Einzug verwenden.',
            downloadLink: 'Hochgeladene Bankbestätigung',
            clearTitle: 'Bankbestätigung löschen',
            clearText:
              'Sind Sie sicher, dass Sie die hochgeladene Bankbestätigung zurücksetzen wollen? Sie müssen dieses Dokument dann erneut hochladen.',
            infoAccountingReference:
              'Laden Sie das unterschriebene Mandat mit der Referenz <strong>{{accountingCustomerNumber}} </strong> hoch',
            customerConfirmation: {
              title: 'Bestätigung ohne Bankbestätigung',
              subtitle: 'Bitte bestätigen Sie die folgenden Punkte, um ohne Bankbestätigung fortzufahren',
              label: 'Meine Bank kann keine Bestätigung ausstellen',
              confirmedByUser: 'SEPA-Lastschriftmandat wurde eigenständig bestätigt von <0>{{firstName}} {{lastName}}</0>',
              confirmedByFormerUser:
                'Das SEPA-Lastschriftmandat wurde eigenständig bestätigt, aber die bestätigende Person ist nicht mehr im Unternehmen beschäftigt',
              chargebackFees:
                'Ich nehme zur Kenntnis, dass etwaige Rücklastschriftgebühren, die durch fehlgeschlagene Abbuchungen entstehen, von mir zu tragen sind.',
              sepaDeactivation:
                'Im Falle wiederholter Rücklastschriften behält sich Probonio vor, die Zahlungsart SEPA-Lastschrift dauerhaft zu deaktivieren. In diesem Fall ist eine Zahlung nur noch per Überweisung möglich.',
              fraudProtection:
                'Ich nehme zur Kenntnis, dass aus Gründen des Betrugsschutzes (Fraud Protection) die erste Guthaben Buchung nach SEPA-Einzug verzögert erfolgt: Die Verbuchung des Guthabens erfolgt frühestens ab Einzug nach fünf Bankarbeitstagen. Bei allen weiteren Abbuchungen erfolgt die Gutschrift innerhalb von ca. 24 Stunden.',
              mandatoryMandateSubmission:
                '<strong>Verpflichtende Mandatsübermittlung:</strong> Damit der SEPA-Einzug technisch erfolgreich durchgeführt werden kann, muss das SEPA-Mandat aktiv von Ihnen an Ihre Bank übermittelt und dort hinterlegt werden (unabhängig davon, ob Sie eine Bankbestätigung hochladen). Erfolgt diese Übermittlung nicht, lehnt die Bank den Einzug ab - eine Rücklastschrift ist die Folge.',
            },
          },
          complete: {
            title: 'Abschließen',
            headerInProgress: 'Wir prüfen Ihre Dokumente',
            headerComplete: 'SEPA Firmenlastschrift aktiv',
            infoInProgress:
              'Der Wechsel von Überweisung zu SEPA-Firmenlastschrift ist abgeschlossen, sobald wir Ihre Mandatsunterlagen geprüft haben.',
            infoComplete:
              'Ihr SEPA Firmenlastschrift ist nun aktiv. Ab sofort zahlen Sie Ihre Rechnungen immer automatisiert und pünktlich. Der Einzug dauert 1-3 Bankarbeitstage.',
            accountingReference: 'Mandatsreferenz: ',
          },
        },
      },
    },
    invoices: {
      downloadFile: 'Probonio_Rechnung_{{date}}.pdf',
      invoice: {
        date: 'Datum',
        type: {
          title: 'Rechnungsart',
          COUPON_BUDGET: 'Coupon-Budgetaufladung',
          SERVICE_FEE: 'Servicegebühr',
          AUTOMATED_ORDER: 'Automatische Guthabenaufladung',
          COUPONS_V2_TOKENS: 'Probonio Gutscheinaufladung',
          URBAN_SPORTS_CLUB: 'Probonio X Urban Sports Club',
          CREDIT_CARD_ORDER_FEE: 'Kreditkarten-Bestellgebühr',
        },
        accountingInvoiceNumber: 'Rechnungsnummer',
        amount: 'Gesamtbetrag',
        status: {
          title: 'Status',
          DRAFT: 'Bearbeitung',
          OPEN: 'Offen',
          PAID: 'Bezahlt',
          VOIDED: 'Storniert',
        },
        actions: {
          pending: 'Rechnung in Erstellung',
          download: 'Rechnung herunterladen',
        },
      },
    },
    hrSystem: {
      title: 'Integration Personio',
      info: ' Diese Integration ermöglicht es Ihnen, die Stammdaten Ihrer Mitarbeiter direkt von Personio an Probonio zu übertragen',
      guide: {
        title: 'Anleitung',
        info: '<p>Verbinden Sie ganz einfach Probonio mit Personio und vermeiden Sie mehrfaches manuelles Einpflegen von Mitarbeiterdaten. Durch die Integration werden in Personio angelegte Mitarbeiter automatisch nach Probonio übertragen. Die Synchronisierung findet jede Nacht statt, Sie können Sie aber auch jederzeit manuell starten.</p><p><i>Deaktivierte Mitarbeiter in Personio werden auch in Probonio deaktiviert.</i></p>',
        section1Title: 'So verbinden Sie Ihre Personio-Anwendung mit Probonio',
        section1Text: `<p>Folgen Sie diesen einfachen Schritte, um eine Verbindung zwischen Personio und Probonio herzustellen:</p>
          <ol>
            <li>
              <strong>Probonio auf dem Personio-Marketplace suchen:</strong>
            </li>
            <ul>
              <li>
                Melden Sie sich in Ihrem Personio-Konto an.
              </li>
              <li>
                Gehen Sie zum <strong>Marketplace</strong> im Hauptmenü.
                <br />
                <strong>Hinweis</strong>: Wenn Sie diesen Reiter nicht sehen, haben Sie nicht die erforderlichen Rechte die Integration zu verbinden.
              </li>
              <li>
                Geben Sie im Suchfeld <strong>Probonio</strong> ein.
              </li>
            </ul>
            <li>
              <strong>Probonio mit Personio verbinden:</strong>
            </li>
            <ul>
              <li>
                Klicken Sie auf den <strong>Verbinden</strong> Button neben <strong>Probonio</strong>.
              </li>
              <li>
                Dadurch wird der Einrichtungsprozess für die Integration gestartet.
              </li>
            </ul>
            <li>
              <strong>API-Zugangsdaten erstellen:</strong>
            </li>
            <ul>
              <li>
                Nach der Verbindung werden Sie aufgefordert, API-Zugangsdaten zu generieren.
              </li>
              <li>
                Klicken Sie auf <strong>API-Zugangsdaten generieren</strong>, um Ihre <strong>Client-ID</strong> und Ihr <strong>Client-Secret</strong> zu erhalten.
              </li>
              <li>
                Kopieren Sie beide Werte, da sie für die Verbindung erforderlich sind.
              </li>
            </ul>
            <li>
              <strong>Zugangsdaten in Probonio einfügen:</strong>
            </li>
            <ul>
              <li>
                Wechseln Sie zur Probonio-Plattform und navigieren Sie zu den Integrationseinstellungen.
              </li>
              <li>
                Fügen Sie die <strong>Client-ID</strong> und das <strong>Client-Secret</strong> in die entsprechenden Felder ein.
              </li>
              <li>
                Speichern Sie die Änderungen indem Sie auf den Button <strong>Verbinden</strong> drücken, um die Verbindung abzuschließen.
              </li>
            </ul>
          </ol>
          <p>
          Sobald diese Schritte abgeschlossen sind, ist Probonio erfolgreich mit Personio verbunden, und es werden Mitarbeiter direkt von Personio zu Probonio übertragen.
          <br />
          Falls Sie nur bestimmte Mitarbeiter von Personio zu Probonio synchronisieren wollen, können Sie jederzeit auf unser Support-Team für genauere Hinweise zukommen.
          </p>`,
        advancedTutorial: `Das folgende Tutorial führt Sie durch den Integrationsprozess. Falls Sie eine detailliertere Anleitung wünschen, klicken Sie hier für eine <0>Anleitung mit Bildern</0>.`,
      },
      status: {
        connected: 'Integration aktiv',
        lastSync: '<strong>Letzte Synchronisierung:</strong> {{date,datetime}}',
        syncError: 'Fehler bei Synchronisierung: {{message}}',
      },
      form: {
        apiKey: 'Client ID',
        apiSecret: 'Client Secret',
        connect: 'Verbinden',
        syncNow: 'Jetzt synchronisieren',
        disconnect: 'Verbindung trennen',
        connectionError: 'Anmeldung bei Personio API fehlgeschlagen',
      },
      instantInvite: {
        label: 'Neue Mitarbeiter über diese Schnittstelle sofort einladen',
        successToast: 'Änderung erfolgreich gespeichert',
      },
    },
    kombo: {
      title: 'Integration HR System',
      info: 'Diese Integration ermöglicht es Ihnen, die Stammdaten Ihrer Mitarbeiter direkt vom gewählten HR System an Probonio zu übertragen.',
      guide: {
        title: 'Anleitung',
        info: '<p>Verbinden Sie ganz einfach Probonio mit Ihrem HR System und vermeiden Sie mehrfaches manuelles Einpflegen von Mitarbeiterdaten. Durch die Integration werden im HR System angelegte Mitarbeiter automatisch nach Probonio übertragen. Die Synchronisierung findet automatisch im Hintergrund statt, Sie können Sie aber auch jederzeit manuell starten.</p><p><i>Deaktivierte Mitarbeiter im HR System werden auch in Probonio deaktiviert.</i></p>',
        advancedTutorial: `Das folgende Tutorial führt Sie durch den Integrationsprozess. Falls Sie eine detailliertere Anleitung wünschen, klicken Sie hier für eine <0>Anleitung mit Bildern</0>.`,
      },
      status: {
        connected: 'Integration aktiv seit {{createdAt,date}}',
        lastSync: '<strong>Letzte Synchronisierung:</strong> {{date,datetime}}',
        syncError: 'Fehler bei Synchronisierung: $t(tenantModule:kombo.syncError.{{errorKey}})',
        setupIncomplete: 'Konfiguration unvollständig',
        inactive: 'Integration deaktiviert, bitte Support kontaktieren',
        initial: 'Wartet auf initiale Synchronisierung',
        syncPlanned: 'Synchronisierung wird verarbeitet...',
      },
      syncError: {
        AUTHENTICATION_FAILED: 'Authentifizierung fehlgeschlagen, erneute Verbindung nötig',
        FAILED: 'Unbekannter Fehler, bitte Support kontaktieren',
        PARTIALLY_FAILED: 'Import unvollständig, bitte versuchen Sie es erneut',
      },
      form: {
        connect: 'Einrichtung starten',
        reconnect: 'Neu verbinden',
        syncNow: 'Synchronisierung planen',
        setup: 'Konfiguration ändern',
        disconnect: 'Verbindung trennen',
        confirmDisconnect:
          'Sind Sie sicher, dass Sie die Verbindung zu Ihrem HR System trennen möchten? Die Synchronisierung von Mitarbeitern wird dadurch gestoppt, bereits übertragene Daten werden jedoch nicht gelöscht.',
      },
      toast: {
        connectionCreated: 'Verbindung wurde hergestellt',
        syncQueued: 'Synchronisierung geplant',
        syncAlreadyQueued: 'Synchronisierung bereits geplant',
        integrationDisconnected: 'Verbindung wurde getrennt',
      },
      syncModal: {
        title: 'Synchronisierung planen',
        info: '<p>Möchten Sie einen vollständigen Datenabgleich Ihrer Mitarbeiterdaten von {{hrSystemName}} zu Probonio einplanen?</p><p>Dies ist nur bei geänderter Schnittstellen-Konfiguration nötig. Der regelmäßige Datenabgleich findet mehrmals täglich automatisiert statt.</p><p>Durch geänderte Filter ausgeschlossene Mitarbeiter werden dabei auch in Probonio deaktiviert.</p><p><b>Die Synchronisierung findet im Hintergrund statt und kann mehrere Minuten dauern</b>.</p>',
      },
    },
    benefitTemplates: {
      title: 'Benefit-Vorlagen',
      info: 'Erstellen Sie hier Vorlagen für Benefit-Konfigurationen, die sie anschließend Ihren Mitarbeitern zuweisen können.',
      createTemplate: 'Neue Benefit-Vorlage anlegen',
      editTemplate: 'Benefit-Vorlage bearbeiten',
      confirmDelete:
        'Wollen Sie die ausgewählte Vorlage wirklich entfernen? Dies hat keine Auswirkungen auf bereits konfigurierte Mitarbeiter.',
      benefitsTitle: 'Benefits in dieser Vorlage',
      benefitsInfo:
        'Die hier konfigurierten Benefits werden für den gewählten Mitarbeiter aktiviert, sobald die Vorlage angewandt wird. Nachträgliche Änderungen haben keinen Einfluss auf bereits konfigurierte Mitarbeiter.',
      successCreate: 'Vorlage erstellt',
      successUpdate: 'Vorlage aktualisiert',
      successDelete: 'Vorlage gelöscht',
      noBenefitsWarning: 'In dieser Vorlage sind noch keine Benefits konfiguriert. Bitte fügen Sie mindestens einen Benefit hinzu.',
      benefitUnavailable: 'Benefit nicht mehr verfügbar',
      defaultTemplate: 'Standard',
      editItemDialog: {
        title: 'Benefit konfigurieren',
        info: 'Geben Sie hier die Parameter ein, die Sie in der Vorlage hinterlegen möchten. Diese werden übernommen, sobald die Vorlage für ein oder mehrere Mitarbeiter angewandt wird. Nachträgliche Änderungen haben keinen Einfluss auf bereits konfigurierte Mitarbeiter',
        warning: 'Nachträgliche Änderungen haben keinen Einfluss auf bereits konfigurierte Mitarbeiter',
      },
      field: {
        name: 'Name',
        isDefault: 'Diese Vorlage automatisch auf neue Mitarbeiter anwenden (einschließlich automatisierter Schnittstellen *)',
        isDefaultHint: '* Solange keine Vorlage über die HR-Schnittstelle gesetzt wird',
      },
      action: {
        newTemplate: 'Neue Vorlage erstellen...',
        delete: 'Vorlage löschen',
        addBenefit: 'Benefit hinzufügen',
        editItem: 'Benefit konfigurieren',
        deleteItem: 'Benefit löschen',
      },
    },
    customisationSettings: {
      title: 'Corporate Design',
      info: 'Ändern Sie hier das Design Ihrer Mitarbeiter-App. Die Einstellungen können selbstständig von Ihnen angepasst werden.',
      logo: {
        title: 'Logo',
        info: 'In der Probonio-Software haben Sie die Möglichkeit, alle Anwendungen mit Ihrem Firmenlogo zu branden. Das Logo wird nach dem Upload sowohl in Ihrem Arbeitgeber-Portal als auch in der Mitarbeiter-App angezeigt.',
      },
      generatePreview: 'Vorschau generieren',
      getDefault: 'Auf Standardwerte zurücksetzen',
      uploadLogo: 'Helles Firmenlogo',
      uploadLogoDark: 'Dunkles Firmenlogo',
      changeImageTooltip: 'Helles Firmenlogo ändern',
      changeImageTooltipDark: 'Dunkles Firmenlogo ändern',
      successToast: 'Firmendaten erfolgreich aktualisiert',
      guide: {
        backgroundColor: {
          title: 'Hintergrundfarbe',
          info: 'Für den App-Hintergrund empfehlen wir helle Farben im hellen Design und dunklere im dunklen Design, um wichtige Icons sichtbar zu halten.',
        },
        accentColor: {
          title: 'Akzentfarbe',
          info: 'Diese Farbe wird für die Icons der App (z. B. bei den Kacheln) verwendet. Wir empfehlen, hierfür eine relativ helle Farbe zu verwenden.',
        },
        buttonColor: {
          title: 'Buttonfarbe',
          info: 'Diese Farbe wird für alle Buttons der App verwendet. Diese Farbe sollte dunkler sein als die Iconfarbe.',
        },
        lightTheme: 'Hell',
        darkTheme: 'Dunkel',
      },
      warning:
        '<strong>Achtung:</strong> Diese Vorschau verwendet echte Daten. <br /> Wenn Sie sich mit einem Microsoft-Account registriert haben, müssen Sie sich zuerst in der <0>App</0> anmelden.',
    },
    benefitSorting: {
      title: 'Benefit-Sortierung',
      info: 'Ändern Sie hier die Reihenfolge angezeigter Benefits in Ihrer Mitarbeiter-App. Die Einstellungen können selbstständig von Ihnen angepasst werden.',
      subTitle: 'Reihenfolge der visualisierten Benefits',
      subInfo: `
       <p>Passen Sie die Reihenfolge der Benefits in der App individuell via Drag and Drop an.</p>
          <ul>
          <li>Änderungen werden nach dem Speichern direkt live in der App angezeigt.</li>
          <li>Nutzer sehen immer nur die Benefits, die freigeschaltet sind.</li>
          <li>Flex Benefits werden automatisch unter der Kategorie „Flex“ zusammengefasst – Flex Benefits können nicht einzeln sortiert werden</li>
          <li>Der Benefit "Mitarbeiterkommunikation" wird erst angezeigt, wenn Artikel veröffentlicht werden.</li>
          </ul>`,
      successToast: 'Sortierung erfolgreich aktualisiert',
    },
    fiscalYear: {
      title: 'Geschäftsjahr & Fristen',
      info: 'Verwalten Sie hier das Ende des Geschäftsjahres und die Fristen für den Belegupload.',
      successToast: 'Einstellungen erfolgreich gespeichert',
      fiscalYearEnd: {
        title: 'Ende des Geschäftsjahres',
        info: 'Dieses Datum kann für Belegupload und Auszahlungen relevant sein. Wenn nichts anderes eingestellt ist, gilt 31.12. als Ende des Geschäftsjahres.',
      },
      closeDelay: {
        title: 'Frist für den Belegupload',
        info: 'Legen Sie fest, wie viele Tage nach Ende des Abrechnungszeitraums Mitarbeiter noch Belege einreichen können.',
        unit: 'Tage',
      },
    },
  },
  tutorialModule: {
    title: 'Probonio Dashboard einrichten',
    buttonDone: 'Als abgeschlossen markieren',
    buttonOpenDrawer: 'Einführung',
    steps: {
      tenantImage: {
        label: 'Firmenlogo',
        description:
          'Ergänzen Sie Ihr Firmenlogo als Bild-Datei. Dieses wird ab dann sowohl in Ihrem Arbeitgeber-Portal als auch in der Mitarbeiter-App angezeigt.',
        help: 'Klicken Sie dazu im Reiter "Corporate Design" in den Unternehmenseinstellungen auf das Feld "Kein Bild ausgewählt" und laden Sie Ihr Logo hoch.',
        buttonText: 'Zu den Einstellungen',
      },
      firstEmployee: {
        label: 'Anlage erster Mitarbeiter',
        description: 'Legen Sie nun Ihre Mitarbeiter an. Sie können mehrere E-Mail-Adressen gesammelt eingeben.',
        help: 'Klicken Sie auf den blauen Button "$t(usersPage:addUser)", den Sie oben rechts auf der Seite "Mitarbeiterstammdaten" finden. Um zu den Mitarbeiterstammdaten zu gelangen, wählen Sie einfach den Punkt "Stammdaten" in der Übersichtsspalte aus.',
        buttonText: 'Zu den Stammdaten',
      },
      configureBenefits: {
        label: 'Konfiguration von Benefits',
        description: `Konfigurieren Sie nun die Benefits für Ihre Mitarbeiter ganz nach Ihren Wünschen. Bestimmen Sie, welche Vorteile Sie anbieten und wer in welcher Höhe davon profitiert.`,
        help: `Klicken Sie in der Übersichtsspalte auf den gewünschten Benefit. Wählen Sie im Untermenü "Mitarbeiter" und gehen Sie auf den Reiter "Benefit inaktiv". Setzen Sie Häkchen vor den E-Mail-Adressen der Mitarbeiter, die Sie auswählen möchten. Anschließend klicken Sie auf den Button "Jetzt für Mitarbeiter konfigurieren", um Anpassungen vorzunehmen und den Benefit zu aktivieren. Alternativ können Sie Benefits auch direkt im Mitarbeiter-Profil einer Person freigeben. Öffnen Sie dazu die Stammdaten und wählen Sie den entsprechenden Mitarbeiter aus. Gehen Sie anschließend auf den Button "Benefit hinzufügen".`,
        buttonText: 'Zu den Stammdaten',
      },
      orderCouponBudget: {
        label: 'Budget-Aufladung Gutscheine',
        description: `Für den Benefit Sachbezug, laden Sie Ihr benötigtes Gutschein-Budget auf. Dieses Budget muss mindestens den Gesamtbetrag der Gutscheine abdecken, die den Mitarbeitern im ersten Monat zur Verfügung stehen sollen.
      Gutscheine können nur ausgewählt und an Mitarbeiter übergeben werden, wenn das Budget ausreichend gedeckt ist.`,
        help: 'Um das Budget aufzuladen, klicken Sie in der Übersichtsspalte auf den Benefit "Sachbezug". Wählen Sie im Untermenü den Reiter "Bestellungen" und dann die Option "Guthaben" rechts oben. Klicken Sie anschließend auf den Button "Aufladen". Alternativ können Sie auch auf die automatische Rechnung warten, die Ihnen entsprechend Ihrer Konfiguration zugesendet wird, da die "automatische Aufladung" aktiviert ist.',
        buttonText: 'Zur Budget-Aufladung',
      },
      informEmployees: {
        label: 'Mitarbeiter informieren',
        description:
          'In einem nächsten Schritt empfehlen wir, Ihre Mitarbeiter über den Beginn der Zusammenarbeit mit Probonio zu informieren.',
        help: 'Gerne unterstützen wir Sie hierbei mit einem Handbuch. Dies erhalten Sie unter dem Punkt "Dokumente" bei Ihrem freigeschalteten Benefit.',
      },
      informEmployeesWithBls: {
        label: 'Mitarbeiter informieren',
        description:
          'In einem nächsten Schritt empfehlen wir, Ihre Mitarbeiter über den Beginn der Zusammenarbeit mit Probonio zu informieren.',
        help: 'Gerne unterstützen wir Sie hierbei mit einem Handbuch. Dies erhalten Sie unter dem Punkt "Dokumente" bei Ihrem freigeschalteten Benefit, für Bikeleasing unter "Informationen & Support".',
      },
      inviteEmployee: {
        label: 'Mitarbeiter einladen',
        description:
          'Laden Sie Ihre Mitarbeiter nun zur Nutzung der App ein, nachdem Sie alle Benefits konfiguriert und das Budget aufgeladen haben.',
        help: 'Klicken Sie dafür auf den grünen "$t(common:userStatusButton.CREATED)"-Button hinter den entsprechenden Mail-Adressen. Diesen finden Sie unter "Stammdaten" im Reiter "In Registrierung". Alternativ können Sie alle Mitarbeiter gesammelt über den grünen Button mit dem Brief-Icon oben rechts einladen. Bitte beachten Sie: Die Benefits werden in der App erst angezeigt, sobald deren Startdatum erreicht ist.',
        buttonText: 'Zur den Stammdaten',
      },
      sepaPayment: {
        label: 'SEPA-Firmenlastschrift einrichten (optional)',
        description: 'Richten Sie Ihr Firmenlastschriftmandat in nur fünf Schritten ein.',
        help: 'Navigieren Sie dazu in Ihre Unternehmenseinstellungen und klicken Sie auf den blauen Button "Wählen" bei der SEPA-Firmenlastschrift, um den Einrichtungsprozess zu starten. Folgen Sie den angezeigten Anweisungen, um Ihre Unternehmensdaten und Bankinformationen einzugeben. Beachten Sie, dass Ihr Mandat erst aktiv ist, sobald Sie per Mail darüber informiert werden. Bis dahin sind alle Rechnungen weiterhin via Überweisung zu begleichen.',
        buttonText: 'Zu den Einstellungen',
      },
      employmentContract: {
        label: 'Zusatzvereinbarung Arbeitsvertrag',
        description: 'Falls Sie wünschen, können Sie mit Ihren Mitarbeitern eine Zusatzvereinbarung zum Arbeitsvertrag schließen.',
        help: 'Eine kostenfreie Vorlage erhalten Sie unter dem Punkt "Dokumente" bei den entsprechenden Benefits.',
      },
      payrollReport: {
        label: 'Integration zur Lohnbuchhaltung',
        description: 'Richten Sie nun die Integration zu Ihrer Lohnbuchhaltung sowie die Auszahlung und Abrechnung Ihrer Benefits ein.',
        help: 'Navigieren Sie dazu in der linken Übersichtsspalte zum gewünschten Benefit und wählen Sie im Untermenü die Option "$t(benefitsModule:report.tabs.export)". Bitte beachten Sie, dass der Lohndatenexport für jedes Benefit separat eingerichtet werden muss. Informationen zu Ihrem Lohnbuchhaltungssystem und den Lohnarten erhalten Sie von Ihrem Steuerbüro oder Ihrer Lohnbuchhaltung.',
      },
      integrationHRSystem: {
        label: 'Integration zum HR-System',
        description:
          'Verbinden Sie Ihr HR-System mit Probonio, damit Mitarbeiterdaten automatisch synchronisiert werden und immer aktuell sind. Auf Wunsch können zudem neue Mitarbeiter nach dem Anlegen im HR-System automatisch zu Probonio eingeladen werden. Kein manueller Aufwand, mehr Zeit für das Wesentliche.',
        buttonText: 'Zur HR Integration',
      },
    },
  },
  bavModule: {
    contractActive: 'Vertragsbeginn am {{startDate, date}}',
    contractIntro:
      'Die Daten des abgeschlossenen bAV-Vertrags werden unten angezeigt. Übermitteln Sie Änderungswünsche mit der Bearbeitungsfunktion an Ihren zuständigen Probonio-Ansprechpartner.',
    contractAppInfo: 'Die Daten sind teilweise für den Mitarbeiter in der Probonio-App einsehbar.',
    requestChange: 'Änderung anfordern',
    changesHint: '<0>*</0> = Änderungen in diesem Feld wurden noch nicht übermittelt',
    requestContact: 'Kontaktanfrage',
    enterComment:
      'Bitte geben Sie Ihre Anfrage unten ein. Wir werden diese umgehend bearbeiten und Sie bei Rückfragen kontaktieren. Ihre Kontaktdaten und die Vertragsdaten werden automatisch mit übermittelt.',
    sendContactRequest: 'Absenden',
    contactSuccessToast: 'Kontaktanfrage übermittelt',
    submitChanges: 'Änderungen übermitteln',
    confirmSubmit:
      'Wollen Sie die mit * markierten Änderungen wirklich übermitteln?\n\nDie Änderungen werden Ihrem zuständigen Probonio-Ansprechpartner zugestellt und sind erst nach Bearbeitung sichtbar.',
    submitSuccessToast: 'Änderungen wurden übermittelt',
    pleaseUseContactForm: 'Bitte verwenden Sie das Kontaktformular, um eine Beitragsänderung anzufordern',
    netValue: '~{{money, euro}} netto',
    periodPremium: '{{money, euro}} Zahlbetrag',
    contractFields: {
      status: 'Status',
      salutation: 'Anrede',
      title: 'Titel',
      firstName: 'Vorname',
      lastName: 'Nachname',
      mail: 'E-Mail',
      dateOfBirth: 'Geburtsdatum',
      street: 'Straße / Hausnummer',
      city: 'Stadt',
      postalCode: 'Postleitzahl',
      country: 'Land',
      employeePremiumGross: 'Arbeitnehmerbeitrag (brutto)',
      employerGrant: 'Arbeitgeberzuschuss',
      vwlConversion: 'VWL-Umwandlung',
      totalPremium: 'Monatl. Gesamtbeitrag',
      startDate: 'Startdatum',
      mainDueDate: 'Hauptfälligkeit',
      paymentPeriod: 'Zahlungsperiode',
      insuranceIBAN: 'IBAN der Versicherung',
      insuranceBIC: 'BIC der Versicherung',
      insuranceBankName: 'Kreditinstitut',
      insuranceName: 'Versicherung',
      insuranceType: 'Durchführungsweg',
      contractNumber: 'Vertragsnummer',
      tariffName: 'Tarifname',
    },
    section: {
      user: 'Vertragsnehmer',
      address: 'Anschrift',
      contract: 'Vertragsdaten',
      billing: 'Abrechnung',
      documents: 'Dokumente',
    },
    status: {
      ACTIVE: 'Aktiv',
      SUSPENDED: 'Pausiert',
      CANCELLED: 'Storniert',
      TRANSFERRED: 'Übertragen',
    },
    insuranceType: {
      DIRECT_INSURANCE: 'Direktversicherung',
      PENSION_POOL: 'Pensionskasse',
      PENSION_FUND: 'Pensionsfonds',
      RELIEF_FUND: 'Unterstützungskasse',
      DIRECT_COMMITMENT: 'Direktzusage',
    },
    paymentPeriod: {
      MONTHLY: 'Monatlich',
      QUARTERLY: 'Quartalsweise',
      YEARLY: 'Jährlich',
    },
    terms: {
      title: 'Versorgungsordnung',
      info: 'Diese Integration ermöglicht es Ihnen, Ihre Versorgungsordnung in der App zu veröffentlichen und sie Ihren Mitarbeitern zugänglich zu machen.',
      submitSuccessToast: 'Änderungen wurden übernommen',
      defaultTemplate: `<p><em>Haftungsausschluss: </em></p><p><em>Bitte beachten Sie, dass dieser Text ein unverbindliches Muster darstellt und im konkreten Einzelfall gegebenenfalls ergänzt und an die individuellen Gegebenheiten des Betriebs angepasst werden muss. Es kann in verschiedenen Fällen nicht geeignet sein, den gewünschten Zweck zu erzielen und ersetzt nicht die anwaltliche Leistung. Wir haben das Muster nach bestem Wissen erstellt. Eine Haftung für die Inhalte wird nicht übernommen. Das Musterschreiben erhebt keinen Anspruch auf Richtigkeit und Aktualität; es dient lediglich als Anregung und Hilfe für Formulierungen. </em></p><h1>Versorgungsordnung über betriebliche Altersversorgung</h1><p>der Muster GmbH </p><p>Musterallee 1 99999 </p><p>Musterhausen </p><p></p><p>(im Nachfolgenden „Arbeitgeber“ genannt) </p><p>Die Mitarbeiterinnen und Mitarbeiter werden im Nachfolgenden geschlechtsneutral „Arbeitnehmer“ genannt. </p><h2>A. Einleitung </h2><h3>1. Regelungsgegenstand </h3><p>Diese Versorgungsordnung regelt die Durchführung der betrieblichen Altersversorgung. Nach § 1a Abs. 1 Satz 1 des Betriebsrentengesetzes (BetrAVG) können Arbeitnehmer die Umwandlung künftiger Entgeltbestandteile zur Finanzierung einer Betriebsrente beanspruchen (Entgeltumwandlung). Der gesetzliche Anspruch auf Entgeltumwandlung ist auf 4 % der jeweiligen Beitragsbemessungsgrenze in der allgemeinen Rentenversicherung begrenzt. </p><h3>2. Teilnahmeberechtigter Personenkreis </h3><p>Das Angebot zur betrieblichen Altersversorgung durch Entgeltumwandlung richtet sich an alle Arbeitnehmer des Arbeitgebers. Voraussetzung ist eine Pflichtversicherung in der gesetzlichen Rentenversicherung. Die Teilnahme an der Entgeltumwandlung erfolgt auf Antrag des Arbeitnehmers. </p><h3>3. Durchführungsweg und Versorgungsträger </h3><p>Die Durchführung der betrieblichen Altersversorgung erfolgt ausschließlich über den Durchführungsweg Direktversicherung.</p><p>Der Arbeitgeber bietet dem Arbeitnehmer mittels Probonio die kostenfreie Möglichkeit für einen Versicherungsvergleich und ein Beratungsgespräch bei einem freien Versicherungsvermittler an, um eine passende Versicherung für seine individuelle Situation zu finden. Der Arbeitnehmer kann diese Versicherung als Vorschlag dem Arbeitgeber vorlegen. Der Arbeitgeber behält sich vor, Vorschläge des Arbeitnehmers zu prüfen, ist jedoch grundsätzlich offen für verschiedene Versicherungen.</p><p>Etwaige Altzusagen in anderen Durchführungswegen und von anderen Versorgungsträgern bleiben davon unberührt.</p><h3>4. Leistungsarten </h3><p>Als Leistungsarten kommen in Betracht: </p><ul><li><span>Altersversorgung</span></li><li><span>vorzeitige Altersversorgung </span></li><li><span>Hinterbliebenenversorgungsleistungen </span></li><li><span>Beitragsbefreiung bei Berufsunfähigkeit </span></li><li><span>Berufsunfähigkeitsrente </span></li><li><span>Grundfähigkeitsrente </span></li></ul><p>Die Festlegung der Leistungsarten erfolgt in einer individuellen Vereinbarung. </p><h2>B. Durchführungsweg Direktversicherung </h2><h3>1. Definition </h3><p>Bei einer Direktversicherung handelt es sich um eine Lebensversicherung (Rentenversicherung), die der Arbeitgeber auf das Leben seines Arbeitnehmers abschließt. Der Arbeitnehmer bzw. seine Hinterbliebenen erhalten ein Bezugsrecht und haben bei Eintritt des Versorgungsfalles einen direkten Rechtsanspruch auf die Leistungen gegen den Versorgungsträger. </p><h3>2. Versorgungszusage </h3><p>Die Versorgungszusagen werden auf Veranlassung des Arbeitgebers als beitragsorientierte Leistungszusage gem. § 1 Abs. 2 Nr. 1 BetrAVG erteilt. Der Arbeitnehmer erhält nach Vertragsabschluss vom Versorgungsträger eine schriftliche Versorgungszusage (Versicherungsschein), in der Art, Höhe und Voraussetzung der Versorgungsleistungen dokumentiert sind. </p><h3>3. Versorgungsleistungen </h3><p>Art und Höhe der Versorgungsleistungen richten sich nach dem Versorgungsbeitrag, den versicherungsmathematischen Grundlagen des gewählten Versicherungstarifs, dem Alter des Arbeitnehmers bei Versicherungsbeginn und der Versicherungsdauer. Weitere Einzelheiten über die Versorgungsleistungen und die maßgeblichen Versicherungsbedingungen sind im Versicherungsschein (Versorgungszusage) festgelegt. Die Versorgungsleistung wird bei Fälligkeit an den Arbeitnehmer bzw. dessen steuerlich zulässige Hinterbliebene direkt ausgezahlt. </p><h3>4. Mindest- und Höchstgrenzen </h3><p>Soweit eine Entgeltumwandlung durchgeführt wird, muss der Arbeitnehmer gem. § 1a Abs. 1 Satz 4 BetrAVG einen Betrag in Höhe von mindestens 1/160 der Bezugsgröße nach § 18 SGB IV jährlich umwandeln (in 2019: 233,63 EUR jährlich bzw. 19,47 EUR monatlich). Die Förderung durch steuerfreie Beiträge richtet sich nach § 3 Nr. 63 EStG. Hierbei haben arbeitgeberfinanzierte Beiträge Vorrang vor Beiträgen, die durch Entgeltumwandlung des Arbeitnehmers finanziert werden. Zusätzlich können unter den jeweiligen Voraussetzungen des § 100 und der §§ 10a, 82 Abs. 2 EStG die steuerlichen Begünstigungen (z. B. Steuerfreistellung) genutzt werden. Beiträge, die nach § 3 Nr. 63 EStG steuerfrei gestellt werden, sind bis zur Höhe von 4 % der BBG in der Rentenversicherung der Arbeiter und Angestellten nicht dem sozialversicherungspflichtigen Arbeitsentgelt zugeordnet (§ 1 Abs. 1 Nr. 9 SvEV). Die Leistungen der Direktversicherung sind steuer- und ggf. sozialabgabenpflichtig. </p><h3>5. Vorzeitiges Ausscheiden </h3><p>Scheidet der Arbeitnehmer vor Eintritt des Versorgungsfalles mit unverfallbaren Ansprüchen nach D.1. dieser Versorgungsordnung aus den Diensten des Arbeitgebers aus, so bleibt sein unverfallbarer Anspruch nach D.1. dieser Versorgungsordnung erhalten. Der Arbeitgeber beantragt innerhalb der gesetzlichen Fristen die Übertragung der Versicherungsnehmereigenschaft auf den ausgetretenen Arbeitnehmer und informiert diesen darüber (versicherungsvertragliches Verfahren). Die Versorgung kann entweder privat oder über einen neuen Arbeitgeber mit weiteren Beiträgen fortgeführt werden. Der Arbeitnehmer kann auch eine Übertragung nach § 4 Abs. 3 BetrAVG (Portabilität) verlangen. Wurde bei Ausscheiden das versicherungsvertragliche Verfahren durchgeführt, so kann er vom Versorgungsträger der Direktversicherung eine Übertragung innerhalb eines Jahres nach Beendigung des Arbeitsverhältnisses verlangen. </p><h3>6. Anpassung laufender Leistungen </h3><p>Bei der beitragsorientierten Leistungszusage werden sämtliche ab Rentenbeginn auf den Versicherungsvertrag entfallenden Überschussanteile zur Erhöhung der Versorgungsleistung verwendet. Eine zusätzliche Erhöhung durch den Arbeitgeber ist ausgeschlossen (§ 16 Abs. 3 Nr. 2 BetrAVG). </p><h2>C. Versorgungsbeitrag</h2><p>Der Versorgungsbeitrag setzt sich aus den folgenden Komponenten zusammen. </p><h3>1. Entgeltumwandlung </h3><p>Im Rahmen der Entgeltumwandlung kann jeder Arbeitnehmer entsprechend seiner wirtschaftlichen Leistungsfähigkeit Beträge aus seinem monatlichen Bruttoverdienst in den Grenzen des § 3 Nr. 63 EStG umwandeln. Dabei darf der Entgeltumwandlungsbetrag zusammen mit den Arbeitgeberleistungen zur betrieblichen Altersversorgung gemäß C.2. den Höchstbetrag von 8 % der Beitragsbemessungsgrenze der allgemeinen Rentenversicherung (West) nicht überschreiten. Die Höhe des Umwandlungsbetrages wird in einer separaten Entgeltumwandlungsvereinbarung festgelegt. Der vereinbarte Betrag kann nur jährlich, erstmalig nach Ablauf eines vollen Jahres ab Versorgungsbeginn, verändert werden. Der Antrag auf Entgeltumwandlung muss einen Monat vor Entgeltumwandlungsbeginn schriftlich bei einer geeigneten Stelle des Arbeitgebers vorliegen. Beispiel: Entgeltumwandlung aus dem Oktoberentgelt; Vereinbarung muss im September dem Arbeitgeber vorliegen. Soweit das Entgelt Bemessungsgrundlage für sonstige Vergütungen ist, wird der Arbeitnehmer, der sich für die Entgeltumwandlung entschieden hat, so gestellt, als ob eine Umwandlung nicht erfolgt wäre. Diese Regelung gilt auch für den Fall, dass Gehaltserhöhungen einheitlich oder nach Gruppen gestaffelt in bestimmter Relation zu den vorherigen Bezügen festgesetzt werden. </p><h3>2. Arbeitgeberzuschuss </h3><p>Macht der Arbeitnehmer von der Möglichkeit der Entgeltumwandlung Gebrauch, leistet der Arbeitgeber für die Dauer der Entgeltumwandlung einen Zuschuss in Höhe von 15,0 % des umgewandelten Betrages. Der Zuschuss wird für ab dem 01.01.2019 geschlossene Entgeltumwandlungsvereinbarungen sofort gewährt; für bis einschließlich 31.12.2018 geschlossene Entgeltumwandlungsvereinbarungen gewährt der Arbeitgeber den o. g. Zuschuss frühestens ab Inkrafttreten dieser Versorgungsordnung. Dieser Arbeitgeberzuschuss wird nur für Entgeltumwandlungsbeiträge gewährt, die im Rahmen von § 3 Nr. 63 EStG geleistet werden. Darüber liegende Entgeltumwandlungsbeträge werden von der Bezuschussung nicht umfasst. Erhält der Arbeitnehmer bereits vor Inkrafttreten dieser Versorgungsordnung zu einer Entgeltumwandlung einen freiwilligen Arbeitgeberzuschuss wird dieser auf den o. g. Zuschuss angerechnet, sofern es sich um den gleichen Durchführungsweg handelt. Der o. g. Zuschuss resultiert insbesondere aus der Sozialversicherungsersparnis, die der Arbeitgeber durch die vollständige oder anteilige Sozialversicherungsfreiheit von Entgeltumwandlungsbeträgen erzielt. Der gesetzlich verpflichtende Arbeitgeberzuschuss gemäß § 1a Abs. 1a BetrAVG wird auf den o. g. Zuschuss, der im Rahmen des versicherungsförmigen Durchführungswegs vom Arbeitgeber geleistet wird, angerechnet. Für entgeltfreie Beschäftigungszeiten gelten die Regelungen nach D.2. dieser Versorgungsordnung. Eine unmittelbare Auszahlung des Arbeitgeberzuschusses zur Entgeltumwandlung ist nicht zulässig. </p><h2>D. Allgemeiner Teil </h2><h3>1. Unverfallbarkeit bei vorzeitigem Ausscheiden </h3><h3>a. Unverfallbarkeit dem Grunde nach </h3><p>Endet das Arbeitsverhältnis vor Eintritt des Versorgungsfalles, so erwirbt der Arbeitnehmer entsprechend den Vorschriften des Betriebsrentengesetzes eine unverfallbare Anwartschaft auf Versorgungsleistungen, sofern die hierfür erforderlichen Fristen erfüllt sind. Der Anspruch auf Anwartschaft aus Entgeltumwandlung ist ab Beginn unverfallbar. Für die Anwartschaft aus dem Arbeitgeberzuschuss gem. C.2. dieser Versorgungsordnung gilt ebenfalls die sofortige Unverfallbarkeit. </p><h3>b. Unverfallbarkeit der Höhe nach </h3><p>Scheidet der Arbeitnehmer vor Erreichen des Versorgungsfalles aus dem Unternehmen aus, gilt bei der Zusageform der beitragsorientierten Leistungszusage Folgendes: Bei vorzeitigem Ausscheiden des Arbeitnehmers aus den Diensten des Arbeitgebers bleibt sein Anspruch aus der Direktversicherung gem. § 2 Abs. 2 BetrAVG erhalten. </p><h3>2. Entgeltfreie Zeiten </h3><p>Der Versorgungsbeitrag wird vom Arbeitgeber nur solange und soweit in der vereinbarten Höhe an den Versorgungsträger gezahlt, wie er zur Zahlung der Entgelte aus dem Arbeitsverhältnis verpflichtet gewesen ist. Besteht das Beschäftigungsverhältnis ohne Entgeltanspruch fort (z. B. längere Krankheit, Elternzeit, unbezahlter Urlaub), entrichtet der Arbeitgeber keinen Versorgungsbeitrag mehr an den Versorgungsträger. Dadurch reduziert sich der Leistungsanspruch des Arbeitnehmers. Der Arbeitnehmer hat jedoch innerhalb des in § 3 Nr. 63 EStG beschriebenen Durchführungswegs Direktversicherung die Möglichkeit, den Versorgungsbeitrag aus eigenen Mitteln weiter zu zahlen. </p><h3>3. Versorgungsausgleich</h3><p>Erfolgt nach einer Scheidung oder Auflösung einer eingetragenen Lebenspartnerschaft ein Urteil über den Versorgungsausgleich, so werden die Versorgungsansprüche real geteilt. Die weiteren Regelungen zum Versorgungsausgleich richten sich nach der jeweils gültigen Teilungsordnung des betreffenden Versorgungsträgers. Haftungsausschluss: Bitte beachten Sie, dass dieser Text ein unverbindliches Muster darstellt und im konkreten Einzelfall gegebenenfalls ergänzt und an die individuellen Gegebenheiten des Betriebs angepasst werden muss. Es kann in verschiedenen Fällen nicht geeignet sein, den gewünschten Zweck zu erzielen und ersetzt nicht die anwaltliche Leistung. Wir haben das Muster nach bestem Wissen erstellt. Eine Haftung für die Inhalte wird nicht übernommen. Das Musterschreiben erhebt keinen Anspruch auf Richtigkeit und Aktualität; es dient lediglich als Anregung und Hilfe für Formulierungen.  </p><h3>4. Mitwirkungspflichten des Arbeitnehmers </h3><p>Der Arbeitnehmer ist im Rahmen der Antragstellung auf betriebliche Altersversorgung verpflichtet, beim Zustandekommen des Versorgungsvertrages mitzuwirken. Insbesondere muss er dem Abschluss eines Versicherungsvertrages auf sein Leben zustimmen. Unterlässt er dies, so entsteht kein Anspruch auf die Versorgungsleistungen. Ansprüche aus der betrieblichen Altersversorgung dürfen vom Arbeitnehmer weder abgetreten, verpfändet noch beliehen werden. Kommt der Arbeitnehmer seinen Mitwirkungspflichten nicht nach, so kann es zu einem Ruhen des Anspruchs kommen. Dies ist insbesondere der Fall, wenn der Arbeitnehmer bei Fälligkeit der Leistungen die zur Auszahlung der Leistungen notwendigen Unterlagen nicht beibringt. Eine Nachzahlung der Leistungen erfolgt - unter Berücksichtigung von Verjährungsfristen - erst nach Erfüllung der Mitwirkungspflichten. </p><h3>5. Beratung und Versicherungsauswahl</h3><p>Die Probonio GmbH ist mit der Beratung und Betreuung zur betrieblichen Altersversorgung beauftragt. Ziel ist es, den Arbeitnehmern einen transparenten Vergleich verschiedener Versicherungsanbieter anzubieten und eine umfassende digitale Beratung zu gewährleisten. Über die Benefit-App von Probonio kann der Arbeitnehmer einen Beratungstermin vereinbaren. Auch nach dem Abschluss einer Versicherung bleibt Probonio als Ansprechpartner zur Verfügung. Die bAV Berater von Probonio sind sowohl über die Support-Hotline als auch per E-Mail unter <a href="mailto:support@probonio.de" target="_blank">support@probonio.de</a> erreichbar.</p><h3>6. Salvatorische Klausel und Schlusserklärung </h3><p>Ergänzend finden die Regelungen des Betriebsrentengesetzes (BetrAVG) Anwendung. Sollten eine oder mehrere Bestimmungen dieser Versorgungsordnung unwirksam sein oder werden, bleiben die übrigen Bestimmungen dieser Versorgungsordnung gleichwohl wirksam. </p><h3>7. Laufzeit </h3><p>Diese Versorgungsordnung tritt mit ihrer Unterzeichnung in Kraft. Diese Versorgungsordnung ist für unbestimmte Dauer gültig und mit einer Frist von 3 Monaten kündbar. Die Kündigung bedarf der Schriftform. Der Arbeitgeber macht die Kündigung an geeigneter Stelle im Unternehmen bekannt oder informiert die Arbeitnehmer persönlich über die erfolgte Kündigung. Die Nachwirkung dieser Versorgungsordnung wird ausgeschlossen.</p>`,
      showToEmployees: 'Mitarbeitern Versorgungsordnung anzeigen',
      integration: 'Integration Ihrer Versorgungsordnung',
      saveTooltip: 'Bitte ändern Sie Ihre Versorgungsordnungseinstellungen, um eine neue Version zu speichern',
      guide: {
        title: 'Versorgungsordnung der Betrieblichen Altersvorsorge',
        info: '<p>Eine <strong>Versorgungsordnung</strong> in der Betrieblichen Altersversorgung ist ein entscheidendes Instrument zur Altersvorsorgeregelung in Unternehmen. Sie gewährleistet Transparenz und Rechtssicherheit für Arbeitgeber und Arbeitnehmer, indem sie klare Bedingungen für die Vergabe von betrieblichen Altersrenten definiert, einschließlich Anspruchsvoraussetzungen, Beitragshöhen und Berechnungsmethoden für Rentenleistungen sowie weitere Leistungen wie Hinterbliebenen- und Invalidenrenten. Diese <strong>Versorgungsordnung</strong> bildet eine Grundlage für die Altersvorsorge und ermöglicht eine individuelle Anpassung an die betrieblichen Anforderungen.</p>',
        section1Title: 'So integrieren Sie ihre individuelle Versorgungsordnung',
        section1Text: `
        <ol>
          <li><strong>Passen Sie die Mustervorlage</strong> mithilfe des Editors nach Ihren Anforderungen an.</li>
          <li><strong>Speichern Sie Ihre Vorlage</strong> und bearbeiten Sie diese zu jeder Zeit.</li>
          <li><strong>Aktivieren Sie "Mitarbeitern Versorgungsordnung anzeigen"</strong>, um diese in der Mitarbeiter-App zu veröffentlichen.</li>
        </ol>
`,
      },
    },
    documentType: {
      POLICY: 'Police',
      DEFERRED_COMPENSATION: 'Entgeltumwandlung',
      CHANGE_REQUEST: 'Änderungsantrag',
      REQUEST: 'Antrag',
      OTHER: 'Anderes',
    },
    contractsTable: {
      header: {
        status: 'Status',
        name: 'Mitarbeiter',
        startDate: 'Vertragsbeginn',
        totalPremium: 'Gesamtprämie',
        insuranceName: 'Versicherungsname',
        contractNumber: 'Vertragsnummer',
      },
      noResults: 'Keine BAV-Verträge vorhanden',
    },
  },
  bikeModule: {
    contractActive: 'Vertrag abgeschlossen',
    contractActiveDate: 'Vertragsbeginn am {{startDate, date}}',
    contractIntro:
      'Die Daten des abgeschlossenen Firmenrad-Vertrags werden unten angezeigt. Für Änderungen laden Sie bitte die Vertragsdaten auf der Übersichtsseite des Firmenrad-Benefits erneut hoch.',
    contractAppInfo: 'Die Daten sind für den Mitarbeiter in der Probonio-App einsehbar.',
    importTab: 'Import',
    importButton: 'Vertragsdaten importieren',
    importButtonHint: 'Importieren Sie hier regelmäßig die Vertragsdaten aus Ihrem Anbieterportal.',
    contractFields: {
      contractNumber: 'Auftragsnummer',
      contractDate: 'Auftragsdatum',
      status: 'Status',
      leasingStartDate: 'Leasingbeginn',
      leasingEndDate: 'Leasingende',
      priceNet: 'Fahrradpreis (netto)',
      monthlyServiceRate: 'Servicerate',
      monthlyInsuranceRate: 'Versicherungsrate',
      employerGrant: 'Arbeitgeberzuschuss',
      bikeSupplier: 'Fahrradhändler',
      bikeProduct: 'Produkt',
      bikeType: 'Typ',
    },
    section: {
      contract: 'Vertragsdaten',
      leasing: 'Leasing',
      bike: 'Fahrraddaten',
      benefits: 'Ihre Leistungen',
    },
    contractsTable: {
      header: {
        status: 'Status',
        name: 'Mitarbeiter',
        leasingStartDate: 'Leasingbeginn',
        leasingEndDate: 'Leasingende',
        contractNumber: 'Vertragsnummer',
      },
      noResults: 'Keine Firmenrad-Verträge vorhanden',
      deleteButton: 'Vertrag löschen',
      confirmDelete: 'Sind Sie sicher, dass Sie den ausgewählten Vertrag löschen möchten?',
      deleteContractSuccess: 'Vertrag wurde gelöscht',
    },
    importDialog: {
      title: 'Firmenrad Vertragsdaten-Import',
      dataPrivacyAlert:
        'Achtung! Sie sind dabei, alle Datensätze mit personenbezogenen Daten Ihrer Arbeitnehmer zu importieren. Bitte achten Sie darauf, dass alle Daten korrekt sind, bevor Sie fortfahren.',
      templateInfo:
        'Laden Sie die Import-Vorlage herunter und befüllen Sie sie mit den Daten Ihrer Firmenrad-Verträge. Das Export-Format des JobRad Management Portals wird auch direkt unterstützt.',
      downloadTemplate: 'Vorlage herunterladen',
      state: {
        initial: 'Wählen Sie die ausgefüllte Vorlage, um mit dem Import zu beginnen',
        ready: '{{count}} Datensätze bereit zum Import',
        success: '{{count}} Datensätze erfolgreich importiert',
        error: 'Import fehlgeschlagen aufgrund der Zeilennummer: {{lineNumber}}',
      },
      conflictError: `Mitarbeiter mit Personalnummer {{employeeNumber}} nicht gefunden`,
    },
  },
  dashboardModule: {
    employeesPanel: {
      title: 'Mitarbeiter',
      createdAt: 'hinzugefügt am {{date,date}}',
      recentCreatedAt: 'Zuletzt hinzugefügt',
      totalCount: 'Gesamtanzahl: {{count}}',
      goToEmployeeList: 'Zur Mitarbeiterliste',
      activeEmployeesCount: '{{count}} Mitarbeiter',
      activeStatusText: 'aktiv',
      legendLabel: 'Mitarbeiter',
    },
    benefitsPanel: {
      title: 'Benefits',
      disclaimer:
        '<p>Einsparung in den letzten 6 Monaten ggü. Ausschüttung des selben Nettobetrages via regulärer Lohnzahlungen.</p><p>Die berechneten Werte hängen immer von Faktoren wie der Steuerklasse, dem Familienstand oder dem Bundesland ab. Die Rechnung dient lediglich als Leitlinie und stellt keine Steuer- oder Rechtsberatung dar.</p> <i>Berechnungsgrundlage: Jahr 2023; 4.000€ Bruttogehalt; Steuerklasse I; keine Kinder; KV 14,6%; Zusatzbeitrag 1,1%; KiSt 8%; Bundesland Bayern</i>',
      pauseCarouselTooltip: 'Slideshow pausieren',
      resumeCarouselTooltip: 'Slideshow fortsetzen',
      totalSavings: 'Eingespart: <0>{{amount, euro}}</0> / 6 Monate',
      totalGrantTitle: 'Ausschüttungen',
      totalGrant: 'Ausgeschüttet: <0>{{amount, euro}}</0> / 6 Monate',
      benefitGrant: '<0>{{amount, euro}}</0> ausgeschüttet',
      benefitSavings: '<0>{{amount, euro}}</0> gespart',
      upsellingRate: '<0>{{value,percent}}</0> unserer Kunden nutzen diesen Benefit.',
      bookNow: 'Jetzt buchen',
      benefitContent: {
        BAV: '<0>{{count}}</0> aktive Verträge',
        BAV_one: '<0>{{count}}</0> aktiver Vertrag',
        BIKE: '<0>{{count}}</0> aktive Verträge',
        BIKE_one: '<0>{{count}}</0> aktiver Vertrag',
        NEWS: '<0>{{count}}</0> aktive Nachrichten',
        NEWS_one: '<0>{{count}}</0> aktive Nachricht',
      },
      chart: {
        scaleFormat: '{{value, euro-float}}',
        tooltipItem: '{{label}}: {{value, euro-float}}',
        tooltipTotal: 'Gesamt: {{value, euro-float}}',
        emptyTitle: 'Keine Daten',
        emptyText:
          'Benefits im Überblick zeigt Ihre Ausschüttungen über die letzten Monate an. Nutzen Sie unsere Benefits um sich Ihre Statistik ansehen zu können.',
      },
    },
  },
  equivalenceCalculator: {
    title: 'Gehaltskonzept',
    subtitle: 'Auswertung',
    inputFields: {
      title: 'Bruttoäquivalenz-Rechner',
      fixed: 'Fixiert',
      standard: 'Standard',
      withCompany: 'Mit Probonio',
      grossPerYear: 'Bruttogehalt pro Jahr',
      netPerYear: 'Nettogehalt pro Jahr',
      tenantCostPerYear: 'Arbeitgeberkosten pro Jahr',
      grossCalculated: 'Bruttoäquivalenz: {{value}}€',
      netCalculatedMore: 'Arbeitnehmer erhält: {{value}}€ mehr',
      netCalculatedSame: 'Nettogehalt bleibt gleich',
      tenantCalculatedMore: 'Arbeitgeber spart {{value}}€ Kosten',
      tenantCalculatedSame: 'Arbeitgeber spart keine Kosten',
      calculateButton: 'Berechnen',
    },
    graph: {
      title: 'Verteilung',
      NET_INCOME: 'Nettoeinkommen',
      AGE_INSURANCE: 'Arbeitslosenversicherung',
      CARE_INSURANCE: 'Pflegeversicherung',
      RENT_INSURANCE: 'Rentenversicherung',
      SICK_INSURANCE: 'Krankenversicherung',
      WAGE_TAX: 'Lohnsteuer',
      SOLIDARITY_TAX: 'Solidaritätszuschlag',
      BENEFITS: 'Benefits',
    },
    personalConfiguration: {
      title: 'Mitarbeiter-Konfiguration',
      taxClass: 'Steuerklasse',
      insuranceType: {
        title: 'Krankenkasse',
        lawful: 'Gesetzlich',
        private: 'Privat',
      },
      privateInsuranceAmount: 'Monatlicher Beitrag',
      children: 'Kinder',
      church: 'Kirche',
    },
    benefitConfiguration: {
      title: 'Benefit-Konfiguration',
      lunchPerMonth: 'Steuerfreier Essenszuschuss Anzahl im Monat',
      voucherPerMonth: 'Sachbezug pro Monat',
      giftsPerYear: 'Aufmerksamkeiten (je 60€) pro Jahr',
      mobilityPerMonth: 'Steuerfreie Mobilität pro Monat',
      internetPerMonth: 'Internetpauschale pro Monat',
      recreationPerMonth: 'Erholungsbeihilfe bzgl. pro zusätzliches Kind',
    },
    warningToast: 'Berechnung zurzeit nicht verfügbar',
    infoTextFull: `Mithilfe des Bruttoäquivalenz-Rechners können Sie eine grobe Vorstellung über mögliche Gehälter und Steuerabzüge erhalten.
    <br><br>
    Bei der Nutzung gibt es einiges zu beachten: 
      <ul>
      <li>Der Gehaltsrechner dient ausschließlich dazu, dem Benutzer eine ungefähre Vorstellung über mögliche Gehälter und Steuerabzüge zu geben</li>
      <li>Bitte beachten Sie, dass die berechneten Werte keine individuelle Steuerberatung darstellen. Jede steuerliche Situation ist einzigartig und erfordert eine individuelle Analyse durch einen qualifizierten Steuerberater</li>
      <li>Die Verwendung des Gehaltsrechners erfolgt auf eigenes Risiko. Wir übernehmen keine Verantwortung für etwaige Schäden oder Verluste, die durch die Verwendung der berechneten Informationen entstehen.</li>
      </ul>`,
  },
  benefitInfoText: {
    videosTitle: 'Hilfreiche Ressourcen',
    videosMoreTitle: 'Mehr zu',
    videosDescription:
      'Um Sie und Ihre Mitarbeiter bei der Einrichtung und Nutzung optimal zu unterstützen, haben wir für Sie hilfreiche Video-Tutorials vorbereitet.',
    managerGeneral: 'Arbeitgeber-Portal Allgemein',
    appGeneral: 'App Allgemein',
  },
  legalTerms: {
    title: 'Rechtliche Hinweise',
    longTitle: 'Rechtliche Hinweise und regulatorische Dokumente',
    guardTitle: 'Herzlich willkommen bei Probonio!',
    guardSubtitle: 'Um unsere Services nutzen zu können, <br />benötigen wir Ihre Bestätigung der Probonio Rahmenbedingungen.',
    version: 'Version {{version}}',
    activeSince: 'Aktiv seit $t(common:date)',
    actions: {
      accept: 'Akzeptieren',
      skip: 'Vorerst Überspringen',
      viewDocument: 'Dokument anzeigen',
    },
    labels: {
      checkTOS:
        'Mit der Nutzung der Services akzeptiere ich die in den <0>AGBs</0> aufgeführten Rahmenbedingungen und schließe als Verantwortlicher mit dem Anbieter einen <1>Auftragsverarbeitungsvertrag AVV</1> gemäß Art. 28 DSGVO.',
      checkPrivacy: 'In unserer <0>Datenschutzerklärung</0> erfahren Sie, wie wir Ihre Daten verarbeiten.',
      additionalDocuments: 'Weitere Dokumente',
    },
    types: {
      PRIVACY: 'Datenschutz',
      TENANT_TERMS: 'Allgemeine Geschäftsbedingungen und Auftragsverarbeitungsvertrag',
      DATA_PROCESSING_AGREEMENT: 'Auftragsverarbeitungsvertrag (AVV)',
      TECHNICAL_ORGANIZATIONAL_MEASURES: 'Technische und organisatorische Maßnahmen (TOM)',
      SERVICE_DESCRIPTION: 'Leistungsbeschreibung',
    },
  },
  tenantHierarchy: {
    employeesCount: '{{count}} Mitarbeiter',
    benefitsCount: '{{count}} Benefits',
    activeTenant: 'Ausgewählt',
  },
  userNotFoundPage: {
    title: 'Kein aktiver Account gefunden',
    details:
      'Zu Ihren Login-Daten wurde kein aktiver Account gefunden. Bitte schließen Sie zuerst die Registrierung ab, um Probonio zu nutzen. <p>Sie möchten Probonio-Kunde werden? Registrieren Sie sich auf <0>{{targetDomain}}</0> oder kontaktieren Sie uns für weitere Informationen.</p>',
    register: 'Registrierung abschließen',
    logout: 'Logout',
  },
};

export default translation;
